{
  "schemaVersion": 4,
  "catalogVersion": "2026.08.21.1",
  "generatedAt": "2026-08-21T23:00:00+09:00",
  "sourceCounts": {
    "bdg": 109,
    "wt": 104,
    "kr": 51
  },
  "observations": [
    {
      "observationId": "bdg-001",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Kings Cup",
      "canonicalId": "kings-cup",
      "family": "카드",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "원으로 카드를 둔다",
      "action": "뽑은 카드의 안전 미션을 수행한다",
      "end": "덱이 끝나면 팀 점수를 합친다.",
      "safeCore": "원으로 카드를 둔다 → 뽑은 카드의 안전 미션을 수행한다 → 덱이 끝나면 팀 점수를 합친다."
    },
    {
      "observationId": "bdg-002",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Ride the Bus",
      "canonicalId": "ride-the-bus",
      "family": "카드추리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "카드의 색/높낮이/무늬를 예측한다",
      "action": "맞히면 전진한다",
      "end": "먼저 노선을 끝내면 승리한다.",
      "safeCore": "카드의 색/높낮이/무늬를 예측한다 → 맞히면 전진한다 → 먼저 노선을 끝내면 승리한다."
    },
    {
      "observationId": "bdg-003",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Circle of Death",
      "canonicalId": "kings-cup",
      "family": "카드",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "Kings Cup의 별칭 관찰",
      "action": "같은 안전 카드 규칙을 쓴다",
      "end": "canonical 결과로 합친다.",
      "safeCore": "Kings Cup의 별칭 관찰 → 같은 안전 카드 규칙을 쓴다 → canonical 결과로 합친다."
    },
    {
      "observationId": "bdg-004",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Screw the Dealer",
      "canonicalId": "screw-the-dealer",
      "family": "카드추리",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "딜러 카드 숫자를 추리한다",
      "action": "힌트로 범위를 줄인다",
      "end": "맞힌 횟수로 딜러가 교대한다.",
      "safeCore": "딜러 카드 숫자를 추리한다 → 힌트로 범위를 줄인다 → 맞힌 횟수로 딜러가 교대한다."
    },
    {
      "observationId": "bdg-005",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Horse Race",
      "canonicalId": "horse-race-cards",
      "family": "카드운",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "네 무늬를 말로 선택한다",
      "action": "공개 카드에 따라 트랙을 전진한다",
      "end": "먼저 결승에 온 무늬의 팀이 이긴다.",
      "safeCore": "네 무늬를 말로 선택한다 → 공개 카드에 따라 트랙을 전진한다 → 먼저 결승에 온 무늬의 팀이 이긴다."
    },
    {
      "observationId": "bdg-006",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Higher or Lower",
      "canonicalId": "higher-lower",
      "family": "카드추리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "setup": "다음 카드가 높을지 낮을지 고른다",
      "action": "카드를 공개한다",
      "end": "연속 정답 점수를 겨룬다.",
      "safeCore": "다음 카드가 높을지 낮을지 고른다 → 카드를 공개한다 → 연속 정답 점수를 겨룬다."
    },
    {
      "observationId": "bdg-007",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Presidents",
      "canonicalId": "presidents",
      "family": "카드전략",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "손패를 나눈다",
      "action": "이전보다 강한 조합을 내거나 패스한다",
      "end": "먼저 손을 비우면 승리한다.",
      "safeCore": "손패를 나눈다 → 이전보다 강한 조합을 내거나 패스한다 → 먼저 손을 비우면 승리한다."
    },
    {
      "observationId": "bdg-008",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Drunk Uno",
      "canonicalId": "uno-house-variant",
      "family": "카드전략",
      "playersMin": 2,
      "props": [
        "상용 카드"
      ],
      "playability": "reference_only",
      "setup": "상용 카드게임의 음주 변형 관찰",
      "action": "일반 규칙과 안전 점수 변형만 안내한다",
      "end": "공식 게임 소유를 요구해 실행 덱은 제공하지 않는다.",
      "safeCore": "상용 카드게임의 음주 변형 관찰 → 일반 규칙과 안전 점수 변형만 안내한다 → 공식 게임 소유를 요구해 실행 덱은 제공하지 않는다."
    },
    {
      "observationId": "bdg-009",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Irish Snap",
      "canonicalId": "irish-snap",
      "family": "카드반응",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "차례대로 카드를 뒤집으며 순서를 말한다",
      "action": "일치 시 중앙 신호를 먼저 누른다",
      "end": "카드가 적은 사람이 이긴다.",
      "safeCore": "차례대로 카드를 뒤집으며 순서를 말한다 → 일치 시 중앙 신호를 먼저 누른다 → 카드가 적은 사람이 이긴다."
    },
    {
      "observationId": "bdg-010",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Irish Poker",
      "canonicalId": "irish-poker",
      "family": "카드추리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "네 장을 뒤집지 않고 놓는다",
      "action": "색/높낮이/안팎을 차례로 추리한다",
      "end": "정답 점수를 합친다.",
      "safeCore": "네 장을 뒤집지 않고 놓는다 → 색/높낮이/안팎을 차례로 추리한다 → 정답 점수를 합친다."
    },
    {
      "observationId": "bdg-011",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Indian Poker",
      "canonicalId": "indian-poker",
      "family": "카드심리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "setup": "자기만 못 보는 카드를 이마 앞에 든다",
      "action": "상대 행동을 보고 계속/포기한다",
      "end": "높은 카드가 점수를 얻는다.",
      "safeCore": "자기만 못 보는 카드를 이마 앞에 든다 → 상대 행동을 보고 계속/포기한다 → 높은 카드가 점수를 얻는다."
    },
    {
      "observationId": "bdg-012",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Bullshit",
      "canonicalId": "bullshit-cards",
      "family": "카드블러핑",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "setup": "선언한 숫자의 카드를 뒤집어 낸다",
      "action": "의심하면 검증한다",
      "end": "먼저 손을 비우면 승리한다.",
      "safeCore": "선언한 숫자의 카드를 뒤집어 낸다 → 의심하면 검증한다 → 먼저 손을 비우면 승리한다."
    },
    {
      "observationId": "bdg-013",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Pyramid",
      "canonicalId": "pyramid-cards",
      "family": "카드기억",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "손패와 피라미드 카드를 배치한다",
      "action": "공개 숫자와 같은 손패를 찾아 주장한다",
      "end": "검증된 매치로 점수를 얻는다.",
      "safeCore": "손패와 피라미드 카드를 배치한다 → 공개 숫자와 같은 손패를 찾아 주장한다 → 검증된 매치로 점수를 얻는다."
    },
    {
      "observationId": "bdg-014",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Give and Take",
      "canonicalId": "give-take-cards",
      "family": "카드운",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "개인 카드와 두 줄을 배치한다",
      "action": "같은 숫자가 나오면 안전 미션을 주거나 받는다",
      "end": "줄이 끝나면 종료한다.",
      "safeCore": "개인 카드와 두 줄을 배치한다 → 같은 숫자가 나오면 안전 미션을 주거나 받는다 → 줄이 끝나면 종료한다."
    },
    {
      "observationId": "bdg-015",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Screw Your Neighbor",
      "canonicalId": "screw-your-neighbor",
      "family": "카드교환",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "한 장씩 받고 낮은 카드를 피한다",
      "action": "옆 사람과 교환하거나 유지한다",
      "end": "라운드 최저 카드가 토큰을 잃는다.",
      "safeCore": "한 장씩 받고 낮은 카드를 피한다 → 옆 사람과 교환하거나 유지한다 → 라운드 최저 카드가 토큰을 잃는다."
    },
    {
      "observationId": "bdg-016",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Electricity",
      "canonicalId": "electricity-cards",
      "family": "팀반응",
      "playersMin": 4,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "두 팀이 손 신호 사슬을 만든다",
      "action": "목표 카드가 나오면 신호를 전달한다",
      "end": "끝 사람이 먼저 목표를 잡으면 점수다.",
      "safeCore": "두 팀이 손 신호 사슬을 만든다 → 목표 카드가 나오면 신호를 전달한다 → 끝 사람이 먼저 목표를 잡으면 점수다."
    },
    {
      "observationId": "bdg-017",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Three Man",
      "canonicalId": "three-man",
      "family": "주사위",
      "playersMin": 3,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "setup": "역할과 합계 규칙을 정한다",
      "action": "두 주사위를 굴려 안전 액션을 적용한다",
      "end": "정해진 라운드 뒤 점수를 비교한다.",
      "safeCore": "역할과 합계 규칙을 정한다 → 두 주사위를 굴려 안전 액션을 적용한다 → 정해진 라운드 뒤 점수를 비교한다."
    },
    {
      "observationId": "bdg-018",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "7-11-Doubles",
      "canonicalId": "seven-eleven-doubles",
      "family": "주사위",
      "playersMin": 3,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "setup": "7·11·더블을 목표로 굴린다",
      "action": "성공 시 다음 플레이어/미션을 고른다",
      "end": "토큰을 먼저 모으면 이긴다.",
      "safeCore": "7·11·더블을 목표로 굴린다 → 성공 시 다음 플레이어/미션을 고른다 → 토큰을 먼저 모으면 이긴다."
    },
    {
      "observationId": "bdg-019",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Ship, Captain & Crew",
      "canonicalId": "ship-captain-crew",
      "family": "주사위",
      "playersMin": 2,
      "props": [
        "주사위5"
      ],
      "playability": "playable_safe",
      "setup": "6·5·4를 순서대로 확보한다",
      "action": "남은 주사위 합을 화물 점수로 삼는다",
      "end": "최고 화물이 이긴다.",
      "safeCore": "6·5·4를 순서대로 확보한다 → 남은 주사위 합을 화물 점수로 삼는다 → 최고 화물이 이긴다."
    },
    {
      "observationId": "bdg-020",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Liar's Dice",
      "canonicalId": "liars-dice",
      "family": "주사위블러핑",
      "playersMin": 2,
      "props": [
        "주사위",
        "컵"
      ],
      "playability": "playable_safe",
      "setup": "각자 주사위를 숨긴다",
      "action": "전체 수량을 추정해 입찰한다",
      "end": "도전 후 맞은 쪽이 점수를 얻는다.",
      "safeCore": "각자 주사위를 숨긴다 → 전체 수량을 추정해 입찰한다 → 도전 후 맞은 쪽이 점수를 얻는다."
    },
    {
      "observationId": "bdg-021",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Mexicali",
      "canonicalId": "mexicali",
      "family": "주사위블러핑",
      "playersMin": 3,
      "props": [
        "주사위",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "두 주사위를 숨겨 굴린다",
      "action": "이전보다 높은 값이라고 선언한다",
      "end": "거짓 도전 결과로 토큰을 이동한다.",
      "safeCore": "두 주사위를 숨겨 굴린다 → 이전보다 높은 값이라고 선언한다 → 거짓 도전 결과로 토큰을 이동한다."
    },
    {
      "observationId": "bdg-022",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Sixes",
      "canonicalId": "sixes-dice",
      "family": "주사위운",
      "playersMin": 2,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "setup": "목표 숫자 6을 정한다",
      "action": "정해진 횟수 굴려 조합을 만든다",
      "end": "목표 조합 점수를 비교한다.",
      "safeCore": "목표 숫자 6을 정한다 → 정해진 횟수 굴려 조합을 만든다 → 목표 조합 점수를 비교한다."
    },
    {
      "observationId": "bdg-023",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Snake Eyes",
      "canonicalId": "snake-eyes",
      "family": "주사위운",
      "playersMin": 2,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "setup": "주사위 합을 예측한다",
      "action": "더블 1이면 보너스 이벤트를 연다",
      "end": "라운드 점수를 합친다.",
      "safeCore": "주사위 합을 예측한다 → 더블 1이면 보너스 이벤트를 연다 → 라운드 점수를 합친다."
    },
    {
      "observationId": "bdg-024",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Die",
      "canonicalId": "table-die",
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "주사위",
        "테이블"
      ],
      "playability": "adapted_safe",
      "setup": "두 팀이 테이블 양쪽에 선다",
      "action": "주사위를 안전 높이로 던져 바운드 목표를 만든다",
      "end": "캐치/착지 점수를 겨룬다.",
      "safeCore": "두 팀이 테이블 양쪽에 선다 → 주사위를 안전 높이로 던져 바운드 목표를 만든다 → 캐치/착지 점수를 겨룬다."
    },
    {
      "observationId": "bdg-025",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Drunk Farkle",
      "canonicalId": "farkle-variant",
      "family": "주사위전략",
      "playersMin": 2,
      "props": [
        "주사위6"
      ],
      "playability": "reference_only",
      "setup": "Farkle 음주 변형 관찰",
      "action": "일반 점수 규칙만 설명한다",
      "end": "상용/지역 규칙표를 복제하지 않는다.",
      "safeCore": "Farkle 음주 변형 관찰 → 일반 점수 규칙만 설명한다 → 상용/지역 규칙표를 복제하지 않는다."
    },
    {
      "observationId": "bdg-026",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Never Have I Ever",
      "canonicalId": "never-have-i-ever",
      "family": "대화",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "안전한 질문만 연다",
      "action": "해당되면 손가락을 접거나 토큰을 놓는다",
      "end": "패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다.",
      "safeCore": "안전한 질문만 연다 → 해당되면 손가락을 접거나 토큰을 놓는다 → 패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다."
    },
    {
      "observationId": "bdg-027",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Most Likely To",
      "canonicalId": "most-likely",
      "family": "지목",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "비모욕 질문을 읽는다",
      "action": "동시에 자신/동의한 선택지를 가리킨다",
      "end": "다수 일치로 팀 점수를 얻는다.",
      "safeCore": "비모욕 질문을 읽는다 → 동시에 자신/동의한 선택지를 가리킨다 → 다수 일치로 팀 점수를 얻는다."
    },
    {
      "observationId": "bdg-028",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Paranoia",
      "canonicalId": "paranoia-question",
      "family": "질문추리",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "질문을 귓속말 대신 화면에 비공개 표시한다",
      "action": "답 대상은 공개하되 질문 공개 여부를 선택한다",
      "end": "누구나 패스 후 다음으로 간다.",
      "safeCore": "질문을 귓속말 대신 화면에 비공개 표시한다 → 답 대상은 공개하되 질문 공개 여부를 선택한다 → 누구나 패스 후 다음으로 간다."
    },
    {
      "observationId": "bdg-029",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Truth or Dare",
      "canonicalId": "truth-or-dare-safe",
      "family": "질문/미션",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "진실/미션/패스를 고른다",
      "action": "사전 검수된 비접촉 문항을 수행한다",
      "end": "완료 토큰만 기록한다.",
      "safeCore": "진실/미션/패스를 고른다 → 사전 검수된 비접촉 문항을 수행한다 → 완료 토큰만 기록한다."
    },
    {
      "observationId": "bdg-030",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Would You Rather",
      "canonicalId": "would-you-rather",
      "family": "양자선택",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "두 선택지를 읽는다",
      "action": "동시에 고른다",
      "end": "소수/다수 이유를 한 문장씩 듣고 다음으로 간다.",
      "safeCore": "두 선택지를 읽는다 → 동시에 고른다 → 소수/다수 이유를 한 문장씩 듣고 다음으로 간다."
    },
    {
      "observationId": "bdg-031",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Medusa",
      "canonicalId": "medusa-look",
      "family": "눈치",
      "playersMin": 4,
      "props": [],
      "playability": "playable_safe",
      "setup": "모두 고개를 숙인다",
      "action": "신호에 한 사람을 본다",
      "end": "서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다.",
      "safeCore": "모두 고개를 숙인다 → 신호에 한 사람을 본다 → 서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다."
    },
    {
      "observationId": "bdg-032",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Buffalo",
      "canonicalId": "buffalo-hand-rule",
      "family": "지속규칙",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "세션 동안 특정 손 사용 금지를 켠다",
      "action": "위반을 발견하면 팀에 알린다",
      "end": "위반자는 안전 미션/점수 -1을 고른다.",
      "safeCore": "세션 동안 특정 손 사용 금지를 켠다 → 위반을 발견하면 팀에 알린다 → 위반자는 안전 미션/점수 -1을 고른다."
    },
    {
      "observationId": "bdg-033",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Cheers to the Governor",
      "canonicalId": "governor-count",
      "family": "기억",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "1부터 목표까지 돌아가며 센다",
      "action": "특정 숫자 규칙을 성공자가 추가한다",
      "end": "목표에 도달하면 모두 성공한다.",
      "safeCore": "1부터 목표까지 돌아가며 센다 → 특정 숫자 규칙을 성공자가 추가한다 → 목표에 도달하면 모두 성공한다."
    },
    {
      "observationId": "bdg-034",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "21",
      "canonicalId": "governor-count",
      "family": "기억",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "Governor count의 숫자 목표 별칭",
      "action": "같은 canonical 규칙을 쓴다",
      "end": "목표 수만 variant로 저장한다.",
      "safeCore": "Governor count의 숫자 목표 별칭 → 같은 canonical 규칙을 쓴다 → 목표 수만 variant로 저장한다."
    },
    {
      "observationId": "bdg-035",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Fingers",
      "canonicalId": "fingers-guess",
      "family": "추리",
      "playersMin": 3,
      "props": [
        "손",
        "컵대체"
      ],
      "playability": "adapted_safe",
      "setup": "모두 손가락 하나를 중앙에 둔다",
      "action": "남을 총 손가락 수를 예측하며 동시에 뺄지 정한다",
      "end": "정확히 맞히면 토큰을 얻는다.",
      "safeCore": "모두 손가락 하나를 중앙에 둔다 → 남을 총 손가락 수를 예측하며 동시에 뺄지 정한다 → 정확히 맞히면 토큰을 얻는다."
    },
    {
      "observationId": "bdg-036",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Spin the Bottle",
      "canonicalId": "spin-selector",
      "family": "룰렛",
      "playersMin": 3,
      "props": [
        "병",
        "앱"
      ],
      "playability": "adapted_safe",
      "setup": "병 또는 화면 룰렛을 돌린다",
      "action": "선택된 사람은 질문/미션/패스를 고른다",
      "end": "접촉·키스 미션 없이 다음으로 간다.",
      "safeCore": "병 또는 화면 룰렛을 돌린다 → 선택된 사람은 질문/미션/패스를 고른다 → 접촉·키스 미션 없이 다음으로 간다."
    },
    {
      "observationId": "bdg-037",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Shot Roulette",
      "canonicalId": "covered-cup-roulette",
      "family": "운",
      "playersMin": 2,
      "props": [
        "불투명 컵"
      ],
      "playability": "adapted_safe",
      "setup": "모두 같은 무알코올 음료/빈 컵을 둔다",
      "action": "룰렛이 선택한 컵의 안전 미션을 공개한다",
      "end": "점수 후 컵을 섞는다.",
      "safeCore": "모두 같은 무알코올 음료/빈 컵을 둔다 → 룰렛이 선택한 컵의 안전 미션을 공개한다 → 점수 후 컵을 섞는다."
    },
    {
      "observationId": "bdg-038",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Categories",
      "canonicalId": "categories",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "주제를 뽑는다",
      "action": "겹치지 않는 단어를 차례로 말한다",
      "end": "반복/시간 초과 시 라운드가 끝난다.",
      "safeCore": "주제를 뽑는다 → 겹치지 않는 단어를 차례로 말한다 → 반복/시간 초과 시 라운드가 끝난다."
    },
    {
      "observationId": "bdg-039",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Rhyme Time",
      "canonicalId": "rhyme-time",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "기준 단어를 뽑는다",
      "action": "운이 맞는 말을 차례로 낸다",
      "end": "반복/시간 초과 전까지 팀 연속 기록을 만든다.",
      "safeCore": "기준 단어를 뽑는다 → 운이 맞는 말을 차례로 낸다 → 반복/시간 초과 전까지 팀 연속 기록을 만든다."
    },
    {
      "observationId": "bdg-040",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Word Association",
      "canonicalId": "word-association",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "시작 단어를 공개한다",
      "action": "앞 단어와 연상되는 새 단어를 잇는다",
      "end": "중복/설명 실패 시 다음 seed로 간다.",
      "safeCore": "시작 단어를 공개한다 → 앞 단어와 연상되는 새 단어를 잇는다 → 중복/설명 실패 시 다음 seed로 간다."
    },
    {
      "observationId": "bdg-041",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "The Name Game",
      "canonicalId": "name-game",
      "family": "인물추리",
      "playersMin": 4,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "setup": "모두 익숙한 인물/캐릭터를 제출한다",
      "action": "설명·한 단어·몸짓 단계로 팀이 맞힌다",
      "end": "총 정답 수를 겨룬다.",
      "safeCore": "모두 익숙한 인물/캐릭터를 제출한다 → 설명·한 단어·몸짓 단계로 팀이 맞힌다 → 총 정답 수를 겨룬다."
    },
    {
      "observationId": "bdg-042",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Questions",
      "canonicalId": "questions-only",
      "family": "즉흥",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "장면을 뽑는다",
      "action": "질문으로만 대화한다",
      "end": "평서문/반복/지연 시 상대가 점수를 얻는다.",
      "safeCore": "장면을 뽑는다 → 질문으로만 대화한다 → 평서문/반복/지연 시 상대가 점수를 얻는다."
    },
    {
      "observationId": "bdg-043",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Fuzzy Duck",
      "canonicalId": "fuzzy-duck",
      "family": "발음반응",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "정방향 구호를 돌린다",
      "action": "전환어가 나오면 방향/구호를 바꾼다",
      "end": "실수 없는 연속 횟수를 기록한다.",
      "safeCore": "정방향 구호를 돌린다 → 전환어가 나오면 방향/구호를 바꾼다 → 실수 없는 연속 횟수를 기록한다."
    },
    {
      "observationId": "bdg-044",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Bizz Buzz",
      "canonicalId": "bizz-buzz",
      "family": "숫자반응",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "숫자를 순서대로 센다",
      "action": "배수는 정해진 말로 바꾼다",
      "end": "목표 수까지 실수 없이 가면 성공한다.",
      "safeCore": "숫자를 순서대로 센다 → 배수는 정해진 말로 바꾼다 → 목표 수까지 실수 없이 가면 성공한다."
    },
    {
      "observationId": "bdg-045",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "The Story Game",
      "canonicalId": "story-chain",
      "family": "이야기",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "첫 문장을 뽑는다",
      "action": "각자 한 문장을 더하되 금지어를 피한다",
      "end": "모두 두 바퀴면 결말을 고른다.",
      "safeCore": "첫 문장을 뽑는다 → 각자 한 문장을 더하되 금지어를 피한다 → 모두 두 바퀴면 결말을 고른다."
    },
    {
      "observationId": "bdg-046",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Thumper",
      "canonicalId": "thumper",
      "family": "동작기억",
      "playersMin": 4,
      "props": [],
      "playability": "playable_safe",
      "setup": "각자 손동작을 정한다",
      "action": "자기 동작 뒤 다음 사람 동작을 보낸다",
      "end": "놓치기 전 연속 기록을 겨룬다.",
      "safeCore": "각자 손동작을 정한다 → 자기 동작 뒤 다음 사람 동작을 보낸다 → 놓치기 전 연속 기록을 겨룬다."
    },
    {
      "observationId": "bdg-047",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Pong",
      "canonicalId": "cup-target",
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "컵",
        "공"
      ],
      "playability": "adapted_safe",
      "setup": "빈 컵을 삼각형으로 둔다",
      "action": "탁구공을 던져 컵을 맞힌다",
      "end": "맞은 컵을 제거하고 먼저 모두 없애면 승리한다.",
      "safeCore": "빈 컵을 삼각형으로 둔다 → 탁구공을 던져 컵을 맞힌다 → 맞은 컵을 제거하고 먼저 모두 없애면 승리한다."
    },
    {
      "observationId": "bdg-048",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Flip Cup",
      "canonicalId": "flip-cup-relay",
      "family": "기술릴레이",
      "playersMin": 4,
      "props": [
        "빈컵"
      ],
      "playability": "adapted_safe",
      "setup": "빈 컵을 가장자리에 둔다",
      "action": "차례로 손가락으로 뒤집어 세운다",
      "end": "전원이 먼저 성공한 팀이 이긴다.",
      "safeCore": "빈 컵을 가장자리에 둔다 → 차례로 손가락으로 뒤집어 세운다 → 전원이 먼저 성공한 팀이 이긴다."
    },
    {
      "observationId": "bdg-049",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Quarters",
      "canonicalId": "coin-target",
      "family": "기술",
      "playersMin": 2,
      "props": [
        "동전",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "빈 컵을 목표로 둔다",
      "action": "동전을 한 번 튕겨 넣는다",
      "end": "정해진 횟수의 성공 점수를 겨룬다.",
      "safeCore": "빈 컵을 목표로 둔다 → 동전을 한 번 튕겨 넣는다 → 정해진 횟수의 성공 점수를 겨룬다."
    },
    {
      "observationId": "bdg-050",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Rage Cage",
      "canonicalId": "bounce-cup-chase",
      "family": "기술반응",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "setup": "두 사람이 공을 튕겨 컵에 넣는다",
      "action": "성공하면 컵을 옆으로 넘긴다",
      "end": "추월 토큰 횟수로 끝낸다.",
      "safeCore": "두 사람이 공을 튕겨 컵에 넣는다 → 성공하면 컵을 옆으로 넘긴다 → 추월 토큰 횟수로 끝낸다."
    },
    {
      "observationId": "bdg-051",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Slap Cup",
      "canonicalId": "bounce-cup-chase",
      "family": "기술반응",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "setup": "Rage Cage 별칭 관찰",
      "action": "빈 컵 추월 canonical을 쓴다",
      "end": "손으로 타인을 치는 동작은 제거한다.",
      "safeCore": "Rage Cage 별칭 관찰 → 빈 컵 추월 canonical을 쓴다 → 손으로 타인을 치는 동작은 제거한다."
    },
    {
      "observationId": "bdg-052",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Chandelier",
      "canonicalId": "chandelier-cups",
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "setup": "중앙/개인 빈 컵을 둔다",
      "action": "공을 튕겨 목표 컵에 넣는다",
      "end": "개인 컵 명중은 점수, 중앙은 모두 위치 교대다.",
      "safeCore": "중앙/개인 빈 컵을 둔다 → 공을 튕겨 목표 컵에 넣는다 → 개인 컵 명중은 점수, 중앙은 모두 위치 교대다."
    },
    {
      "observationId": "bdg-053",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Civil War",
      "canonicalId": "multi-ball-cup-target",
      "family": "던지기",
      "playersMin": 6,
      "props": [
        "컵",
        "공3"
      ],
      "playability": "adapted_safe",
      "setup": "두 팀에 빈 컵과 공을 나눈다",
      "action": "동시에 상대 컵을 노린다",
      "end": "안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다.",
      "safeCore": "두 팀에 빈 컵과 공을 나눈다 → 동시에 상대 컵을 노린다 → 안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다."
    },
    {
      "observationId": "bdg-054",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Baseball",
      "canonicalId": "cup-baseball",
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "setup": "컵을 1~4루 점수로 둔다",
      "action": "팀별로 공을 던진다",
      "end": "이닝 뒤 득점을 비교한다.",
      "safeCore": "컵을 1~4루 점수로 둔다 → 팀별로 공을 던진다 → 이닝 뒤 득점을 비교한다."
    },
    {
      "observationId": "bdg-055",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Boat Race",
      "canonicalId": "flip-cup-relay",
      "family": "릴레이",
      "playersMin": 4,
      "props": [
        "빈컵"
      ],
      "playability": "adapted_safe",
      "setup": "Flip Cup 계열 source alias",
      "action": "빈 컵 릴레이만 실행한다",
      "end": "속주 요소는 차단한다.",
      "safeCore": "Flip Cup 계열 source alias → 빈 컵 릴레이만 실행한다 → 속주 요소는 차단한다."
    },
    {
      "observationId": "bdg-056",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Land Mines",
      "canonicalId": "coin-spin-obstacles",
      "family": "기술",
      "playersMin": 3,
      "props": [
        "동전",
        "빈컵"
      ],
      "playability": "adapted_safe",
      "setup": "동전을 회전시킨다",
      "action": "멈추기 전 정해진 손동작을 하고 잡는다",
      "end": "성공 시 빈 컵 장애물을 배치한다.",
      "safeCore": "동전을 회전시킨다 → 멈추기 전 정해진 손동작을 하고 잡는다 → 성공 시 빈 컵 장애물을 배치한다."
    },
    {
      "observationId": "bdg-057",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Anchorman",
      "canonicalId": "pour-limit-puzzle",
      "family": "정밀",
      "playersMin": 3,
      "props": [
        "물",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "공용 물병과 표시 컵을 둔다",
      "action": "선을 넘지 않게 소량 따른다",
      "end": "넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다.",
      "safeCore": "공용 물병과 표시 컵을 둔다 → 선을 넘지 않게 소량 따른다 → 넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다."
    },
    {
      "observationId": "bdg-058",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Ball",
      "canonicalId": "table-ball-target",
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "공",
        "빈캔"
      ],
      "playability": "adapted_safe",
      "setup": "두 팀의 빈 캔 목표를 둔다",
      "action": "공으로 상대 목표를 맞힌다",
      "end": "회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다.",
      "safeCore": "두 팀의 빈 캔 목표를 둔다 → 공으로 상대 목표를 맞힌다 → 회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다."
    },
    {
      "observationId": "bdg-059",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Sink the Ship",
      "canonicalId": "floating-cup-balance",
      "family": "균형",
      "playersMin": 2,
      "props": [
        "대야",
        "물",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "물에 빈 컵을 띄운다",
      "action": "차례로 소량의 물을 더한다",
      "end": "가라앉힌 사람은 정리 담당을 고른다.",
      "safeCore": "물에 빈 컵을 띄운다 → 차례로 소량의 물을 더한다 → 가라앉힌 사람은 정리 담당을 고른다."
    },
    {
      "observationId": "bdg-060",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Power Hour",
      "canonicalId": "power-hour",
      "family": "속주",
      "playersMin": 1,
      "props": [
        "타이머"
      ],
      "playability": "safety_blocked",
      "setup": "매분 음주하는 원형을 정보로만 보존한다",
      "action": "실행 타이머는 제공하지 않는다",
      "end": "음악 1분 퀴즈로 대체한다.",
      "safeCore": "매분 음주하는 원형을 정보로만 보존한다 → 실행 타이머는 제공하지 않는다 → 음악 1분 퀴즈로 대체한다."
    },
    {
      "observationId": "bdg-061",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Movie Drinking Game",
      "canonicalId": "screen-trope-bingo",
      "family": "영상관찰",
      "playersMin": 2,
      "props": [
        "영상",
        "빙고"
      ],
      "playability": "adapted_safe",
      "setup": "작품 전에 일반 trope 칸을 고른다",
      "action": "장면이 나오면 칸을 표시한다",
      "end": "한 줄을 먼저 완성하면 승리한다.",
      "safeCore": "작품 전에 일반 trope 칸을 고른다 → 장면이 나오면 칸을 표시한다 → 한 줄을 먼저 완성하면 승리한다."
    },
    {
      "observationId": "bdg-062",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "TV Show Drinking Game",
      "canonicalId": "screen-trope-bingo",
      "family": "영상관찰",
      "playersMin": 2,
      "props": [
        "영상",
        "빙고"
      ],
      "playability": "adapted_safe",
      "setup": "같은 screen trope canonical",
      "action": "에피소드 단위로 표식한다",
      "end": "음주 대신 빙고 점수로 끝낸다.",
      "safeCore": "같은 screen trope canonical → 에피소드 단위로 표식한다 → 음주 대신 빙고 점수로 끝낸다."
    },
    {
      "observationId": "bdg-063",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Music Roulette",
      "canonicalId": "music-roulette",
      "family": "음악추리",
      "playersMin": 2,
      "props": [
        "재생기"
      ],
      "playability": "adapted_safe",
      "setup": "각자 재생 가능한 곡을 큐에 넣는다",
      "action": "무작위 일부를 듣는다",
      "end": "제목/가수/제출자를 맞혀 점수를 얻는다.",
      "safeCore": "각자 재생 가능한 곡을 큐에 넣는다 → 무작위 일부를 듣는다 → 제목/가수/제출자를 맞혀 점수를 얻는다."
    },
    {
      "observationId": "bdg-064",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Lyric Master",
      "canonicalId": "lyric-master",
      "family": "음악기억",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "공개 라이선스/사용자 기억 기반 시작 구절 주제를 낸다",
      "action": "다음 말을 직접 이어 부르지 않고 제목/다음 단어를 답한다",
      "end": "정답 점수를 합친다.",
      "safeCore": "공개 라이선스/사용자 기억 기반 시작 구절 주제를 낸다 → 다음 말을 직접 이어 부르지 않고 제목/다음 단어를 답한다 → 정답 점수를 합친다."
    },
    {
      "observationId": "bdg-065",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Disney Drinking Game",
      "canonicalId": "branded-screen-game",
      "family": "영상관찰",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "특정 브랜드 음주 규칙의 존재만 보존한다",
      "action": "라이선스 콘텐츠/대사 없이 일반 screen trope bingo를 추천한다",
      "end": "원형 실행 0.",
      "safeCore": "특정 브랜드 음주 규칙의 존재만 보존한다 → 라이선스 콘텐츠/대사 없이 일반 screen trope bingo를 추천한다 → 원형 실행 0."
    },
    {
      "observationId": "bdg-066",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Sports Drinking Game",
      "canonicalId": "sports-bingo",
      "family": "스포츠관찰",
      "playersMin": 2,
      "props": [
        "중계",
        "빙고"
      ],
      "playability": "adapted_safe",
      "setup": "경기 전 일반 사건 칸을 고른다",
      "action": "발생 시 표시한다",
      "end": "한 줄/최다 칸으로 승자를 정한다.",
      "safeCore": "경기 전 일반 사건 칸을 고른다 → 발생 시 표시한다 → 한 줄/최다 칸으로 승자를 정한다."
    },
    {
      "observationId": "bdg-067",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Commercial Break",
      "canonicalId": "ad-break-prompt",
      "family": "관찰/대화",
      "playersMin": 2,
      "props": [
        "영상"
      ],
      "playability": "adapted_safe",
      "setup": "광고 휴식 때 짧은 주제를 연다",
      "action": "전원이 한 답을 낸다",
      "end": "일치 답으로 팀 점수를 얻는다.",
      "safeCore": "광고 휴식 때 짧은 주제를 연다 → 전원이 한 답을 낸다 → 일치 답으로 팀 점수를 얻는다."
    },
    {
      "observationId": "bdg-068",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Karaoke Roulette",
      "canonicalId": "karaoke-roulette",
      "family": "노래",
      "playersMin": 2,
      "props": [
        "재생기"
      ],
      "playability": "adapted_safe",
      "setup": "모두 가능한 곡/장르를 넣는다",
      "action": "무작위 곡의 짧은 구간을 선택한다",
      "end": "부르기/허밍/패스 후 박수 점수를 준다.",
      "safeCore": "모두 가능한 곡/장르를 넣는다 → 무작위 곡의 짧은 구간을 선택한다 → 부르기/허밍/패스 후 박수 점수를 준다."
    },
    {
      "observationId": "bdg-069",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Thunderstruck",
      "canonicalId": "music-cue-pass",
      "family": "음악반응",
      "playersMin": 3,
      "props": [
        "재생기"
      ],
      "playability": "adapted_safe",
      "setup": "반복 신호가 있는 권리 확보 음악을 튼다",
      "action": "신호마다 토큰을 옆으로 넘긴다",
      "end": "곡 종료 시 연속 성공을 기록한다.",
      "safeCore": "반복 신호가 있는 권리 확보 음악을 튼다 → 신호마다 토큰을 옆으로 넘긴다 → 곡 종료 시 연속 성공을 기록한다."
    },
    {
      "observationId": "bdg-070",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Roxanne",
      "canonicalId": "branded-music-cue",
      "family": "음악반응",
      "playersMin": 2,
      "props": [
        "특정 곡"
      ],
      "playability": "reference_only",
      "setup": "특정 곡 반복어 음주 규칙을 보존한다",
      "action": "음악 권리/섭취 없이 일반 music cue pass를 추천한다",
      "end": "원형 실행 0.",
      "safeCore": "특정 곡 반복어 음주 규칙을 보존한다 → 음악 권리/섭취 없이 일반 music cue pass를 추천한다 → 원형 실행 0."
    },
    {
      "observationId": "bdg-071",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Olympics",
      "canonicalId": "party-decathlon",
      "family": "종합",
      "playersMin": 4,
      "props": [
        "선택"
      ],
      "playability": "adapted_safe",
      "setup": "안전 미니게임 3~7개를 고른다",
      "action": "팀별 점수를 누적한다",
      "end": "총점과 페어플레이 배지를 함께 공개한다.",
      "safeCore": "안전 미니게임 3~7개를 고른다 → 팀별 점수를 누적한다 → 총점과 페어플레이 배지를 함께 공개한다."
    },
    {
      "observationId": "bdg-072",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Wizard Staff",
      "canonicalId": "container-tower",
      "family": "만들기",
      "playersMin": 2,
      "props": [
        "빈 용기",
        "테이프"
      ],
      "playability": "adapted_safe",
      "setup": "깨끗한 빈 용기만 준비한다",
      "action": "제한 시간 동안 자립 탑을 만든다",
      "end": "높이보다 안정성/창의 점수를 합친다.",
      "safeCore": "깨끗한 빈 용기만 준비한다 → 제한 시간 동안 자립 탑을 만든다 → 높이보다 안정성/창의 점수를 합친다."
    },
    {
      "observationId": "bdg-073",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Edward Fortyhands",
      "canonicalId": "hands-bound-challenge",
      "family": "구속/섭취",
      "playersMin": 2,
      "props": [
        "테이프",
        "대용량주류"
      ],
      "playability": "safety_blocked",
      "setup": "손에 술병을 고정하는 원형만 정보로 보존한다",
      "action": "구속·섭취 실행 0",
      "end": "한 손 협동 그림을 추천한다.",
      "safeCore": "손에 술병을 고정하는 원형만 정보로 보존한다 → 구속·섭취 실행 0 → 한 손 협동 그림을 추천한다."
    },
    {
      "observationId": "bdg-074",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Dizzy Bat",
      "canonicalId": "dizzy-bat",
      "family": "회전/달리기",
      "playersMin": 2,
      "props": [
        "방망이"
      ],
      "playability": "safety_blocked",
      "setup": "회전 뒤 달리는 원형은 낙상 위험으로 차단한다",
      "action": "실행 안내 0",
      "end": "앉아서 손가락 미로 릴레이를 추천한다.",
      "safeCore": "회전 뒤 달리는 원형은 낙상 위험으로 차단한다 → 실행 안내 0 → 앉아서 손가락 미로 릴레이를 추천한다."
    },
    {
      "observationId": "bdg-075",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beersbee",
      "canonicalId": "flying-disc-target",
      "family": "야외던지기",
      "playersMin": 4,
      "props": [
        "디스크",
        "목표"
      ],
      "playability": "adapted_safe",
      "setup": "넓고 안전한 야외에 목표를 둔다",
      "action": "디스크로 목표를 맞힌다",
      "end": "명중/캐치 점수로 끝낸다.",
      "safeCore": "넓고 안전한 야외에 목표를 둔다 → 디스크로 목표를 맞힌다 → 명중/캐치 점수로 끝낸다."
    },
    {
      "observationId": "bdg-076",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Drunk Cornhole",
      "canonicalId": "cornhole",
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "보드",
        "주머니"
      ],
      "playability": "adapted_safe",
      "setup": "보드와 주머니를 둔다",
      "action": "구멍/보드에 던진다",
      "end": "표준 점수만 쓰고 음주 요소를 제거한다.",
      "safeCore": "보드와 주머니를 둔다 → 구멍/보드에 던진다 → 표준 점수만 쓰고 음주 요소를 제거한다."
    },
    {
      "observationId": "bdg-077",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Slip 'N Flip",
      "canonicalId": "slip-n-flip",
      "family": "미끄럼/릴레이",
      "playersMin": 4,
      "props": [
        "물",
        "시트"
      ],
      "playability": "safety_blocked",
      "setup": "미끄러운 바닥과 속도 경쟁 원형을 차단한다",
      "action": "실행 안내 0",
      "end": "마른 바닥 flip-cup relay를 추천한다.",
      "safeCore": "미끄러운 바닥과 속도 경쟁 원형을 차단한다 → 실행 안내 0 → 마른 바닥 flip-cup relay를 추천한다."
    },
    {
      "observationId": "bdg-078",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Drunk Jenga",
      "canonicalId": "tower-safe-prompts",
      "family": "균형",
      "playersMin": 2,
      "props": [
        "블록"
      ],
      "playability": "adapted_safe",
      "setup": "블록에 안전 질문/점수를 붙인다",
      "action": "한 블록을 빼고 미션을 고른다",
      "end": "탑이 무너지면 모두 재시작 점수를 얻는다.",
      "safeCore": "블록에 안전 질문/점수를 붙인다 → 한 블록을 빼고 미션을 고른다 → 탑이 무너지면 모두 재시작 점수를 얻는다."
    },
    {
      "observationId": "bdg-079",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Mile",
      "canonicalId": "beer-mile",
      "family": "속주/달리기",
      "playersMin": 1,
      "props": [
        "술",
        "트랙"
      ],
      "playability": "safety_blocked",
      "setup": "반복 음주와 달리기 결합 원형을 차단한다",
      "action": "실행 타이머 0",
      "end": "일반 걷기 빙고를 추천한다.",
      "safeCore": "반복 음주와 달리기 결합 원형을 차단한다 → 실행 타이머 0 → 일반 걷기 빙고를 추천한다."
    },
    {
      "observationId": "bdg-080",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Battleshots",
      "canonicalId": "grid-target-cups",
      "family": "추리",
      "playersMin": 2,
      "props": [
        "격자",
        "빈컵"
      ],
      "playability": "adapted_safe",
      "setup": "각자 격자에 빈 컵 함대를 숨긴다",
      "action": "좌표를 부른다",
      "end": "명중 컵을 제거해 먼저 전부 찾으면 이긴다.",
      "safeCore": "각자 격자에 빈 컵 함대를 숨긴다 → 좌표를 부른다 → 명중 컵을 제거해 먼저 전부 찾으면 이긴다."
    },
    {
      "observationId": "bdg-081",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Kan Jam",
      "canonicalId": "disc-slot-target",
      "family": "야외던지기",
      "playersMin": 4,
      "props": [
        "디스크",
        "목표"
      ],
      "playability": "reference_only",
      "setup": "상용 스포츠 이름을 보존한다",
      "action": "공식 장비/규칙 소유 시 일반 안전 플레이만 안내한다",
      "end": "자체 복제품은 제공하지 않는다.",
      "safeCore": "상용 스포츠 이름을 보존한다 → 공식 장비/규칙 소유 시 일반 안전 플레이만 안내한다 → 자체 복제품은 제공하지 않는다."
    },
    {
      "observationId": "bdg-082",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Keg Stand",
      "canonicalId": "keg-stand",
      "family": "역자세/강제섭취",
      "playersMin": 2,
      "props": [
        "술통"
      ],
      "playability": "safety_blocked",
      "setup": "사람을 거꾸로 들고 마시는 원형을 차단한다",
      "action": "실행·타이머 0",
      "end": "벽 기대기 팀 퀴즈도 신체 위험 때문에 기본 비추천한다.",
      "safeCore": "사람을 거꾸로 들고 마시는 원형을 차단한다 → 실행·타이머 0 → 벽 기대기 팀 퀴즈도 신체 위험 때문에 기본 비추천한다."
    },
    {
      "observationId": "bdg-083",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Das Boot",
      "canonicalId": "boot-glass-challenge",
      "family": "용기/섭취",
      "playersMin": 2,
      "props": [
        "부츠잔"
      ],
      "playability": "safety_blocked",
      "setup": "대형 잔 연속 섭취 원형을 정보로만 보존한다",
      "action": "실행 0",
      "end": "컵 모양 그림 맞히기를 추천한다.",
      "safeCore": "대형 잔 연속 섭취 원형을 정보로만 보존한다 → 실행 0 → 컵 모양 그림 맞히기를 추천한다."
    },
    {
      "observationId": "bdg-084",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Mario Kart Drinking Game",
      "canonicalId": "branded-video-game-variant",
      "family": "비디오게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "특정 게임의 음주 house rule을 보존한다",
      "action": "공식 게임은 자체 규칙으로만 플레이",
      "end": "일반 race-event bingo를 추천한다.",
      "safeCore": "특정 게임의 음주 house rule을 보존한다 → 공식 게임은 자체 규칙으로만 플레이 → 일반 race-event bingo를 추천한다."
    },
    {
      "observationId": "bdg-085",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Mario Party Drinking Game",
      "canonicalId": "branded-video-game-variant",
      "family": "비디오게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "같은 branded variant canonical",
      "action": "음주 트리거 실행 0",
      "end": "일반 party-event bingo를 추천한다.",
      "safeCore": "같은 branded variant canonical → 음주 트리거 실행 0 → 일반 party-event bingo를 추천한다."
    },
    {
      "observationId": "bdg-086",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Smash Bros Drinking Game",
      "canonicalId": "branded-video-game-variant",
      "family": "비디오게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "같은 branded variant canonical",
      "action": "패배 음주 실행 0",
      "end": "라운드 점수표만 제공한다.",
      "safeCore": "같은 branded variant canonical → 패배 음주 실행 0 → 라운드 점수표만 제공한다."
    },
    {
      "observationId": "bdg-087",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "FIFA Drinking Game",
      "canonicalId": "branded-video-game-variant",
      "family": "비디오게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "같은 branded variant canonical",
      "action": "경기 사건 음주 실행 0",
      "end": "일반 sports bingo를 추천한다.",
      "safeCore": "같은 branded variant canonical → 경기 사건 음주 실행 0 → 일반 sports bingo를 추천한다."
    },
    {
      "observationId": "bdg-088",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Call of Duty Drinking Game",
      "canonicalId": "branded-video-game-variant",
      "family": "비디오게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "같은 branded variant canonical",
      "action": "사망/패배 음주 실행 0",
      "end": "일반 team objective bingo를 추천한다.",
      "safeCore": "같은 branded variant canonical → 사망/패배 음주 실행 0 → 일반 team objective bingo를 추천한다."
    },
    {
      "observationId": "bdg-089",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Jackbox Drinking Game",
      "canonicalId": "branded-party-game-variant",
      "family": "디지털파티",
      "playersMin": 3,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "상용 파티게임의 음주 변형만 보존한다",
      "action": "공식 게임 결과는 점수로만 사용",
      "end": "앱은 음주 규칙을 실행하지 않는다.",
      "safeCore": "상용 파티게임의 음주 변형만 보존한다 → 공식 게임 결과는 점수로만 사용 → 앱은 음주 규칙을 실행하지 않는다."
    },
    {
      "observationId": "bdg-090",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Flunkyball",
      "canonicalId": "bottle-target-relay",
      "family": "야외던지기",
      "playersMin": 4,
      "props": [
        "공",
        "빈병"
      ],
      "playability": "adapted_safe",
      "setup": "두 팀 사이 빈 목표를 둔다",
      "action": "공으로 쓰러뜨리고 회수한다",
      "end": "정해진 명중 수를 먼저 채우면 승리한다.",
      "safeCore": "두 팀 사이 빈 목표를 둔다 → 공으로 쓰러뜨리고 회수한다 → 정해진 명중 수를 먼저 채우면 승리한다."
    },
    {
      "observationId": "bdg-091",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Hammerschlagen",
      "canonicalId": "hammer-nail-race",
      "family": "도구기술",
      "playersMin": 2,
      "props": [
        "망치",
        "못"
      ],
      "playability": "safety_blocked",
      "setup": "음주 환경에서 망치·못을 쓰는 원형을 차단한다",
      "action": "실행 안내 0",
      "end": "자석 핀 밀기를 추천한다.",
      "safeCore": "음주 환경에서 망치·못을 쓰는 원형을 차단한다 → 실행 안내 0 → 자석 핀 밀기를 추천한다."
    },
    {
      "observationId": "bdg-092",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Pub Golf",
      "canonicalId": "venue-scorecard",
      "family": "이동/종합",
      "playersMin": 2,
      "props": [
        "장소"
      ],
      "playability": "adapted_safe",
      "setup": "장소별 안전 미션과 파를 정한다",
      "action": "음료 섭취량 대신 퀴즈/사진 없는 관찰 과제를 완료한다",
      "end": "낮은 점수가 승리한다.",
      "safeCore": "장소별 안전 미션과 파를 정한다 → 음료 섭취량 대신 퀴즈/사진 없는 관찰 과제를 완료한다 → 낮은 점수가 승리한다."
    },
    {
      "observationId": "bdg-093",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Goon of Fortune",
      "canonicalId": "rotary-container-game",
      "family": "회전/대용량섭취",
      "playersMin": 3,
      "props": [
        "빨랫줄",
        "주류"
      ],
      "playability": "safety_blocked",
      "setup": "회전 주류 용기에서 마시는 원형을 차단한다",
      "action": "실행 0",
      "end": "회전 화살표 안전 질문을 추천한다.",
      "safeCore": "회전 주류 용기에서 마시는 원형을 차단한다 → 실행 0 → 회전 화살표 안전 질문을 추천한다."
    },
    {
      "observationId": "bdg-094",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Titanic",
      "canonicalId": "floating-cup-balance",
      "family": "균형",
      "playersMin": 2,
      "props": [
        "물",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "Sink the Ship의 별칭",
      "action": "물만 사용하는 canonical을 연다",
      "end": "가라앉힘은 정리 미션으로 끝낸다.",
      "safeCore": "Sink the Ship의 별칭 → 물만 사용하는 canonical을 연다 → 가라앉힘은 정리 미션으로 끝낸다."
    },
    {
      "observationId": "bdg-095",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Baskin Robbins 31",
      "canonicalId": "baskin-31",
      "family": "숫자전략",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "차례에 숫자 1~3개를 이어 말한다",
      "action": "31을 말한 사람이 라운드 선택권을 넘긴다",
      "end": "목표 수 variant를 지원한다.",
      "safeCore": "차례에 숫자 1~3개를 이어 말한다 → 31을 말한 사람이 라운드 선택권을 넘긴다 → 목표 수 variant를 지원한다."
    },
    {
      "observationId": "bdg-096",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "3-6-9",
      "canonicalId": "three-six-nine",
      "family": "숫자반응",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "숫자를 순서대로 센다",
      "action": "3/6/9가 든 횟수만큼 박수/시각 신호를 낸다",
      "end": "목표까지 팀 성공을 노린다.",
      "safeCore": "숫자를 순서대로 센다 → 3/6/9가 든 횟수만큼 박수/시각 신호를 낸다 → 목표까지 팀 성공을 노린다."
    },
    {
      "observationId": "bdg-097",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Kastenlauf",
      "canonicalId": "crate-walk",
      "family": "이동/대량주류",
      "playersMin": 2,
      "props": [
        "상자",
        "주류"
      ],
      "playability": "safety_blocked",
      "setup": "술 상자를 들고 장거리 이동·섭취하는 원형을 차단한다",
      "action": "실행 0",
      "end": "동네 관찰 빙고를 추천한다.",
      "safeCore": "술 상자를 들고 장거리 이동·섭취하는 원형을 차단한다 → 실행 0 → 동네 관찰 빙고를 추천한다."
    },
    {
      "observationId": "bdg-098",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Centurion",
      "canonicalId": "centurion",
      "family": "속주",
      "playersMin": 1,
      "props": [
        "타이머"
      ],
      "playability": "safety_blocked",
      "setup": "100회 시간 음주 원형을 차단한다",
      "action": "실행·알림 0",
      "end": "100초 협동 퀴즈를 추천한다.",
      "safeCore": "100회 시간 음주 원형을 차단한다 → 실행·알림 0 → 100초 협동 퀴즈를 추천한다."
    },
    {
      "observationId": "bdg-099",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Two Truths and a Lie",
      "canonicalId": "two-truths-one-lie",
      "family": "대화추리",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "각자 안전한 사실 2개와 허구 1개를 낸다",
      "action": "나머지가 거짓을 고른다",
      "end": "맞힌 사람과 속인 사람이 점수를 얻는다.",
      "safeCore": "각자 안전한 사실 2개와 허구 1개를 낸다 → 나머지가 거짓을 고른다 → 맞힌 사람과 속인 사람이 점수를 얻는다."
    },
    {
      "observationId": "bdg-100",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "What Are the Odds?",
      "canonicalId": "what-are-the-odds-safe",
      "family": "합의/숫자",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "수행 가능한 안전 미션과 2~10 범위를 합의한다",
      "action": "동시에 숫자를 말한다",
      "end": "일치하면 수행/패스, 불일치는 종료다.",
      "safeCore": "수행 가능한 안전 미션과 2~10 범위를 합의한다 → 동시에 숫자를 말한다 → 일치하면 수행/패스, 불일치는 종료다."
    },
    {
      "observationId": "bdg-101",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Straight Face",
      "canonicalId": "straight-face",
      "family": "표정",
      "playersMin": 3,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "setup": "비모욕 문장을 제출한다",
      "action": "한 사람이 무표정으로 읽는다",
      "end": "웃음이 나면 문장 작성자가 점수를 얻는다.",
      "safeCore": "비모욕 문장을 제출한다 → 한 사람이 무표정으로 읽는다 → 웃음이 나면 문장 작성자가 점수를 얻는다."
    },
    {
      "observationId": "bdg-102",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Caps",
      "canonicalId": "cap-target",
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "병뚜껑",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "빈 컵을 목표로 둔다",
      "action": "병뚜껑을 던진다",
      "end": "명중 시 상대가 같은 시도로 방어하고 점수를 정한다.",
      "safeCore": "빈 컵을 목표로 둔다 → 병뚜껑을 던진다 → 명중 시 상대가 같은 시도로 방어하고 점수를 정한다."
    },
    {
      "observationId": "bdg-103",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Drunk Twister",
      "canonicalId": "color-position-variant",
      "family": "신체/상용게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "setup": "상용 신체게임의 음주 변형을 보존한다",
      "action": "공식 게임은 동의·접촉 없음 옵션으로만 플레이",
      "end": "자체 보드는 제공하지 않는다.",
      "safeCore": "상용 신체게임의 음주 변형을 보존한다 → 공식 게임은 동의·접촉 없음 옵션으로만 플레이 → 자체 보드는 제공하지 않는다."
    },
    {
      "observationId": "bdg-104",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Beer Bong",
      "canonicalId": "beer-bong",
      "family": "강제/속주",
      "playersMin": 1,
      "props": [
        "깔때기"
      ],
      "playability": "safety_blocked",
      "setup": "깔때기로 빠르게 마시는 원형을 차단한다",
      "action": "실행 안내·용량·타이머 0",
      "end": "안전 게임 추천만 제공한다.",
      "safeCore": "깔때기로 빠르게 마시는 원형을 차단한다 → 실행 안내·용량·타이머 0 → 안전 게임 추천만 제공한다."
    },
    {
      "observationId": "bdg-105",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Sociables",
      "canonicalId": "sociables-cards",
      "family": "카드종합",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "setup": "카드마다 안전 카테고리/질문/규칙을 매핑한다",
      "action": "차례로 수행한다",
      "end": "덱 종료 시 팀 성공 수를 합친다.",
      "safeCore": "카드마다 안전 카테고리/질문/규칙을 매핑한다 → 차례로 수행한다 → 덱 종료 시 팀 성공 수를 합친다."
    },
    {
      "observationId": "bdg-106",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Suck and Blow",
      "canonicalId": "card-pass-air",
      "family": "접촉/호흡",
      "playersMin": 4,
      "props": [
        "카드"
      ],
      "playability": "safety_blocked",
      "setup": "입으로 카드를 전달하는 접촉·위생 원형을 차단한다",
      "action": "실행 0",
      "end": "손등 카드 릴레이를 추천한다.",
      "safeCore": "입으로 카드를 전달하는 접촉·위생 원형을 차단한다 → 실행 0 → 손등 카드 릴레이를 추천한다."
    },
    {
      "observationId": "bdg-107",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Moose",
      "canonicalId": "moose-dice",
      "family": "주사위반응",
      "playersMin": 3,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "setup": "특정 주사위 조합에 공통 손동작을 정한다",
      "action": "굴릴 때 즉시 반응한다",
      "end": "가장 늦은 사람은 점수 -1/패스를 고른다.",
      "safeCore": "특정 주사위 조합에 공통 손동작을 정한다 → 굴릴 때 즉시 반응한다 → 가장 늦은 사람은 점수 -1/패스를 고른다."
    },
    {
      "observationId": "bdg-108",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Shotgunning a Beer",
      "canonicalId": "shotgun-beer",
      "family": "속주/용기훼손",
      "playersMin": 1,
      "props": [
        "캔"
      ],
      "playability": "safety_blocked",
      "setup": "캔을 뚫어 빠르게 마시는 원형을 차단한다",
      "action": "방법·도구·타이머 0",
      "end": "안전 대체만 제공한다.",
      "safeCore": "캔을 뚫어 빠르게 마시는 원형을 차단한다 → 방법·도구·타이머 0 → 안전 대체만 제공한다."
    },
    {
      "observationId": "bdg-109",
      "sourceCode": "bdg",
      "sourceRegion": "global_english",
      "sourceName": "Status Code Drinking Game",
      "canonicalId": "status-code-bingo",
      "family": "개발/관찰",
      "playersMin": 2,
      "props": [
        "로그",
        "빙고"
      ],
      "playability": "adapted_safe",
      "setup": "상태코드 이벤트 칸을 만든다",
      "action": "개발/게임 세션 중 발생하면 표시한다",
      "end": "한 줄을 먼저 채우면 승리한다.",
      "safeCore": "상태코드 이벤트 칸을 만든다 → 개발/게임 세션 중 발생하면 표시한다 → 한 줄을 먼저 채우면 승리한다."
    },
    {
      "observationId": "wt-001",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "1-2-3",
      "canonicalId": "one-two-three-dice",
      "family": "Dice/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "주사위 3개의 순서를 예측한다",
      "action": "공개 조합으로 점수를 계산한다",
      "end": "최고 점수가 승리한다.",
      "safeCore": "주사위 3개의 순서를 예측한다 → 공개 조합으로 점수를 계산한다 → 최고 점수가 승리한다."
    },
    {
      "observationId": "wt-002",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Ally McBeal Drinking Game",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 음주 규칙 존재만 보존한다",
      "action": "일반 screen trope bingo로 이동한다",
      "end": "대사·영상·음주 트리거는 제공하지 않는다.",
      "safeCore": "특정 방송 음주 규칙 존재만 보존한다 → 일반 screen trope bingo로 이동한다 → 대사·영상·음주 트리거는 제공하지 않는다."
    },
    {
      "observationId": "wt-003",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Asshole",
      "canonicalId": "presidents",
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "Presidents의 역사적·모욕적 별칭",
      "action": "public display는 대통령 카드",
      "end": "손패를 먼저 비우는 전략 게임으로 실행한다.",
      "safeCore": "Presidents의 역사적·모욕적 별칭 → public display는 대통령 카드 → 손패를 먼저 비우는 전략 게임으로 실행한다."
    },
    {
      "observationId": "wt-004",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Baseball",
      "canonicalId": "coin-baseball",
      "family": "Coin/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "동전 성공 구간을 루로 정한다",
      "action": "차례로 튕겨 주자를 전진한다",
      "end": "이닝 득점을 비교한다.",
      "safeCore": "동전 성공 구간을 루로 정한다 → 차례로 튕겨 주자를 전진한다 → 이닝 득점을 비교한다."
    },
    {
      "observationId": "wt-005",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "BatBeer",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 영상 기반 원형만 보존한다",
      "action": "일반 trope bingo를 추천한다",
      "end": "원형 실행 0.",
      "safeCore": "특정 영상 기반 원형만 보존한다 → 일반 trope bingo를 추천한다 → 원형 실행 0."
    },
    {
      "observationId": "wt-006",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beat the Barman",
      "canonicalId": "beat-the-barman",
      "family": "Endurance/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "제한 시간 연속 섭취 경쟁을 차단한다",
      "action": "용량·속도 안내 0",
      "end": "주문 기억 릴레이를 추천한다.",
      "safeCore": "제한 시간 연속 섭취 경쟁을 차단한다 → 용량·속도 안내 0 → 주문 기억 릴레이를 추천한다."
    },
    {
      "observationId": "wt-007",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer 99 #1",
      "canonicalId": "ninety-nine-cards",
      "family": "Card/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "카드 값을 더하되 합계 99를 넘기지 않는다",
      "action": "특수 숫자 효과를 적용한다",
      "end": "마지막 생존 토큰이 승리한다.",
      "safeCore": "카드 값을 더하되 합계 99를 넘기지 않는다 → 특수 숫자 효과를 적용한다 → 마지막 생존 토큰이 승리한다."
    },
    {
      "observationId": "wt-008",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer 99 #2",
      "canonicalId": "ninety-nine-cards",
      "family": "Card/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "같은 99 canonical의 house variant",
      "action": "variant rule만 별칭으로 저장한다",
      "end": "음주 없이 토큰으로 끝낸다.",
      "safeCore": "같은 99 canonical의 house variant → variant rule만 별칭으로 저장한다 → 음주 없이 토큰으로 끝낸다."
    },
    {
      "observationId": "wt-009",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Blow",
      "canonicalId": "card-blow-stack",
      "family": "Card/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "컵 위 카드 더미를 둔다",
      "action": "한 번씩 불어 일부만 떨어뜨린다",
      "end": "마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다.",
      "safeCore": "컵 위 카드 더미를 둔다 → 한 번씩 불어 일부만 떨어뜨린다 → 마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다."
    },
    {
      "observationId": "wt-010",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Bomb",
      "canonicalId": "coin-target",
      "family": "Skill/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "동전/작은 토큰을 빈 목표에 넣는다",
      "action": "명중 횟수를 기록한다",
      "end": "점수로 승부한다.",
      "safeCore": "동전/작은 토큰을 빈 목표에 넣는다 → 명중 횟수를 기록한다 → 점수로 승부한다."
    },
    {
      "observationId": "wt-011",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Bungee",
      "canonicalId": "elastic-target",
      "family": "Strength/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "탄성 도구를 쓰는 지역 게임 관찰",
      "action": "장비 안전 사양이 없어 실행하지 않는다",
      "end": "cap target을 추천한다.",
      "safeCore": "탄성 도구를 쓰는 지역 게임 관찰 → 장비 안전 사양이 없어 실행하지 않는다 → cap target을 추천한다."
    },
    {
      "observationId": "wt-012",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Chess",
      "canonicalId": "chess-safe-variant",
      "family": "Board/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "체스 한 판을 둔다",
      "action": "잡힌 말마다 마시기 대신 상대가 퀴즈/점수 중 하나를 고른다",
      "end": "체크메이트로 끝낸다.",
      "safeCore": "체스 한 판을 둔다 → 잡힌 말마다 마시기 대신 상대가 퀴즈/점수 중 하나를 고른다 → 체크메이트로 끝낸다."
    },
    {
      "observationId": "wt-013",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Hunter",
      "canonicalId": "hidden-container-roulette",
      "family": "Other/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "일부 용기에 위험 음료를 숨기는 원형을 차단한다",
      "action": "음식/음료 러시안룰렛 0",
      "end": "숨은 색 토큰 추리를 추천한다.",
      "safeCore": "일부 용기에 위험 음료를 숨기는 원형을 차단한다 → 음식/음료 러시안룰렛 0 → 숨은 색 토큰 추리를 추천한다."
    },
    {
      "observationId": "wt-014",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Pong",
      "canonicalId": "cup-target",
      "family": "Other/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-047 alias",
      "action": "빈 컵과 물 세척 공만 사용한다",
      "end": "컵 제거 점수로 끝낸다.",
      "safeCore": "bdg-047 alias → 빈 컵과 물 세척 공만 사용한다 → 컵 제거 점수로 끝낸다."
    },
    {
      "observationId": "wt-015",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Pot",
      "canonicalId": "coin-pot",
      "family": "Skill/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "중앙 빈 컵/그릇을 둔다",
      "action": "동전을 튕겨 목표 구역에 넣는다",
      "end": "정해진 시도 뒤 점수를 비교한다.",
      "safeCore": "중앙 빈 컵/그릇을 둔다 → 동전을 튕겨 목표 구역에 넣는다 → 정해진 시도 뒤 점수를 비교한다."
    },
    {
      "observationId": "wt-016",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beer Race",
      "canonicalId": "beer-race",
      "family": "Speed/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "속주 릴레이를 차단한다",
      "action": "실행 타이머 0",
      "end": "flip-cup relay를 추천한다.",
      "safeCore": "속주 릴레이를 차단한다 → 실행 타이머 0 → flip-cup relay를 추천한다."
    },
    {
      "observationId": "wt-017",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beerchesi",
      "canonicalId": "parcheesi-safe-variant",
      "family": "Board/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 보드게임 변형 존재만 보존한다",
      "action": "공식 보유판은 점수만 사용한다",
      "end": "자체 보드/음주 규칙은 제공하지 않는다.",
      "safeCore": "특정 보드게임 변형 존재만 보존한다 → 공식 보유판은 점수만 사용한다 → 자체 보드/음주 규칙은 제공하지 않는다."
    },
    {
      "observationId": "wt-018",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beergammon",
      "canonicalId": "backgammon-safe-variant",
      "family": "Board/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 보드게임 변형 존재만 보존한다",
      "action": "공식 일반 규칙을 따른다",
      "end": "음주 트리거 0.",
      "safeCore": "특정 보드게임 변형 존재만 보존한다 → 공식 일반 규칙을 따른다 → 음주 트리거 0."
    },
    {
      "observationId": "wt-019",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beeropoly",
      "canonicalId": "monopoly-safe-variant",
      "family": "Board/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "상용 부동산 보드게임 음주 변형을 보존한다",
      "action": "공식판 소유 시 일반 플레이만",
      "end": "자체 복제/음주 규칙 0.",
      "safeCore": "상용 부동산 보드게임 음주 변형을 보존한다 → 공식판 소유 시 일반 플레이만 → 자체 복제/음주 규칙 0."
    },
    {
      "observationId": "wt-020",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Beers for Cheers",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 기반 원형",
      "action": "일반 screen trope bingo 추천",
      "end": "원형 실행 0.",
      "safeCore": "특정 방송 기반 원형 → 일반 screen trope bingo 추천 → 원형 실행 0."
    },
    {
      "observationId": "wt-021",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Boat Races",
      "canonicalId": "flip-cup-relay",
      "family": "Speed/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-055 alias",
      "action": "빈 컵 뒤집기 릴레이",
      "end": "섭취·속주 제거.",
      "safeCore": "bdg-055 alias → 빈 컵 뒤집기 릴레이 → 섭취·속주 제거."
    },
    {
      "observationId": "wt-022",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Bouncing Ball",
      "canonicalId": "bouncing-ball-chant",
      "family": "Vocal/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "원을 만들고 가상의 공을 1번부터 시작한다",
      "action": "WHIZ는 다음 사람, BOUNCE는 한 사람 건너뛰기, BOING은 진행 방향을 뒤집는다",
      "end": "실수 없이 10회 연속 패스하면 함께 성공한다.",
      "safeCore": "원을 만들고 가상의 공을 1번부터 시작한다 → WHIZ는 다음 사람, BOUNCE는 한 사람 건너뛰기, BOING은 진행 방향을 뒤집는다 → 실수 없이 10회 연속 패스하면 함께 성공한다."
    },
    {
      "observationId": "wt-023",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Brain Damage",
      "canonicalId": "brain-damage-cards",
      "family": "Card/High-Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "이름과 지역 카드 변형만 보존한다",
      "action": "규칙 signature 확정 전 실행하지 않는다",
      "end": "pyramid cards를 추천한다.",
      "safeCore": "이름과 지역 카드 변형만 보존한다 → 규칙 signature 확정 전 실행하지 않는다 → pyramid cards를 추천한다."
    },
    {
      "observationId": "wt-024",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Buffalo",
      "canonicalId": "buffalo-hand-rule",
      "family": "Hands/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-032 alias",
      "action": "특정 손 금지 지속 규칙",
      "end": "위반은 점수/안전 미션으로 처리한다.",
      "safeCore": "bdg-032 alias → 특정 손 금지 지속 규칙 → 위반은 점수/안전 미션으로 처리한다."
    },
    {
      "observationId": "wt-025",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Bullshit",
      "canonicalId": "bullshit-cards",
      "family": "Card/High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-012 alias",
      "action": "카드 선언과 도전",
      "end": "손패를 먼저 비우면 승리한다.",
      "safeCore": "bdg-012 alias → 카드 선언과 도전 → 손패를 먼저 비우면 승리한다."
    },
    {
      "observationId": "wt-026",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Buzz",
      "canonicalId": "bizz-buzz",
      "family": "Vocal/Low",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-044 alias",
      "action": "배수 대체어를 말한다",
      "end": "목표 수까지 협동한다.",
      "safeCore": "bdg-044 alias → 배수 대체어를 말한다 → 목표 수까지 협동한다."
    },
    {
      "observationId": "wt-027",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Caps",
      "canonicalId": "cap-target",
      "family": "Skill/Low-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-102 alias",
      "action": "병뚜껑을 빈 컵에 던진다",
      "end": "명중/방어 점수를 쓴다.",
      "safeCore": "bdg-102 alias → 병뚜껑을 빈 컵에 던진다 → 명중/방어 점수를 쓴다."
    },
    {
      "observationId": "wt-028",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Cardinal Puff",
      "canonicalId": "cardinal-puff-memory",
      "family": "Vocal/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "긴 말·동작 순서를 시범 카드로 배운다",
      "action": "순서대로 재현한다",
      "end": "완주 횟수를 기록한다.",
      "safeCore": "긴 말·동작 순서를 시범 카드로 배운다 → 순서대로 재현한다 → 완주 횟수를 기록한다."
    },
    {
      "observationId": "wt-029",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Century Club",
      "canonicalId": "centurion",
      "family": "Endurance/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "bdg-098 alias",
      "action": "반복 시간 음주 차단",
      "end": "100초 협동 퀴즈 추천.",
      "safeCore": "bdg-098 alias → 반복 시간 음주 차단 → 100초 협동 퀴즈 추천."
    },
    {
      "observationId": "wt-030",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Chutes and Ladders",
      "canonicalId": "chutes-ladders-variant",
      "family": "Board/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "상용 보드게임 변형 관찰",
      "action": "공식판 일반 규칙만",
      "end": "음주 house rule 0.",
      "safeCore": "상용 보드게임 변형 관찰 → 공식판 일반 규칙만 → 음주 house rule 0."
    },
    {
      "observationId": "wt-031",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Death Ring",
      "canonicalId": "kings-cup",
      "family": "Card/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "Circle of Death/Kings Cup alias",
      "action": "안전 카드 덱으로 실행",
      "end": "중앙 혼합 음료 0.",
      "safeCore": "Circle of Death/Kings Cup alias → 안전 카드 덱으로 실행 → 중앙 혼합 음료 0."
    },
    {
      "observationId": "wt-032",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Dice",
      "canonicalId": "open-dice-rules",
      "family": "Dice/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "안전 주사위 액션 6개를 고른다",
      "action": "굴린 면의 점수/질문을 수행한다",
      "end": "정해진 라운드로 끝낸다.",
      "safeCore": "안전 주사위 액션 6개를 고른다 → 굴린 면의 점수/질문을 수행한다 → 정해진 라운드로 끝낸다."
    },
    {
      "observationId": "wt-033",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Drop the Dime",
      "canonicalId": "coin-drop-precision",
      "family": "Skill/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "물이 든 투명 그릇 아래 목표를 둔다",
      "action": "동전을 떨어뜨려 목표와 겹친다",
      "end": "근접 점수를 합친다.",
      "safeCore": "물이 든 투명 그릇 아래 목표를 둔다 → 동전을 떨어뜨려 목표와 겹친다 → 근접 점수를 합친다."
    },
    {
      "observationId": "wt-034",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Drug Dealer",
      "canonicalId": "dealer-detective-cards",
      "family": "Card/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "역할 카드를 비공개로 나눈다",
      "action": "눈짓/단서로 dealer를 찾는다",
      "end": "직업명은 비밀 전달자로 중립 표시한다.",
      "safeCore": "역할 카드를 비공개로 나눈다 → 눈짓/단서로 dealer를 찾는다 → 직업명은 비밀 전달자로 중립 표시한다."
    },
    {
      "observationId": "wt-035",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Eurovision Song Contest Drinking Game",
      "canonicalId": "branded-event-bingo",
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 행사 기반 음주 규칙을 보존한다",
      "action": "일반 music-event bingo를 추천한다",
      "end": "브랜드 에셋/음주 트리거 0.",
      "safeCore": "특정 행사 기반 음주 규칙을 보존한다 → 일반 music-event bingo를 추천한다 → 브랜드 에셋/음주 트리거 0."
    },
    {
      "observationId": "wt-036",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Flip the cup",
      "canonicalId": "flip-cup-relay",
      "family": "Skill/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-048 alias",
      "action": "빈 컵 뒤집기 릴레이",
      "end": "섭취 0.",
      "safeCore": "bdg-048 alias → 빈 컵 뒤집기 릴레이 → 섭취 0."
    },
    {
      "observationId": "wt-037",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Fuzzy Duck #1",
      "canonicalId": "fuzzy-duck",
      "family": "Vocal/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-043 alias",
      "action": "구호 방향 전환",
      "end": "연속 성공 기록.",
      "safeCore": "bdg-043 alias → 구호 방향 전환 → 연속 성공 기록."
    },
    {
      "observationId": "wt-038",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Fuzzy Duck #2",
      "canonicalId": "fuzzy-duck",
      "family": "Vocal/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "같은 canonical house variant",
      "action": "전환어 set만 variant",
      "end": "안전 동일.",
      "safeCore": "같은 canonical house variant → 전환어 set만 variant → 안전 동일."
    },
    {
      "observationId": "wt-039",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Give One, Take One",
      "canonicalId": "give-take-cards",
      "family": "Card/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-014 alias",
      "action": "카드 매치가 안전 미션의 주고받기를 정한다",
      "end": "패스 가능.",
      "safeCore": "bdg-014 alias → 카드 매치가 안전 미션의 주고받기를 정한다 → 패스 가능."
    },
    {
      "observationId": "wt-040",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Guess the Note",
      "canonicalId": "guess-the-note",
      "family": "Other/Low",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "권리 확보 음원의 한 음/짧은 효과음을 튼다",
      "action": "곡/악기/높낮이를 맞힌다",
      "end": "정답 점수를 합친다.",
      "safeCore": "권리 확보 음원의 한 음/짧은 효과음을 튼다 → 곡/악기/높낮이를 맞힌다 → 정답 점수를 합친다."
    },
    {
      "observationId": "wt-041",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Hi, Bob",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송·대사 규칙을 보존한다",
      "action": "일반 screen trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송·대사 규칙을 보존한다 → 일반 screen trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-042",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "High or Low",
      "canonicalId": "higher-lower",
      "family": "Card/High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-006 alias",
      "action": "다음 카드 높낮이 추리",
      "end": "연속 정답 점수.",
      "safeCore": "bdg-006 alias → 다음 카드 높낮이 추리 → 연속 정답 점수."
    },
    {
      "observationId": "wt-043",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Hockey",
      "canonicalId": "hockey-cards",
      "family": "Card/Medium-Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "카드 숫자를 공격/수비 신호로 매핑한다",
      "action": "팀별로 공개·대응한다",
      "end": "정해진 피리어드 득점을 비교한다.",
      "safeCore": "카드 숫자를 공격/수비 신호로 매핑한다 → 팀별로 공개·대응한다 → 정해진 피리어드 득점을 비교한다."
    },
    {
      "observationId": "wt-044",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "I Never",
      "canonicalId": "never-have-i-ever",
      "family": "Vocal/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-026 alias",
      "action": "안전 질문에 손가락/토큰으로 응답",
      "end": "설명·음주 강제 없이 종료한다.",
      "safeCore": "bdg-026 alias → 안전 질문에 손가락/토큰으로 응답 → 설명·음주 강제 없이 종료한다."
    },
    {
      "observationId": "wt-045",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Icetray Quarters",
      "canonicalId": "ice-tray-coin-target",
      "family": "Coin/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "얼음틀/칸 목표에 동전을 튕긴다",
      "action": "칸별 점수를 얻는다",
      "end": "위생상 음식/음료와 분리한다.",
      "safeCore": "얼음틀/칸 목표에 동전을 튕긴다 → 칸별 점수를 얻는다 → 위생상 음식/음료와 분리한다."
    },
    {
      "observationId": "wt-046",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Indian Poker",
      "canonicalId": "indian-poker",
      "family": "Card/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-011 alias",
      "action": "자기 카드만 못 보고 심리 선택",
      "end": "높은 카드 점수.",
      "safeCore": "bdg-011 alias → 자기 카드만 못 보고 심리 선택 → 높은 카드 점수."
    },
    {
      "observationId": "wt-047",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "James Bond",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 영화 기반 음주 규칙",
      "action": "일반 action trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 영화 기반 음주 규칙 → 일반 action trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-048",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Jenga",
      "canonicalId": "tower-safe-prompts",
      "family": "Skill/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-078 alias",
      "action": "블록 빼기와 안전 질문/점수",
      "end": "탑 재시작.",
      "safeCore": "bdg-078 alias → 블록 빼기와 안전 질문/점수 → 탑 재시작."
    },
    {
      "observationId": "wt-049",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Kings and Blood",
      "canonicalId": "kings-blood-variant",
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "혼합 음료/강제 섭취가 핵심인 지역 variant를 차단한다",
      "action": "일반 Kings Cup 안전 덱 추천.",
      "end": "정해진 라운드 뒤 종료한다.",
      "safeCore": "혼합 음료/강제 섭취가 핵심인 지역 variant를 차단한다 → 일반 Kings Cup 안전 덱 추천."
    },
    {
      "observationId": "wt-050",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Kings",
      "canonicalId": "kings-cup",
      "family": "Card/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-001 alias",
      "action": "안전 카드 미션",
      "end": "덱 종료 팀 점수.",
      "safeCore": "bdg-001 alias → 안전 카드 미션 → 덱 종료 팀 점수."
    },
    {
      "observationId": "wt-051",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Master of the Thumb",
      "canonicalId": "thumb-master",
      "family": "Skill/Low",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "한 명이 임의 시점에 엄지를 댄다",
      "action": "다른 사람도 따라 한다",
      "end": "마지막 반응은 점수 -1/패스를 고른다.",
      "safeCore": "한 명이 임의 시점에 엄지를 댄다 → 다른 사람도 따라 한다 → 마지막 반응은 점수 -1/패스를 고른다."
    },
    {
      "observationId": "wt-052",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Mexicali",
      "canonicalId": "mexicali",
      "family": "Dice/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-021 alias",
      "action": "숨긴 주사위 입찰/도전",
      "end": "토큰 점수.",
      "safeCore": "bdg-021 alias → 숨긴 주사위 입찰/도전 → 토큰 점수."
    },
    {
      "observationId": "wt-053",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Mexican",
      "canonicalId": "mexican-dice",
      "family": "Dice/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "두 주사위 조합 순위를 정한다",
      "action": "숨겨 굴려 선언/도전한다",
      "end": "검증 결과로 토큰을 옮긴다.",
      "safeCore": "두 주사위 조합 순위를 정한다 → 숨겨 굴려 선언/도전한다 → 검증 결과로 토큰을 옮긴다."
    },
    {
      "observationId": "wt-054",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Multiple Party Game",
      "canonicalId": "multi-party-ruleset",
      "family": "Other/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "규칙 식별이 불충분한 source title을 보존한다",
      "action": "상세 provenance 확인 전 실행 0",
      "end": "party decathlon 추천.",
      "safeCore": "규칙 식별이 불충분한 source title을 보존한다 → 상세 provenance 확인 전 실행 0 → party decathlon 추천."
    },
    {
      "observationId": "wt-055",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Nothing",
      "canonicalId": "nothing-dice",
      "family": "Dice/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "규칙 식별이 불충분한 역사명",
      "action": "source detail 수동 감사 queue",
      "end": "open dice rules 추천.",
      "safeCore": "규칙 식별이 불충분한 역사명 → source detail 수동 감사 queue → open dice rules 추천."
    },
    {
      "observationId": "wt-056",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "One Big Chicken",
      "canonicalId": "one-big-chicken",
      "family": "Vocal/High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "누적 숫자와 동물 구호를 순서대로 말한다",
      "action": "지정된 반복/동작을 기억한다",
      "end": "목표 단계까지 협동한다.",
      "safeCore": "누적 숫자와 동물 구호를 순서대로 말한다 → 지정된 반복/동작을 기억한다 → 목표 단계까지 협동한다."
    },
    {
      "observationId": "wt-057",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Pennies In a Pitcher",
      "canonicalId": "coin-target",
      "family": "Coin/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-049 계열",
      "action": "동전을 빈 물 없는 목표에 던진다",
      "end": "명중 점수.",
      "safeCore": "bdg-049 계열 → 동전을 빈 물 없는 목표에 던진다 → 명중 점수."
    },
    {
      "observationId": "wt-058",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Peuchre",
      "canonicalId": "peuchre-cards",
      "family": "Card/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "지역 카드게임 이름을 보존한다",
      "action": "규칙/권리 수동 검증 전 실행하지 않는다",
      "end": "presidents 추천.",
      "safeCore": "지역 카드게임 이름을 보존한다 → 규칙/권리 수동 검증 전 실행하지 않는다 → presidents 추천."
    },
    {
      "observationId": "wt-059",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Pursuit",
      "canonicalId": "pursuit-skill",
      "family": "Skill/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "규칙 signature가 불명확한 역사 항목",
      "action": "source detail 검토 대기",
      "end": "safe skill pack 추천.",
      "safeCore": "규칙 signature가 불명확한 역사 항목 → source detail 검토 대기 → safe skill pack 추천."
    },
    {
      "observationId": "wt-060",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Quarters",
      "canonicalId": "coin-target",
      "family": "Skill/Coin/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-049 alias",
      "action": "동전 튕겨 빈 컵 목표",
      "end": "점수.",
      "safeCore": "bdg-049 alias → 동전 튕겨 빈 컵 목표 → 점수."
    },
    {
      "observationId": "wt-061",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Queens",
      "canonicalId": "queens-cards",
      "family": "Card/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "여왕 카드의 질문/팀 규칙을 정한다",
      "action": "차례로 카드를 내며 적용한다",
      "end": "손패가 끝나면 점수를 합친다.",
      "safeCore": "여왕 카드의 질문/팀 규칙을 정한다 → 차례로 카드를 내며 적용한다 → 손패가 끝나면 점수를 합친다."
    },
    {
      "observationId": "wt-062",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Questions",
      "canonicalId": "questions-only",
      "family": "Vocal/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-042 alias",
      "action": "질문만으로 즉흥 대화",
      "end": "평서문/지연 시 상대 점수.",
      "safeCore": "bdg-042 alias → 질문만으로 즉흥 대화 → 평서문/지연 시 상대 점수."
    },
    {
      "observationId": "wt-063",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Rainman",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Low",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 영화 음주 규칙 존재만 보존한다",
      "action": "일반 screen trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 영화 음주 규칙 존재만 보존한다 → 일반 screen trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-064",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Red Dwarf Drinking Game",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 기반 원형",
      "action": "일반 SF trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송 기반 원형 → 일반 SF trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-065",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Red Wings Drinking Game",
      "canonicalId": "branded-sports-bingo",
      "family": "Sports/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 팀/경기 음주 규칙",
      "action": "일반 sports bingo 추천",
      "end": "팀 상표/음주 트리거 0.",
      "safeCore": "특정 팀/경기 음주 규칙 → 일반 sports bingo 추천 → 팀 상표/음주 트리거 0."
    },
    {
      "observationId": "wt-066",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Red and Black #1",
      "canonicalId": "red-black-cards",
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "다음 카드 색을 예측한다",
      "action": "공개 후 정답 토큰을 얻는다",
      "end": "정해진 연속 목표로 끝낸다.",
      "safeCore": "다음 카드 색을 예측한다 → 공개 후 정답 토큰을 얻는다 → 정해진 연속 목표로 끝낸다."
    },
    {
      "observationId": "wt-067",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Red and Black #2",
      "canonicalId": "red-black-cards",
      "family": "Card/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "같은 canonical variant",
      "action": "streak/scoring만 변형",
      "end": "음주 결과 0.",
      "safeCore": "같은 canonical variant → streak/scoring만 변형 → 음주 결과 0."
    },
    {
      "observationId": "wt-068",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Ren and Stimpy",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 애니메이션 기반 원형",
      "action": "일반 animation trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 애니메이션 기반 원형 → 일반 animation trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-069",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Rudolph the Red Nosed Reindeer",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 작품 기반 원형",
      "action": "일반 holiday trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 작품 기반 원형 → 일반 holiday trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-070",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Russian Beer Roulette",
      "canonicalId": "hidden-container-roulette",
      "family": "Luck/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "숨긴 알코올/혼합물 섭취를 차단한다",
      "action": "식음료 러시안룰렛 0",
      "end": "숨은 색 토큰 추리 추천.",
      "safeCore": "숨긴 알코올/혼합물 섭취를 차단한다 → 식음료 러시안룰렛 0 → 숨은 색 토큰 추리 추천."
    },
    {
      "observationId": "wt-071",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "S*M*A*S*H",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 기반 원형",
      "action": "일반 screen trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송 기반 원형 → 일반 screen trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-072",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Shotgun",
      "canonicalId": "shotgun-beer",
      "family": "Speed/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "bdg-108 alias",
      "action": "캔 훼손·속주 실행 0",
      "end": "안전 대체.",
      "safeCore": "bdg-108 alias → 캔 훼손·속주 실행 0 → 안전 대체."
    },
    {
      "observationId": "wt-073",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Simpsons",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 기반 원형",
      "action": "일반 animation trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송 기반 원형 → 일반 animation trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-074",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Sink the battleship",
      "canonicalId": "floating-cup-balance",
      "family": "Skill/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-059 alias",
      "action": "물 위 빈 컵 균형",
      "end": "가라앉히면 정리 미션.",
      "safeCore": "bdg-059 alias → 물 위 빈 컵 균형 → 가라앉히면 정리 미션."
    },
    {
      "observationId": "wt-075",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Sixes",
      "canonicalId": "sixes-dice",
      "family": "Dice/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-022 alias",
      "action": "목표 6 조합 점수",
      "end": "정해진 굴림 후 비교.",
      "safeCore": "bdg-022 alias → 목표 6 조합 점수 → 정해진 굴림 후 비교."
    },
    {
      "observationId": "wt-076",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Snap",
      "canonicalId": "irish-snap",
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-009 family",
      "action": "카드/호명 일치에 중앙 신호",
      "end": "반응 점수.",
      "safeCore": "bdg-009 family → 카드/호명 일치에 중앙 신호 → 반응 점수."
    },
    {
      "observationId": "wt-077",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Speed Quarters",
      "canonicalId": "speed-quarters",
      "family": "Coin/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "두 목표에 동전을 번갈아 튕긴다",
      "action": "명중하면 토큰을 넘긴다",
      "end": "속주 없이 제한 라운드 점수로 끝낸다.",
      "safeCore": "두 목표에 동전을 번갈아 튕긴다 → 명중하면 토큰을 넘긴다 → 속주 없이 제한 라운드 점수로 끝낸다."
    },
    {
      "observationId": "wt-078",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Spinners",
      "canonicalId": "coin-spinner",
      "family": "Coin/Low",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "동전을 회전시킨다",
      "action": "멈추기 전 안전 질문에 답하거나 손 신호를 끝낸다",
      "end": "성공 점수를 얻는다.",
      "safeCore": "동전을 회전시킨다 → 멈추기 전 안전 질문에 답하거나 손 신호를 끝낸다 → 성공 점수를 얻는다."
    },
    {
      "observationId": "wt-079",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Star Trek: Deep Space 9",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송/시즌 기반 원형",
      "action": "일반 SF trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송/시즌 기반 원형 → 일반 SF trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-080",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Star Trek: The Next Generation",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/High-Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 기반 원형",
      "action": "일반 SF trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송 기반 원형 → 일반 SF trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-081",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Star Trek",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 franchise 기반 원형",
      "action": "일반 SF trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 franchise 기반 원형 → 일반 SF trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-082",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Star Wars Drinking Game",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 영화 franchise 기반 원형",
      "action": "일반 space trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 영화 franchise 기반 원형 → 일반 space trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-083",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Strange Brew",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 영화 기반 원형",
      "action": "일반 comedy trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 영화 기반 원형 → 일반 comedy trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-084",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Stripes and Solids",
      "canonicalId": "pool-table-variant",
      "family": "Other/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "당구 공 종류별 팀을 정한다",
      "action": "공식 장소 규칙대로 친다",
      "end": "포켓/파울을 점수로만 기록한다.",
      "safeCore": "당구 공 종류별 팀을 정한다 → 공식 장소 규칙대로 친다 → 포켓/파울을 점수로만 기록한다."
    },
    {
      "observationId": "wt-085",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Super Quarters",
      "canonicalId": "coin-target",
      "family": "Coin/High-Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "Quarters house variant",
      "action": "거리/목표 점수만 variant",
      "end": "빈 컵·점수 규칙.",
      "safeCore": "Quarters house variant → 거리/목표 점수만 variant → 빈 컵·점수 규칙."
    },
    {
      "observationId": "wt-086",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "TV Characters",
      "canonicalId": "character-bingo",
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "일반 캐릭터 trope 칸을 고른다",
      "action": "화면에서 나타나면 표시한다",
      "end": "한 줄 빙고로 끝낸다.",
      "safeCore": "일반 캐릭터 trope 칸을 고른다 → 화면에서 나타나면 표시한다 → 한 줄 빙고로 끝낸다."
    },
    {
      "observationId": "wt-087",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "The Jerry Springer Drinking Game",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Extra high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 음주 규칙 존재만 보존한다",
      "action": "일반 talk-show trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송 음주 규칙 존재만 보존한다 → 일반 talk-show trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-088",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "The Name Game",
      "canonicalId": "name-game",
      "family": "Vocal/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-041 alias",
      "action": "인물 설명/한 단어/몸짓 3단계",
      "end": "정답 점수.",
      "safeCore": "bdg-041 alias → 인물 설명/한 단어/몸짓 3단계 → 정답 점수."
    },
    {
      "observationId": "wt-089",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "The Tower",
      "canonicalId": "tower-dice",
      "family": "Dice/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "주사위 합으로 블록 추가/제거를 정한다",
      "action": "탑을 유지한다",
      "end": "정해진 라운드 안정성 점수.",
      "safeCore": "주사위 합으로 블록 추가/제거를 정한다 → 탑을 유지한다 → 정해진 라운드 안정성 점수."
    },
    {
      "observationId": "wt-090",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "The Vegetable Game",
      "canonicalId": "vegetable-gesture",
      "family": "Vocal/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "각자 채소 이름과 동작을 정한다",
      "action": "자기 신호 뒤 다른 신호를 호출한다",
      "end": "놓치지 않은 연속 기록.",
      "safeCore": "각자 채소 이름과 동작을 정한다 → 자기 신호 뒤 다른 신호를 호출한다 → 놓치지 않은 연속 기록."
    },
    {
      "observationId": "wt-091",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "The X-Files Drinking Game",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 방송 기반 원형",
      "action": "일반 mystery trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 방송 기반 원형 → 일반 mystery trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-092",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Thirty One",
      "canonicalId": "thirty-one-cards",
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "같은 무늬 3장의 합을 31에 가깝게 만든다",
      "action": "뽑고 버리거나 knock한다",
      "end": "최고 합이 점수를 얻는다.",
      "safeCore": "같은 무늬 3장의 합을 31에 가깝게 만든다 → 뽑고 버리거나 knock한다 → 최고 합이 점수를 얻는다."
    },
    {
      "observationId": "wt-093",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Three Man",
      "canonicalId": "three-man",
      "family": "Dice/High-Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "bdg-017 alias",
      "action": "주사위 역할/안전 액션",
      "end": "라운드 점수.",
      "safeCore": "bdg-017 alias → 주사위 역할/안전 액션 → 라운드 점수."
    },
    {
      "observationId": "wt-094",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Thumper",
      "canonicalId": "thumper",
      "family": "Vocal/Hands/Low",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-046 alias",
      "action": "개인 손동작을 이어 보낸다",
      "end": "연속 기록.",
      "safeCore": "bdg-046 alias → 개인 손동작을 이어 보낸다 → 연속 기록."
    },
    {
      "observationId": "wt-095",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Trivial Pursuit",
      "canonicalId": "licensed-board-variant",
      "family": "Board/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "상용 퀴즈 보드 변형 존재만 보존한다",
      "action": "공식판은 일반 규칙으로 플레이",
      "end": "자체 문항/보드 복제 0.",
      "safeCore": "상용 퀴즈 보드 변형 존재만 보존한다 → 공식판은 일반 규칙으로 플레이 → 자체 문항/보드 복제 0."
    },
    {
      "observationId": "wt-096",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Twenty-One Aces",
      "canonicalId": "twenty-one-aces-dice",
      "family": "Dice/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "주사위로 21에 가까운 합을 만든다",
      "action": "ace variant 효과를 선택한다",
      "end": "넘지 않은 최고 합이 승리한다.",
      "safeCore": "주사위로 21에 가까운 합을 만든다 → ace variant 효과를 선택한다 → 넘지 않은 최고 합이 승리한다."
    },
    {
      "observationId": "wt-097",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Ultimate Loser",
      "canonicalId": "ultimate-loser-cards",
      "family": "Card/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "규칙 signature/명칭 위험을 수동 감사한다",
      "action": "확인 전 실행 0",
      "end": "presidents 추천.",
      "safeCore": "규칙 signature/명칭 위험을 수동 감사한다 → 확인 전 실행 0 → presidents 추천."
    },
    {
      "observationId": "wt-098",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Up and Down the River",
      "canonicalId": "up-down-river-cards",
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "카드를 단계별로 공개해 자기 카드와 매치한다",
      "action": "올라갈 때 획득, 내려갈 때 반환 토큰을 계산한다",
      "end": "순점수로 끝낸다.",
      "safeCore": "카드를 단계별로 공개해 자기 카드와 매치한다 → 올라갈 때 획득, 내려갈 때 반환 토큰을 계산한다 → 순점수로 끝낸다."
    },
    {
      "observationId": "wt-099",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Viking",
      "canonicalId": "viking-gesture",
      "family": "Hands/Low",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "역할별 머리/노 젓기 동작을 정한다",
      "action": "호출된 사람이 다음 역할을 보낸다",
      "end": "늦지 않은 연속 기록.",
      "safeCore": "역할별 머리/노 젓기 동작을 정한다 → 호출된 사람이 다음 역할을 보낸다 → 늦지 않은 연속 기록."
    },
    {
      "observationId": "wt-100",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Waltham Rules Asshole",
      "canonicalId": "presidents",
      "family": "Card/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "Presidents의 지역·모욕적 source alias",
      "action": "public display는 중립화",
      "end": "일반 손패 비우기 규칙.",
      "safeCore": "Presidents의 지역·모욕적 source alias → public display는 중립화 → 일반 손패 비우기 규칙."
    },
    {
      "observationId": "wt-101",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Whales Tales",
      "canonicalId": "whale-tales",
      "family": "Vocal/High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "해양 단어와 동작을 정한다",
      "action": "이야기 속 키워드마다 맞는 동작을 한다",
      "end": "팀 정확도를 기록한다.",
      "safeCore": "해양 단어와 동작을 정한다 → 이야기 속 키워드마다 맞는 동작을 한다 → 팀 정확도를 기록한다."
    },
    {
      "observationId": "wt-102",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Who Shit",
      "canonicalId": "who-did-it-animals",
      "family": "Vocal/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "모욕적 source name은 provenance에만 둔다",
      "action": "각자 동물 역할을 받고 호출/반박을 이어간다",
      "end": "public display 누가 그랬지?.",
      "safeCore": "모욕적 source name은 provenance에만 둔다 → 각자 동물 역할을 받고 호출/반박을 이어간다 → public display 누가 그랬지?."
    },
    {
      "observationId": "wt-103",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Whoville X-Mas Game",
      "canonicalId": "branded-screen-game",
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "setup": "특정 작품/캐릭터 기반 원형",
      "action": "일반 holiday trope bingo 추천",
      "end": "실행 0.",
      "safeCore": "특정 작품/캐릭터 기반 원형 → 일반 holiday trope bingo 추천 → 실행 0."
    },
    {
      "observationId": "wt-104",
      "sourceCode": "wt",
      "sourceRegion": "global_english",
      "sourceName": "Wuss, Douche Bag, Fucker",
      "canonicalId": "three-role-chant-retired-name",
      "family": "Vocal/Low",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "차별·모욕 source name은 provenance에만 둔다",
      "action": "public display 세 역할 구호",
      "end": "중립 역할 3개로 호출 순서 기억 게임을 실행한다.",
      "safeCore": "차별·모욕 source name은 provenance에만 둔다 → public display 세 역할 구호 → 중립 역할 3개로 호출 순서 기억 게임을 실행한다."
    },
    {
      "observationId": "kr-001",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "단어게임",
      "canonicalId": "categories",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "주제를 뽑는다",
      "action": "제한 시간 안에 겹치지 않는 단어를 말한다",
      "end": "연속 정답을 기록한다.",
      "safeCore": "주제를 뽑는다 → 제한 시간 안에 겹치지 않는 단어를 말한다 → 연속 정답을 기록한다."
    },
    {
      "observationId": "kr-002",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "5개말해요",
      "canonicalId": "say-five",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "주제를 뽑는다",
      "action": "5초 안에 예시 5개를 말한다",
      "end": "성공 토큰을 얻고 다음으로 간다.",
      "safeCore": "주제를 뽑는다 → 5초 안에 예시 5개를 말한다 → 성공 토큰을 얻고 다음으로 간다."
    },
    {
      "observationId": "kr-003",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "가운데글자",
      "canonicalId": "middle-letter",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "앞뒤와 가운데 빈칸을 보여준다",
      "action": "가운데 글자를 채워 실제 단어를 만든다",
      "end": "유효 단어 점수를 얻는다.",
      "safeCore": "앞뒤와 가운데 빈칸을 보여준다 → 가운데 글자를 채워 실제 단어를 만든다 → 유효 단어 점수를 얻는다."
    },
    {
      "observationId": "kr-004",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "훈민게임",
      "canonicalId": "hunmin-initials",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "초성 두 개를 뽑는다",
      "action": "맞는 단어를 차례로 말한다",
      "end": "중복/시간 초과 전 연속 기록.",
      "safeCore": "초성 두 개를 뽑는다 → 맞는 단어를 차례로 말한다 → 중복/시간 초과 전 연속 기록."
    },
    {
      "observationId": "kr-005",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "O.X게임",
      "canonicalId": "ox-quiz",
      "family": "퀴즈",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "사실 문장을 읽는다",
      "action": "O/X를 동시에 고른다",
      "end": "해설과 정답 점수를 공개한다.",
      "safeCore": "사실 문장을 읽는다 → O/X를 동시에 고른다 → 해설과 정답 점수를 공개한다."
    },
    {
      "observationId": "kr-006",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "초성검색",
      "canonicalId": "initial-search",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "카테고리와 초성을 공개한다",
      "action": "가능한 단어를 먼저 입력/말한다",
      "end": "검증된 답이 점수를 얻는다.",
      "safeCore": "카테고리와 초성을 공개한다 → 가능한 단어를 먼저 입력/말한다 → 검증된 답이 점수를 얻는다."
    },
    {
      "observationId": "kr-007",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "쿵쿵따",
      "canonicalId": "three-syllable-chain",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "세 글자 단어로 시작한다",
      "action": "끝 글자로 새 세 글자 단어를 잇는다",
      "end": "중복/실수 전 기록.",
      "safeCore": "세 글자 단어로 시작한다 → 끝 글자로 새 세 글자 단어를 잇는다 → 중복/실수 전 기록."
    },
    {
      "observationId": "kr-008",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "종합퀴즈존",
      "canonicalId": "general-quiz",
      "family": "퀴즈",
      "playersMin": 1,
      "props": [],
      "playability": "playable_safe",
      "setup": "난도/주제를 고른다",
      "action": "객관식/짧은 답을 푼다",
      "end": "정답 수를 합친다.",
      "safeCore": "난도/주제를 고른다 → 객관식/짧은 답을 푼다 → 정답 수를 합친다."
    },
    {
      "observationId": "kr-009",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "이상한듣기평가",
      "canonicalId": "sound-guess",
      "family": "청각추리",
      "playersMin": 2,
      "props": [
        "음원"
      ],
      "playability": "playable_safe",
      "setup": "권리 확보 효과음을 튼다",
      "action": "무엇인지 고른다",
      "end": "정답과 자막 설명을 공개한다.",
      "safeCore": "권리 확보 효과음을 튼다 → 무엇인지 고른다 → 정답과 자막 설명을 공개한다."
    },
    {
      "observationId": "kr-010",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "영어릴레이퀴즈",
      "canonicalId": "english-word-chain",
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "시작 영어 단어를 연다",
      "action": "마지막 글자로 새 단어를 잇는다",
      "end": "중복/지연 전 기록.",
      "safeCore": "시작 영어 단어를 연다 → 마지막 글자로 새 단어를 잇는다 → 중복/지연 전 기록."
    },
    {
      "observationId": "kr-011",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "첫 소절 게임",
      "canonicalId": "song-intro-guess",
      "family": "음악추리",
      "playersMin": 2,
      "props": [
        "음원"
      ],
      "playability": "reference_only",
      "setup": "사용자 보유/권리 확보 음원만 사용한다",
      "action": "첫 짧은 구간에서 제목을 맞힌다",
      "end": "스트리밍 복제 없이 점수만 기록한다.",
      "safeCore": "사용자 보유/권리 확보 음원만 사용한다 → 첫 짧은 구간에서 제목을 맞힌다 → 스트리밍 복제 없이 점수만 기록한다."
    },
    {
      "observationId": "kr-012",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "0000년 퀴즈",
      "canonicalId": "year-quiz",
      "family": "퀴즈",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "사건/작품의 연도 질문을 연다",
      "action": "숫자를 동시에 고른다",
      "end": "가장 가까운 답이 점수를 얻는다.",
      "safeCore": "사건/작품의 연도 질문을 연다 → 숫자를 동시에 고른다 → 가장 가까운 답이 점수를 얻는다."
    },
    {
      "observationId": "kr-013",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "369게임",
      "canonicalId": "three-six-nine",
      "family": "숫자반응",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "bdg-096 alias",
      "action": "3/6/9 자릿수만큼 박수/시각 신호",
      "end": "목표 수까지 협동한다.",
      "safeCore": "bdg-096 alias → 3/6/9 자릿수만큼 박수/시각 신호 → 목표 수까지 협동한다."
    },
    {
      "observationId": "kr-014",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "무궁화게임",
      "canonicalId": "red-light-green-light",
      "family": "동작반응",
      "playersMin": 3,
      "props": [
        "공간"
      ],
      "playability": "adapted_safe",
      "setup": "안전 거리와 정지선을 정한다",
      "action": "신호가 켜질 때만 천천히 이동한다",
      "end": "접촉 없이 먼저 도달하면 승리, 앉은 버전 제공.",
      "safeCore": "안전 거리와 정지선을 정한다 → 신호가 켜질 때만 천천히 이동한다 → 접촉 없이 먼저 도달하면 승리, 앉은 버전 제공."
    },
    {
      "observationId": "kr-015",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "공기놀이",
      "canonicalId": "gonggi",
      "family": "손기술",
      "playersMin": 2,
      "props": [
        "공기돌"
      ],
      "playability": "playable_safe",
      "setup": "깨끗한 공기돌을 준비한다",
      "action": "단계별 던지기/집기를 수행한다",
      "end": "최고 완료 단계를 비교한다.",
      "safeCore": "깨끗한 공기돌을 준비한다 → 단계별 던지기/집기를 수행한다 → 최고 완료 단계를 비교한다."
    },
    {
      "observationId": "kr-016",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "제기차기",
      "canonicalId": "jegichagi",
      "family": "신체기술",
      "playersMin": 2,
      "props": [
        "제기"
      ],
      "playability": "adapted_safe",
      "setup": "안전 공간/앉은 손 버전을 고른다",
      "action": "제기를 연속으로 찬다",
      "end": "최고 기록을 비교한다.",
      "safeCore": "안전 공간/앉은 손 버전을 고른다 → 제기를 연속으로 찬다 → 최고 기록을 비교한다."
    },
    {
      "observationId": "kr-017",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "멀리날리기",
      "canonicalId": "distance-flight",
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "종이비행기"
      ],
      "playability": "adapted_safe",
      "setup": "종이비행기 등 안전 물체를 고른다",
      "action": "표시선 뒤에서 던진다",
      "end": "가장 먼 유효 착지가 승리한다.",
      "safeCore": "종이비행기 등 안전 물체를 고른다 → 표시선 뒤에서 던진다 → 가장 먼 유효 착지가 승리한다."
    },
    {
      "observationId": "kr-018",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "너프건게임",
      "canonicalId": "foam-target",
      "family": "표적",
      "playersMin": 2,
      "props": [
        "폼 블래스터"
      ],
      "playability": "adapted_safe",
      "setup": "사람 없는 과녁과 안전선을 둔다",
      "action": "폼 탄환으로 과녁을 맞힌다",
      "end": "보안경/장비 지침 충족 때만 점수화한다.",
      "safeCore": "사람 없는 과녁과 안전선을 둔다 → 폼 탄환으로 과녁을 맞힌다 → 보안경/장비 지침 충족 때만 점수화한다."
    },
    {
      "observationId": "kr-019",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "생수통세우기",
      "canonicalId": "bottle-flip",
      "family": "기술",
      "playersMin": 1,
      "props": [
        "물병"
      ],
      "playability": "playable_safe",
      "setup": "소량의 물이 든 닫힌 병을 둔다",
      "action": "한 번 회전시켜 세운다",
      "end": "제한 시도 성공 수를 센다.",
      "safeCore": "소량의 물이 든 닫힌 병을 둔다 → 한 번 회전시켜 세운다 → 제한 시도 성공 수를 센다."
    },
    {
      "observationId": "kr-020",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "고추냉이게임",
      "canonicalId": "spicy-food-roulette",
      "family": "음식위험",
      "playersMin": 2,
      "props": [
        "음식"
      ],
      "playability": "safety_blocked",
      "setup": "알레르기·자극 식품 러시안룰렛을 차단한다",
      "action": "섭취 미션 0",
      "end": "숨은 색 토큰 추리를 추천한다.",
      "safeCore": "알레르기·자극 식품 러시안룰렛을 차단한다 → 섭취 미션 0 → 숨은 색 토큰 추리를 추천한다."
    },
    {
      "observationId": "kr-021",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "아트풍선사격",
      "canonicalId": "balloon-art-target",
      "family": "표적",
      "playersMin": 2,
      "props": [
        "안전 다트",
        "풍선"
      ],
      "playability": "adapted_safe",
      "setup": "비접촉 안전 도구와 과녁을 둔다",
      "action": "지정 색 과녁을 맞힌다",
      "end": "환경/소음 조건 충족 시 점수화한다.",
      "safeCore": "비접촉 안전 도구와 과녁을 둔다 → 지정 색 과녁을 맞힌다 → 환경/소음 조건 충족 시 점수화한다."
    },
    {
      "observationId": "kr-022",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "탁구공불기게임",
      "canonicalId": "table-ball-blow",
      "family": "호흡/기술",
      "playersMin": 2,
      "props": [
        "개인 공",
        "테이블"
      ],
      "playability": "adapted_safe",
      "setup": "개인별 세척 공과 레인을 둔다",
      "action": "손 대신 바람/부채로 결승까지 보낸다",
      "end": "타액 공유 없이 먼저 도착하면 승리한다.",
      "safeCore": "개인별 세척 공과 레인을 둔다 → 손 대신 바람/부채로 결승까지 보낸다 → 타액 공유 없이 먼저 도착하면 승리한다."
    },
    {
      "observationId": "kr-023",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "스탑워치게임",
      "canonicalId": "stopwatch-target",
      "family": "시간감각",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "목표 시간을 공개한다",
      "action": "화면을 보지 않고 멈춘다",
      "end": "오차가 가장 작은 사람이 승리한다.",
      "safeCore": "목표 시간을 공개한다 → 화면을 보지 않고 멈춘다 → 오차가 가장 작은 사람이 승리한다."
    },
    {
      "observationId": "kr-024",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "잡아라 쥐돌이",
      "canonicalId": "catch-mole-rhythm",
      "family": "리듬반응",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "화면 구멍을 고른다",
      "action": "신호가 나온 칸을 탭한다",
      "end": "제한 시간 정확도/연속 기록을 겨룬다.",
      "safeCore": "화면 구멍을 고른다 → 신호가 나온 칸을 탭한다 → 제한 시간 정확도/연속 기록을 겨룬다."
    },
    {
      "observationId": "kr-025",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "마피아게임",
      "canonicalId": "mafia-local",
      "family": "사회추리",
      "playersMin": 4,
      "props": [
        "역할카드"
      ],
      "playability": "playable_safe",
      "setup": "비공개 역할을 나눈다",
      "action": "밤 행동과 낮 토론/투표를 반복한다",
      "end": "시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다.",
      "safeCore": "비공개 역할을 나눈다 → 밤 행동과 낮 토론/투표를 반복한다 → 시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다."
    },
    {
      "observationId": "kr-026",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "마피아게임2",
      "canonicalId": "odd-drawing-detective",
      "family": "그림추리",
      "playersMin": 4,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "setup": "한 사람만 다른 제시어를 받는다",
      "action": "모두 같은 횟수 선을 그린다",
      "end": "토론 뒤 다른 제시어 역할을 찾는다.",
      "safeCore": "한 사람만 다른 제시어를 받는다 → 모두 같은 횟수 선을 그린다 → 토론 뒤 다른 제시어 역할을 찾는다."
    },
    {
      "observationId": "kr-027",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "눈치게임",
      "canonicalId": "nunchi-count",
      "family": "눈치",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "순서 없이 1부터 하나씩 외친다",
      "action": "동시에 말하면 해당 라운드를 재시작한다",
      "end": "목표 수까지 협동한다.",
      "safeCore": "순서 없이 1부터 하나씩 외친다 → 동시에 말하면 해당 라운드를 재시작한다 → 목표 수까지 협동한다."
    },
    {
      "observationId": "kr-028",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "바보게임",
      "canonicalId": "opposite-answer",
      "family": "반응",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "질문 규칙을 반대로/엉뚱하게로 정한다",
      "action": "제한 시간에 규칙대로 답한다",
      "end": "정확한 반응 연속 기록.",
      "safeCore": "질문 규칙을 반대로/엉뚱하게로 정한다 → 제한 시간에 규칙대로 답한다 → 정확한 반응 연속 기록."
    },
    {
      "observationId": "kr-029",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "규칙게임",
      "canonicalId": "hidden-rule",
      "family": "추리",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "호스트가 안전한 분류 규칙을 고른다",
      "action": "참가자가 예시를 제안한다",
      "end": "규칙을 먼저 맞힌 사람이 다음 호스트다.",
      "safeCore": "호스트가 안전한 분류 규칙을 고른다 → 참가자가 예시를 제안한다 → 규칙을 먼저 맞힌 사람이 다음 호스트다."
    },
    {
      "observationId": "kr-030",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "더게임오브데스",
      "canonicalId": "pointing-chain",
      "family": "지목리듬",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "구호 뒤 모두 한 사람을 가리킨다",
      "action": "지목 수만큼 체인을 이동한다",
      "end": "선택된 사람은 다음 게임/주제/패스를 고른다.",
      "safeCore": "구호 뒤 모두 한 사람을 가리킨다 → 지목 수만큼 체인을 이동한다 → 선택된 사람은 다음 게임/주제/패스를 고른다."
    },
    {
      "observationId": "kr-031",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "좀비게임",
      "canonicalId": "zombie-safe-zone",
      "family": "공간추리",
      "playersMin": 4,
      "props": [
        "공간"
      ],
      "playability": "adapted_safe",
      "setup": "걷기만 허용하고 안전 구역을 표시한다",
      "action": "태그 대신 근거리 손 신호로 감염을 전달한다",
      "end": "제한 시간 생존 팀을 공개한다.",
      "safeCore": "걷기만 허용하고 안전 구역을 표시한다 → 태그 대신 근거리 손 신호로 감염을 전달한다 → 제한 시간 생존 팀을 공개한다."
    },
    {
      "observationId": "kr-032",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "꼼꼬미게임",
      "canonicalId": "spot-the-change",
      "family": "관찰",
      "playersMin": 3,
      "props": [
        "소품"
      ],
      "playability": "playable_safe",
      "setup": "한 사람이 안전한 소품 배치를 본다",
      "action": "눈을 감은 동안 한 가지를 바꾼다",
      "end": "변화를 맞히면 점수다.",
      "safeCore": "한 사람이 안전한 소품 배치를 본다 → 눈을 감은 동안 한 가지를 바꾼다 → 변화를 맞히면 점수다."
    },
    {
      "observationId": "kr-033",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "혼자왔습니다",
      "canonicalId": "came-alone-rhythm",
      "family": "리듬/기억",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "인원 증가 구호와 동작을 정한다",
      "action": "순서대로 누적 재현한다",
      "end": "목표 인원 단계까지 협동한다.",
      "safeCore": "인원 증가 구호와 동작을 정한다 → 순서대로 누적 재현한다 → 목표 인원 단계까지 협동한다."
    },
    {
      "observationId": "kr-034",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "카드게임",
      "canonicalId": "two-card-sum",
      "family": "카드운",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "setup": "두 장씩 뽑는다",
      "action": "합/조합을 공개한다",
      "end": "가장 높은 유효 합이 점수를 얻는다.",
      "safeCore": "두 장씩 뽑는다 → 합/조합을 공개한다 → 가장 높은 유효 합이 점수를 얻는다."
    },
    {
      "observationId": "kr-035",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "왕게임",
      "canonicalId": "king-orders-safe",
      "family": "역할/미션",
      "playersMin": 3,
      "props": [
        "카드",
        "앱"
      ],
      "playability": "adapted_safe",
      "setup": "익명 번호와 왕을 뽑는다",
      "action": "왕은 사전 검수 안전 미션만 두 번호에 제시한다",
      "end": "당사자는 패스/대체 후 왕을 교대한다.",
      "safeCore": "익명 번호와 왕을 뽑는다 → 왕은 사전 검수 안전 미션만 두 번호에 제시한다 → 당사자는 패스/대체 후 왕을 교대한다."
    },
    {
      "observationId": "kr-036",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "병뚜껑게임",
      "canonicalId": "cap-flick-number",
      "family": "기술/추리",
      "playersMin": 2,
      "props": [
        "병뚜껑"
      ],
      "playability": "adapted_safe",
      "setup": "병뚜껑을 안전 방향으로 튕긴다",
      "action": "회전/착지 숫자 또는 거리를 예측한다",
      "end": "근접 점수를 얻는다.",
      "safeCore": "병뚜껑을 안전 방향으로 튕긴다 → 회전/착지 숫자 또는 거리를 예측한다 → 근접 점수를 얻는다."
    },
    {
      "observationId": "kr-037",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "이순신게임",
      "canonicalId": "commander-signal",
      "family": "명령반응",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "setup": "함대 방향 손 신호를 정한다",
      "action": "지휘 신호에 맞는 동작을 한다",
      "end": "접촉/굴욕 명령 없이 연속 정확도를 겨룬다.",
      "safeCore": "함대 방향 손 신호를 정한다 → 지휘 신호에 맞는 동작을 한다 → 접촉/굴욕 명령 없이 연속 정확도를 겨룬다."
    },
    {
      "observationId": "kr-038",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "이구동성",
      "canonicalId": "same-word-sync",
      "family": "동시응답",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "setup": "주제/두 단서를 연다",
      "action": "신호에 동시에 한 단어를 말한다",
      "end": "같으면 팀 토큰을 얻는다.",
      "safeCore": "주제/두 단서를 연다 → 신호에 동시에 한 단어를 말한다 → 같으면 팀 토큰을 얻는다."
    },
    {
      "observationId": "kr-039",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "그림그리기",
      "canonicalId": "draw-and-guess",
      "family": "그림추리",
      "playersMin": 3,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "setup": "제시어를 한 사람에게 보여준다",
      "action": "글자 없이 그린다",
      "end": "팀이 시간 안에 맞히면 점수다.",
      "safeCore": "제시어를 한 사람에게 보여준다 → 글자 없이 그린다 → 팀이 시간 안에 맞히면 점수다."
    },
    {
      "observationId": "kr-040",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "아파트게임",
      "canonicalId": "apartment-hands",
      "family": "손/숫자",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "손을 층처럼 겹치되 접촉 없는 화면 탭 대체를 제공한다",
      "action": "호스트가 층수를 센다",
      "end": "해당 층이 다음 주제를 고른다.",
      "safeCore": "손을 층처럼 겹치되 접촉 없는 화면 탭 대체를 제공한다 → 호스트가 층수를 센다 → 해당 층이 다음 주제를 고른다."
    },
    {
      "observationId": "kr-041",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "겨드랑이게임",
      "canonicalId": "hidden-object-guess",
      "family": "신체/추리",
      "playersMin": 3,
      "props": [
        "안전소품"
      ],
      "playability": "adapted_safe",
      "setup": "source의 신체 부위 표현은 display에서 중립화한다",
      "action": "손/상자에 안전 소품을 숨긴다",
      "end": "촉감 없이 질문으로 맞힌다.",
      "safeCore": "source의 신체 부위 표현은 display에서 중립화한다 → 손/상자에 안전 소품을 숨긴다 → 촉감 없이 질문으로 맞힌다."
    },
    {
      "observationId": "kr-042",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "할머니게임",
      "canonicalId": "bundle-memory",
      "family": "기억",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "setup": "보따리 안에로 시작한다",
      "action": "각자 물건 하나를 누적한다",
      "end": "전체 순서를 목표 바퀴까지 재현한다.",
      "safeCore": "보따리 안에로 시작한다 → 각자 물건 하나를 누적한다 → 전체 순서를 목표 바퀴까지 재현한다."
    },
    {
      "observationId": "kr-043",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "자연촬영게임",
      "canonicalId": "nature-observation-bingo",
      "family": "야외관찰",
      "playersMin": 2,
      "props": [
        "카메라선택"
      ],
      "playability": "adapted_safe",
      "setup": "사람/사유지/위치 정보 없는 자연 항목을 고른다",
      "action": "촬영 대신 체크도 허용한다",
      "end": "빙고 줄을 완성한다.",
      "safeCore": "사람/사유지/위치 정보 없는 자연 항목을 고른다 → 촬영 대신 체크도 허용한다 → 빙고 줄을 완성한다."
    },
    {
      "observationId": "kr-044",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "손병호게임",
      "canonicalId": "five-fingers-statements",
      "family": "자기공개",
      "playersMin": 3,
      "props": [
        "손"
      ],
      "playability": "adapted_safe",
      "setup": "가벼운 사실 문장을 말한다",
      "action": "해당자는 손가락을 접는다",
      "end": "민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다.",
      "safeCore": "가벼운 사실 문장을 말한다 → 해당자는 손가락을 접는다 → 민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다."
    },
    {
      "observationId": "kr-045",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "타이타닉게임",
      "canonicalId": "floating-cup-balance",
      "family": "균형",
      "playersMin": 2,
      "props": [
        "물",
        "컵"
      ],
      "playability": "adapted_safe",
      "setup": "bdg-094 alias",
      "action": "물 위 컵에 물을 더한다",
      "end": "침몰은 정리 미션, 섭취 0.",
      "safeCore": "bdg-094 alias → 물 위 컵에 물을 더한다 → 침몰은 정리 미션, 섭취 0."
    },
    {
      "observationId": "kr-046",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "보물찾기",
      "canonicalId": "treasure-hunt",
      "family": "탐색",
      "playersMin": 3,
      "props": [
        "단서"
      ],
      "playability": "playable_safe",
      "setup": "허용 공간에 종이 단서를 둔다",
      "action": "팀이 순서대로 푼다",
      "end": "먼저 마지막 단서에 도달하면 승리한다.",
      "safeCore": "허용 공간에 종이 단서를 둔다 → 팀이 순서대로 푼다 → 먼저 마지막 단서에 도달하면 승리한다."
    },
    {
      "observationId": "kr-047",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "뽀뽀게임",
      "canonicalId": "consent-contact-roulette",
      "family": "무동의접촉",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "setup": "키스/신체 접촉 룰렛을 차단한다",
      "action": "실행·대상 지목 0",
      "end": "칭찬 한마디/패스 룰렛을 추천한다.",
      "safeCore": "키스/신체 접촉 룰렛을 차단한다 → 실행·대상 지목 0 → 칭찬 한마디/패스 룰렛을 추천한다."
    },
    {
      "observationId": "kr-048",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "손바닥끈끈이게임",
      "canonicalId": "palm-mirror",
      "family": "손반응",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "setup": "접촉 없이 두 손 사이 간격을 둔다",
      "action": "리더 동작을 거울처럼 따라 한다",
      "end": "정확도/동시성 점수를 얻는다.",
      "safeCore": "접촉 없이 두 손 사이 간격을 둔다 → 리더 동작을 거울처럼 따라 한다 → 정확도/동시성 점수를 얻는다."
    },
    {
      "observationId": "kr-049",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "사진피하기게임",
      "canonicalId": "camera-freeze",
      "family": "촬영/프라이버시",
      "playersMin": 2,
      "props": [
        "카메라"
      ],
      "playability": "adapted_safe",
      "setup": "저장·업로드 없이 local preview만 허용한다",
      "action": "신호 때 프레임 밖/정지 포즈를 고른다",
      "end": "즉시 삭제 후 라운드 점수만 남긴다.",
      "safeCore": "저장·업로드 없이 local preview만 허용한다 → 신호 때 프레임 밖/정지 포즈를 고른다 → 즉시 삭제 후 라운드 점수만 남긴다."
    },
    {
      "observationId": "kr-050",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "노래방점수빼기",
      "canonicalId": "karaoke-target-score",
      "family": "노래",
      "playersMin": 2,
      "props": [
        "외부기기"
      ],
      "playability": "adapted_safe",
      "setup": "목표 점수와 노래를 고른다",
      "action": "외부 노래방의 공식 점수만 입력한다",
      "end": "목표에 가장 가까운 사람이 승리한다.",
      "safeCore": "목표 점수와 노래를 고른다 → 외부 노래방의 공식 점수만 입력한다 → 목표에 가장 가까운 사람이 승리한다."
    },
    {
      "observationId": "kr-051",
      "sourceCode": "kr",
      "sourceRegion": "korea",
      "sourceName": "질문문자보내기",
      "canonicalId": "question-message",
      "family": "외부메시지/프라이버시",
      "playersMin": 2,
      "props": [
        "연락처"
      ],
      "playability": "safety_blocked",
      "setup": "제3자에게 무단 메시지를 보내는 원형을 차단한다",
      "action": "연락처 접근·전송 0",
      "end": "방 안 익명 질문 카드로 대체한다.",
      "safeCore": "제3자에게 무단 메시지를 보내는 원형을 차단한다 → 연락처 접근·전송 0 → 방 안 익명 질문 카드로 대체한다."
    }
  ],
  "games": [
    {
      "canonicalId": "one-two-three-dice",
      "displayName": "1-2-3",
      "aliases": [],
      "searchAliases": [
        "1-2-3"
      ],
      "family": "Dice/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "주사위 3개의 순서를 예측한다",
        "action": "공개 조합으로 점수를 계산한다",
        "end": "최고 점수가 승리한다."
      },
      "sourceObservationIds": [
        "wt-001"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "1-2-3",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "1-2-3는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주사위 3개의 순서를 예측한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 주사위 3개의 순서를 예측한다",
            "hostCue": "‘준비: 주사위 3개의 순서를 예측한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘최고 점수가 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 최고 점수가 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공개 조합으로 점수를 계산한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공개 조합으로 점수를 계산한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "최고 점수가 승리한다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 최고 점수가 승리한다.’"
          }
        ],
        "example": {
          "title": "1-2-3 한 차례 예시",
          "lines": [
            "실제 행동: 공개 조합으로 점수를 계산한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "1-2-3 · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "1-2-3 · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "1-2-3 · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "1-2-3 · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "1-2-3 · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "1-2-3 · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "최고 점수가 승리한다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "three-six-nine",
      "displayName": "3·6·9",
      "aliases": [],
      "searchAliases": [
        "3-6-9",
        "369게임"
      ],
      "family": "숫자반응",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "숫자를 순서대로 센다",
        "action": "3/6/9가 든 횟수만큼 박수/시각 신호를 낸다",
        "end": "목표까지 팀 성공을 노린다."
      },
      "sourceObservationIds": [
        "bdg-096",
        "kr-013"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "1부터 20까지 숫자를 이어 가며 3·6·9가 들어간 숫자에서는 그 개수만큼 박수를 고른다.",
        "fun": "숫자와 박수를 바꿔야 하는 순간의 빠른 판단",
        "firstAction": "1번이 화면의 ‘숫자 1’을 눌러 첫 차례를 넘긴다.",
        "reward": "도달한 숫자와 박수 정답 기록",
        "durationSec": 45,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english",
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "3·6·9",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "3·6·9는 1부터 20까지 숫자를 이어 가며 3·6·9가 들어간 숫자에서는 그 개수만큼 박수를 고른다. 숫자와 박수를 바꿔야 하는 순간의 빠른 판단을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "숫자를 순서대로 센다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 숫자를 순서대로 센다",
            "hostCue": "‘준비: 숫자를 순서대로 센다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 1부터 20까지 숫자를 이어 가며 3·6·9가 들어간 숫자에서는 그 개수만큼 박수를 고른다. 라운드의 끝은 ‘목표까지 팀 성공을 노린다.’입니다.",
            "hostCue": "‘성공 조건: 목표까지 팀 성공을 노린다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 1번이 화면의 ‘숫자 1’을 눌러 첫 차례를 넘긴다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "3/6/9가 든 횟수만큼 박수/시각 신호를 낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 3/6/9가 든 횟수만큼 박수/시각 신호를 낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표까지 팀 성공을 노린다. 앱은 도달한 숫자와 박수 정답 기록을 보여 줍니다.",
            "hostCue": "‘끝: 목표까지 팀 성공을 노린다.’"
          }
        ],
        "example": {
          "title": "3·6·9 한 차례 예시",
          "lines": [
            "실제 행동: 3/6/9가 든 횟수만큼 박수/시각 신호를 낸다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "3·6·9 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "3·6·9 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "3·6·9 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "3·6·9 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "3·6·9 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "3·6·9 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "목표까지 팀 성공을 노린다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "baskin-31",
      "displayName": "31 숫자게임",
      "aliases": [],
      "searchAliases": [
        "Baskin Robbins 31"
      ],
      "family": "숫자전략",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "차례에 숫자 1~3개를 이어 말한다",
        "action": "31을 말한 사람이 라운드 선택권을 넘긴다",
        "end": "목표 수 변형 규칙를 지원한다."
      },
      "sourceObservationIds": [
        "bdg-095"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "차례마다 숫자 1~3개를 이어 말하고 31을 말한 사람에서 판을 끝낸다.",
        "fun": "상대가 31을 말하게 만들기 위해 숫자 개수를 고르는 눈치 싸움",
        "firstAction": "첫 사람이 1개·2개·3개 중 이어 말할 숫자 개수를 고른다.",
        "reward": "31까지의 실제 숫자 흐름과 마지막 차례",
        "durationSec": 50,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "31 숫자게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "31 숫자게임은 차례마다 숫자 1~3개를 이어 말하고 31을 말한 사람에서 판을 끝낸다. 상대가 31을 말하게 만들기 위해 숫자 개수를 고르는 눈치 싸움을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "차례에 숫자 1~3개를 이어 말한다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 차례에 숫자 1~3개를 이어 말한다",
            "hostCue": "‘준비: 차례에 숫자 1~3개를 이어 말한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 차례마다 숫자 1~3개를 이어 말하고 31을 말한 사람에서 판을 끝낸다. 라운드의 끝은 ‘목표 수 변형 규칙를 지원한다.’입니다.",
            "hostCue": "‘성공 조건: 목표 수 변형 규칙를 지원한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 첫 사람이 1개·2개·3개 중 이어 말할 숫자 개수를 고른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "31을 말한 사람이 라운드 선택권을 넘긴다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 31을 말한 사람이 라운드 선택권을 넘긴다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표 수 변형 규칙를 지원한다. 앱은 31까지의 실제 숫자 흐름과 마지막 차례를 보여 줍니다.",
            "hostCue": "‘끝: 목표 수 변형 규칙를 지원한다.’"
          }
        ],
        "example": {
          "title": "31 숫자게임 한 차례 예시",
          "lines": [
            "실제 행동: 31을 말한 사람이 라운드 선택권을 넘긴다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "31 숫자게임 · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "31 숫자게임 · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "31 숫자게임 · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "31 숫자게임 · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "31 숫자게임 · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "31 숫자게임 · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "목표 수 변형 규칙를 지원한다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "say-five",
      "displayName": "5개말해요",
      "aliases": [],
      "searchAliases": [
        "5개말해요"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "주제를 뽑는다",
        "action": "5초 안에 예시 5개를 말한다",
        "end": "성공 토큰을 얻고 다음으로 간다."
      },
      "sourceObservationIds": [
        "kr-002"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "5개말해요",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "5개말해요는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주제를 뽑는다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 주제를 뽑는다",
            "hostCue": "‘준비: 주제를 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘성공 토큰을 얻고 다음으로 간다.’입니다.",
            "hostCue": "‘성공 조건: 성공 토큰을 얻고 다음으로 간다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "5초 안에 예시 5개를 말한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 5초 안에 예시 5개를 말한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "성공 토큰을 얻고 다음으로 간다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 성공 토큰을 얻고 다음으로 간다.’"
          }
        ],
        "example": {
          "title": "5개말해요 한 차례 예시",
          "lines": [
            "실제 행동: 5초 안에 예시 5개를 말한다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "5개말해요 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "5개말해요 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "5개말해요 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "5개말해요 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "5개말해요 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "5개말해요 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "성공 토큰을 얻고 다음으로 간다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "seven-eleven-doubles",
      "displayName": "7-11-Doubles",
      "aliases": [],
      "searchAliases": [
        "7-11-Doubles"
      ],
      "family": "주사위",
      "playersMin": 3,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "7·11·더블을 목표로 굴린다",
        "action": "성공 시 다음 플레이어/미션을 고른다",
        "end": "토큰을 먼저 모으면 이긴다."
      },
      "sourceObservationIds": [
        "bdg-018"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "7-11-Doubles",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "7-11-Doubles는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "7·11·더블을 목표로 굴린다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 7·11·더블을 목표로 굴린다",
            "hostCue": "‘준비: 7·11·더블을 목표로 굴린다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘토큰을 먼저 모으면 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 토큰을 먼저 모으면 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "성공 시 다음 플레이어/미션을 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 성공 시 다음 플레이어/미션을 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "토큰을 먼저 모으면 이긴다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 토큰을 먼저 모으면 이긴다.’"
          }
        ],
        "example": {
          "title": "7-11-Doubles 한 차례 예시",
          "lines": [
            "실제 행동: 성공 시 다음 플레이어/미션을 고른다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "7-11-Doubles · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "7-11-Doubles · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "7-11-Doubles · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "7-11-Doubles · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "7-11-Doubles · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "7-11-Doubles · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "토큰을 먼저 모으면 이긴다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "middle-letter",
      "displayName": "가운데글자",
      "aliases": [],
      "searchAliases": [
        "가운데글자"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "앞뒤와 가운데 빈칸을 보여준다",
        "action": "가운데 글자를 채워 실제 단어를 만든다",
        "end": "유효 단어 점수를 얻는다."
      },
      "sourceObservationIds": [
        "kr-003"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "가운데글자",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "가운데글자는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "앞뒤와 가운데 빈칸을 보여준다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 앞뒤와 가운데 빈칸을 보여준다",
            "hostCue": "‘준비: 앞뒤와 가운데 빈칸을 보여준다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘유효 단어 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 유효 단어 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "가운데 글자를 채워 실제 단어를 만든다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 가운데 글자를 채워 실제 단어를 만든다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "유효 단어 점수를 얻는다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 유효 단어 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "가운데글자 한 차례 예시",
          "lines": [
            "실제 행동: 가운데 글자를 채워 실제 단어를 만든다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "가운데글자 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "가운데글자 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "가운데글자 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "가운데글자 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "가운데글자 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "가운데글자 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "유효 단어 점수를 얻는다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "same-word-sync",
      "displayName": "같은 마음",
      "aliases": [],
      "searchAliases": [
        "이구동성"
      ],
      "family": "동시응답",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "주제/두 단서를 연다",
        "action": "신호에 동시에 한 단어를 말한다",
        "end": "같으면 팀 토큰을 얻는다."
      },
      "sourceObservationIds": [
        "kr-038"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "3~8명이 같은 질문에 답을 숨겨 고른 뒤, 모두의 선택 분포가 얼마나 같은지 확인한다.",
        "fun": "친구의 답을 따라 고를 수 없는 상태에서 마지막에 예상 밖의 같은 마음이 드러나는 순간",
        "firstAction": "인원을 정하고 1번만 화면을 본 상태에서 세 선택지 중 하나를 고른 뒤 화면을 덮어 넘긴다.",
        "reward": "모두가 고른 뒤 공개되는 세 선택지의 실제 분포와 가장 많이 겹친 답",
        "durationSec": 55,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "같은 마음",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "같은 마음은 3~8명이 같은 질문에 답을 숨겨 고른 뒤, 모두의 선택 분포가 얼마나 같은지 확인한다. 친구의 답을 따라 고를 수 없는 상태에서 마지막에 예상 밖의 같은 마음이 드러나는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주제/두 단서를 연다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 주제/두 단서를 연다",
            "hostCue": "‘준비: 주제/두 단서를 연다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 3~8명이 같은 질문에 답을 숨겨 고른 뒤, 모두의 선택 분포가 얼마나 같은지 확인한다. 라운드의 끝은 ‘같으면 팀 토큰을 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 같으면 팀 토큰을 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 인원을 정하고 1번만 화면을 본 상태에서 세 선택지 중 하나를 고른 뒤 화면을 덮어 넘긴다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "신호에 동시에 한 단어를 말한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 신호에 동시에 한 단어를 말한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "같으면 팀 토큰을 얻는다. 앱은 모두가 고른 뒤 공개되는 세 선택지의 실제 분포와 가장 많이 겹친 답을 보여 줍니다.",
            "hostCue": "‘끝: 같으면 팀 토큰을 얻는다.’"
          }
        ],
        "example": {
          "title": "같은 마음 한 차례 예시",
          "lines": [
            "실제 행동: 신호에 동시에 한 단어를 말한다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "같은 마음 · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "같은 마음 · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "같은 마음 · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "같은 마음 · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "같은 마음 · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "같은 마음 · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "같으면 팀 토큰을 얻는다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "bouncing-ball-chant",
      "displayName": "공 튕기기 구호",
      "aliases": [],
      "searchAliases": [
        "Bouncing Ball"
      ],
      "family": "Vocal/Medium",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "원을 만들고 가상의 공을 1번부터 시작한다",
        "action": "WHIZ는 다음 사람, BOUNCE는 한 사람 건너뛰기, BOING은 진행 방향을 뒤집는다",
        "end": "실수 없이 10회 연속 패스하면 함께 성공한다."
      },
      "sourceObservationIds": [
        "wt-022"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "digital",
        "goal": "WHIZ·BOUNCE·BOING을 골라 가상의 공을 알맞은 사람에게 보내고, 열 번 끊기지 않게 이어 간다.",
        "fun": "한 단어로 순서가 건너뛰거나 뒤집히는 순간",
        "firstAction": "원을 만들고 각자 번호를 확인한 뒤, 1번이 ‘WHIZ’를 외치고 화면의 WHIZ를 누른다.",
        "reward": "현재 차례·진행 방향·최고 이어가기 기록",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "공 튕기기 구호",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "말로 가상의 공을 돌리는 원형 게임입니다. WHIZ(위즈)는 옆 사람, BOUNCE(바운스)는 한 사람 건너, BOING(보잉)은 방향을 바꾼 뒤 옆 사람에게 보냅니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 공을 가진 자리·진행 방향·연속 기록을 표시합니다. 실제 공이나 별도 진행자는 필요 없습니다.",
        "setupChecklist": [
          "3~8명이 원을 만들고 화면에서 자기 자리 번호를 확인합니다.",
          "시계 방향 1번부터 시작하고 세 단어 WHIZ·BOUNCE·BOING을 함께 한 번 읽습니다.",
          "휴대폰을 모두가 볼 수 있는 가운데에 놓습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "자리를 정해요",
            "instruction": "원을 만들고 화면의 1번·2번·3번 순서와 현재 방향 화살표를 확인합니다.",
            "hostCue": "‘지금 공은 1번, 방향은 시계 방향이에요.’"
          },
          {
            "id": "learn",
            "title": "세 단어만 기억해요",
            "instruction": "WHIZ(위즈)는 옆 사람, BOUNCE(바운스)는 한 사람 건너, BOING(보잉)은 방향을 바꾼 뒤 옆 사람에게 공을 보냅니다.",
            "hostCue": "‘위즈는 옆으로, 바운스는 한 명 건너, 보잉은 방향 바꾸기.’"
          },
          {
            "id": "practice",
            "title": "한 번 연습해요",
            "instruction": "1번이 WHIZ를 말하고 화면의 WHIZ를 눌러 공이 2번으로 이동하는지 봅니다.",
            "hostCue": "‘1번이 위즈!’"
          },
          {
            "id": "play",
            "title": "말한 단어를 눌러요",
            "instruction": "현재 사람이 세 단어 중 하나를 외친 직후 같은 버튼을 누릅니다. 화면이 다음 사람과 방향을 계산합니다.",
            "hostCue": "‘화면에 표시된 사람만 말하고 눌러 주세요.’"
          },
          {
            "id": "finish",
            "title": "열 번 이어지면 성공",
            "instruction": "순서가 헷갈리면 ‘순서가 헷갈렸어요’를 누릅니다. 현재 차례는 유지하고 이어가기 숫자만 0으로 돌아갑니다.",
            "hostCue": "‘틀려도 누구 탓인지 정하지 않고, 지금 차례부터 다시 이어 가요.’"
          }
        ],
        "example": {
          "title": "4명이 한 차례 돌리는 예시",
          "lines": [
            "1번 WHIZ → 2번",
            "2번 BOUNCE → 4번(3번 건너뜀)",
            "4번 BOING → 방향이 반대로 바뀌고 3번",
            "3번 WHIZ → 2번"
          ]
        },
        "rounds": [
          {
            "title": "Bouncing Ball · 1라운드",
            "prompt": "WHIZ로 다음 사람",
            "options": [
              "WHIZ",
              "BOUNCE",
              "BOING"
            ],
            "reveal": "화면이 현재 공의 자리와 진행 방향을 바로 계산합니다."
          },
          {
            "title": "Bouncing Ball · 2라운드",
            "prompt": "BOUNCE로 한 사람 건너뛰기",
            "options": [
              "WHIZ",
              "BOUNCE",
              "BOING"
            ],
            "reveal": "화면이 현재 공의 자리와 진행 방향을 바로 계산합니다."
          },
          {
            "title": "Bouncing Ball · 3라운드",
            "prompt": "BOING으로 방향 뒤집기",
            "options": [
              "WHIZ",
              "BOUNCE",
              "BOING"
            ],
            "reveal": "화면이 현재 공의 자리와 진행 방향을 바로 계산합니다."
          },
          {
            "title": "Bouncing Ball · 4라운드",
            "prompt": "WHIZ 두 번 이어 보기",
            "options": [
              "WHIZ",
              "BOUNCE",
              "BOING"
            ],
            "reveal": "화면이 현재 공의 자리와 진행 방향을 바로 계산합니다."
          },
          {
            "title": "Bouncing Ball · 5라운드",
            "prompt": "BOUNCE 뒤 BOING",
            "options": [
              "WHIZ",
              "BOUNCE",
              "BOING"
            ],
            "reveal": "화면이 현재 공의 자리와 진행 방향을 바로 계산합니다."
          },
          {
            "title": "Bouncing Ball · 6라운드",
            "prompt": "10회 연속 도전",
            "options": [
              "WHIZ",
              "BOUNCE",
              "BOING"
            ],
            "reveal": "화면이 현재 공의 자리와 진행 방향을 바로 계산합니다."
          }
        ],
        "practice": {
          "instruction": "1번 차례에서 WHIZ(위즈)를 눌러 공을 2번으로 보내 보세요.",
          "actionLabel": "WHIZ 연습",
          "success": "공이 옆 사람에게 이동했어요. BOUNCE와 BOING도 말한 뒤 같은 버튼을 누르면 됩니다."
        },
        "winCondition": "가상의 공을 열 번 끊기지 않게 넘기면 모두 함께 성공합니다.",
        "tip": "사람 이름 대신 화면의 자리 번호로 먼저 익히면 처음 하는 모임에서도 덜 헷갈립니다.",
        "recovery": "누가 차례인지 놓치면 ‘지금 외칠 사람’을 확인하고, 현재 차례는 유지한 채 이어가기 숫자만 0으로 되돌립니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "WHIZ · 다음",
            "BOUNCE · 건너뜀",
            "BOING · 반대 방향",
            "10회 연속"
          ]
        }
      }
    },
    {
      "canonicalId": "gonggi",
      "displayName": "공기놀이",
      "aliases": [],
      "searchAliases": [
        "공기놀이"
      ],
      "family": "손기술",
      "playersMin": 2,
      "props": [
        "공기돌"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "깨끗한 공기돌을 준비한다",
        "action": "단계별 던지기/집기를 수행한다",
        "end": "최고 완료 단계를 비교한다."
      },
      "sourceObservationIds": [
        "kr-015"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "공기놀이",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "공기놀이는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "깨끗한 공기돌을 준비한다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 깨끗한 공기돌을 준비한다",
            "hostCue": "‘준비: 깨끗한 공기돌을 준비한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘최고 완료 단계를 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 최고 완료 단계를 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "단계별 던지기/집기를 수행한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 단계별 던지기/집기를 수행한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "최고 완료 단계를 비교한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 최고 완료 단계를 비교한다.’"
          }
        ],
        "example": {
          "title": "공기놀이 한 차례 예시",
          "lines": [
            "실제 행동: 단계별 던지기/집기를 수행한다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "공기놀이 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "공기놀이 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "공기놀이 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "공기놀이 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "공기놀이 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "공기놀이 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "최고 완료 단계를 비교한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "hidden-rule",
      "displayName": "규칙게임",
      "aliases": [],
      "searchAliases": [
        "규칙게임"
      ],
      "family": "추리",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "호스트가 안전한 분류 규칙을 고른다",
        "action": "참가자가 예시를 제안한다",
        "end": "규칙을 먼저 맞힌 사람이 다음 호스트다."
      },
      "sourceObservationIds": [
        "kr-029"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "규칙게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "규칙게임은 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "호스트가 안전한 분류 규칙을 고른다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 호스트가 안전한 분류 규칙을 고른다",
            "hostCue": "‘준비: 호스트가 안전한 분류 규칙을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘규칙을 먼저 맞힌 사람이 다음 호스트다.’입니다.",
            "hostCue": "‘성공 조건: 규칙을 먼저 맞힌 사람이 다음 호스트다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "참가자가 예시를 제안한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 참가자가 예시를 제안한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "규칙을 먼저 맞힌 사람이 다음 호스트다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 규칙을 먼저 맞힌 사람이 다음 호스트다.’"
          }
        ],
        "example": {
          "title": "규칙게임 한 차례 예시",
          "lines": [
            "실제 행동: 참가자가 예시를 제안한다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "규칙게임 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "규칙게임 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "규칙게임 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "규칙게임 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "규칙게임 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "규칙게임 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "규칙을 먼저 맞힌 사람이 다음 호스트다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "draw-and-guess",
      "displayName": "그림그리기",
      "aliases": [],
      "searchAliases": [
        "그림그리기"
      ],
      "family": "그림추리",
      "playersMin": 3,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "제시어를 한 사람에게 보여준다",
        "action": "글자 없이 그린다",
        "end": "팀이 시간 안에 맞히면 점수다."
      },
      "sourceObservationIds": [
        "kr-039"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "그림그리기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "그림그리기는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "제시어를 한 사람에게 보여준다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 제시어를 한 사람에게 보여준다",
            "hostCue": "‘준비: 제시어를 한 사람에게 보여준다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘팀이 시간 안에 맞히면 점수다.’입니다.",
            "hostCue": "‘성공 조건: 팀이 시간 안에 맞히면 점수다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "글자 없이 그린다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 글자 없이 그린다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "팀이 시간 안에 맞히면 점수다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 팀이 시간 안에 맞히면 점수다.’"
          }
        ],
        "example": {
          "title": "그림그리기 한 차례 예시",
          "lines": [
            "실제 행동: 글자 없이 그린다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "그림그리기 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "그림그리기 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "그림그리기 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "그림그리기 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "그림그리기 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "그림그리기 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "팀이 시간 안에 맞히면 점수다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "spot-the-change",
      "displayName": "꼼꼬미게임",
      "aliases": [],
      "searchAliases": [
        "꼼꼬미게임"
      ],
      "family": "관찰",
      "playersMin": 3,
      "props": [
        "소품"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "한 사람이 안전한 소품 배치를 본다",
        "action": "눈을 감은 동안 한 가지를 바꾼다",
        "end": "변화를 맞히면 점수다."
      },
      "sourceObservationIds": [
        "kr-032"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "꼼꼬미게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "꼼꼬미게임은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "한 사람이 안전한 소품 배치를 본다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 한 사람이 안전한 소품 배치를 본다",
            "hostCue": "‘준비: 한 사람이 안전한 소품 배치를 본다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘변화를 맞히면 점수다.’입니다.",
            "hostCue": "‘성공 조건: 변화를 맞히면 점수다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "눈을 감은 동안 한 가지를 바꾼다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 눈을 감은 동안 한 가지를 바꾼다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "변화를 맞히면 점수다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 변화를 맞히면 점수다.’"
          }
        ],
        "example": {
          "title": "꼼꼬미게임 한 차례 예시",
          "lines": [
            "실제 행동: 눈을 감은 동안 한 가지를 바꾼다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "꼼꼬미게임 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "꼼꼬미게임 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "꼼꼬미게임 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "꼼꼬미게임 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "꼼꼬미게임 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "꼼꼬미게임 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "변화를 맞히면 점수다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "foam-target",
      "displayName": "너프건게임",
      "aliases": [],
      "searchAliases": [
        "너프건게임"
      ],
      "family": "표적",
      "playersMin": 2,
      "props": [
        "폼 블래스터"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "사람 없는 과녁과 안전선을 둔다",
        "action": "폼 탄환으로 과녁을 맞힌다",
        "end": "보안경/장비 지침 충족 때만 점수화한다."
      },
      "sourceObservationIds": [
        "kr-018"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "너프건게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "너프건게임은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "사람 없는 과녁과 안전선을 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 사람 없는 과녁과 안전선을 둔다",
            "hostCue": "‘준비: 사람 없는 과녁과 안전선을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘보안경/장비 지침 충족 때만 점수화한다.’입니다.",
            "hostCue": "‘성공 조건: 보안경/장비 지침 충족 때만 점수화한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "폼 탄환으로 과녁을 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 폼 탄환으로 과녁을 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "보안경/장비 지침 충족 때만 점수화한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 보안경/장비 지침 충족 때만 점수화한다.’"
          }
        ],
        "example": {
          "title": "너프건게임 한 차례 예시",
          "lines": [
            "실제 행동: 폼 탄환으로 과녁을 맞힌다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "너프건게임 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "너프건게임 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "너프건게임 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "너프건게임 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "너프건게임 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "너프건게임 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "보안경/장비 지침 충족 때만 점수화한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "karaoke-target-score",
      "displayName": "노래방점수빼기",
      "aliases": [],
      "searchAliases": [
        "노래방점수빼기"
      ],
      "family": "노래",
      "playersMin": 2,
      "props": [
        "외부기기"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "목표 점수와 노래를 고른다",
        "action": "외부 노래방의 공식 점수만 입력한다",
        "end": "목표에 가장 가까운 사람이 승리한다."
      },
      "sourceObservationIds": [
        "kr-050"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "performance",
        "mode": "hosted",
        "goal": "그림·몸짓·소리·연기로 팀이 답을 맞히게 한다.",
        "fun": "엉뚱한 표현과 극적인 정답",
        "firstAction": "표현할 사람과 첫 제시어를 정한다.",
        "reward": "맞힌 수와 관객 반응",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "노래방점수빼기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "노래방점수빼기는 그림·몸짓·소리·연기로 팀이 답을 맞히게 한다. 엉뚱한 표현과 극적인 정답을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 제시어·표현 시간·정답 수를 관리합니다. 다른 제시어 앱이나 메모가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "목표 점수와 노래를 고른다",
          "앱이 제시어·표현 시간·정답 수를 관리합니다. 다른 제시어 앱이나 메모가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 목표 점수와 노래를 고른다",
            "hostCue": "‘준비: 목표 점수와 노래를 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 그림·몸짓·소리·연기로 팀이 답을 맞히게 한다. 라운드의 끝은 ‘목표에 가장 가까운 사람이 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 목표에 가장 가까운 사람이 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 제시어를 보고 말하지 않고 몸짓 또는 소리로 5초 동안 표현하세요.",
            "hostCue": "‘연습만 한 번: 표현할 사람과 첫 제시어를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "외부 노래방의 공식 점수만 입력한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 외부 노래방의 공식 점수만 입력한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표에 가장 가까운 사람이 승리한다. 앱은 맞힌 수와 관객 반응을 보여 줍니다.",
            "hostCue": "‘끝: 목표에 가장 가까운 사람이 승리한다.’"
          }
        ],
        "example": {
          "title": "노래방점수빼기 한 차례 예시",
          "lines": [
            "실제 행동: 외부 노래방의 공식 점수만 입력한다",
            "표현자만 연습 제시어 ‘고양이’ 확인",
            "말 없이 수염·발 동작 표현",
            "다른 사람이 답을 외침"
          ]
        },
        "rounds": [
          {
            "title": "노래방점수빼기 · 1라운드",
            "prompt": "표현 제시어: 양치하기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "노래방점수빼기 · 2라운드",
            "prompt": "표현 제시어: 버스 놓치기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "노래방점수빼기 · 3라운드",
            "prompt": "표현 제시어: 사진 찍기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "노래방점수빼기 · 4라운드",
            "prompt": "표현 제시어: 요리하기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "노래방점수빼기 · 5라운드",
            "prompt": "표현 제시어: 길 찾기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "노래방점수빼기 · 6라운드",
            "prompt": "표현 제시어: 선물 열기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 제시어를 보고 말하지 않고 몸짓 또는 소리로 5초 동안 표현하세요.",
          "actionLabel": "표현 연습",
          "success": "표현자와 맞히는 사람의 역할을 익혔어요."
        },
        "winCondition": "목표에 가장 가까운 사람이 승리한다.",
        "tip": "외모·장애·억양을 흉내 내지 않고 사물·동물·행동 중심 제시어를 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "stage",
          "labels": [
            "제시어",
            "표현",
            "추측",
            "정답"
          ]
        }
      }
    },
    {
      "canonicalId": "who-did-it-animals",
      "displayName": "누가 그랬지?",
      "aliases": [],
      "searchAliases": [
        "Who Shit"
      ],
      "family": "Vocal/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "모욕적 수집 이름은 출처 기록에만 둔다",
        "action": "각자 동물 역할을 받고 호출/반박을 이어간다",
        "end": "공개 화면 누가 그랬지?."
      },
      "sourceObservationIds": [
        "wt-102"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "누가 그랬지?",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "누가 그랬지?는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "모욕적 수집 이름은 출처 기록에만 둔다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 모욕적 수집 이름은 출처 기록에만 둔다",
            "hostCue": "‘준비: 모욕적 수집 이름은 출처 기록에만 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘공개 화면 누가 그랬지?.’입니다.",
            "hostCue": "‘성공 조건: 공개 화면 누가 그랬지?.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "각자 동물 역할을 받고 호출/반박을 이어간다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 각자 동물 역할을 받고 호출/반박을 이어간다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "공개 화면 누가 그랬지?. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 공개 화면 누가 그랬지?.’"
          }
        ],
        "example": {
          "title": "누가 그랬지? 한 차례 예시",
          "lines": [
            "실제 행동: 각자 동물 역할을 받고 호출/반박을 이어간다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "누가 그랬지? · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "누가 그랬지? · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "누가 그랬지? · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "누가 그랬지? · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "누가 그랬지? · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "누가 그랬지? · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "공개 화면 누가 그랬지?.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "nunchi-count",
      "displayName": "눈치 숫자게임",
      "aliases": [],
      "searchAliases": [
        "눈치게임"
      ],
      "family": "눈치",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "순서 없이 1부터 하나씩 외친다",
        "action": "동시에 말하면 해당 라운드를 재시작한다",
        "end": "목표 수까지 협동한다."
      },
      "sourceObservationIds": [
        "kr-027"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "순서를 정하지 않고 1부터 인원수까지 겹치지 않게 숫자를 이어 말한다.",
        "fun": "누가 먼저 누를지 모르는 짧은 긴장과 동시 입력",
        "firstAction": "각자 자기 번호 버튼을 정한 뒤 눈치껏 한 명이 먼저 누른다.",
        "reward": "충돌 없이 이어 간 숫자와 완주 기록",
        "durationSec": 40,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "눈치 숫자게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "눈치 숫자게임은 순서를 정하지 않고 1부터 인원수까지 겹치지 않게 숫자를 이어 말한다. 누가 먼저 누를지 모르는 짧은 긴장과 동시 입력을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "순서 없이 1부터 하나씩 외친다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 순서 없이 1부터 하나씩 외친다",
            "hostCue": "‘준비: 순서 없이 1부터 하나씩 외친다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 순서를 정하지 않고 1부터 인원수까지 겹치지 않게 숫자를 이어 말한다. 라운드의 끝은 ‘목표 수까지 협동한다.’입니다.",
            "hostCue": "‘성공 조건: 목표 수까지 협동한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 각자 자기 번호 버튼을 정한 뒤 눈치껏 한 명이 먼저 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동시에 말하면 해당 라운드를 재시작한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동시에 말하면 해당 라운드를 재시작한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표 수까지 협동한다. 앱은 충돌 없이 이어 간 숫자와 완주 기록을 보여 줍니다.",
            "hostCue": "‘끝: 목표 수까지 협동한다.’"
          }
        ],
        "example": {
          "title": "눈치 숫자게임 한 차례 예시",
          "lines": [
            "실제 행동: 동시에 말하면 해당 라운드를 재시작한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "눈치 숫자게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "눈치 숫자게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "눈치 숫자게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "눈치 숫자게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "눈치 숫자게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "눈치 숫자게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "목표 수까지 협동한다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "presidents",
      "displayName": "대통령 카드",
      "aliases": [],
      "searchAliases": [
        "Asshole",
        "Presidents",
        "Waltham Rules Asshole"
      ],
      "family": "카드전략",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "손패를 나눈다",
        "action": "이전보다 강한 조합을 내거나 패스한다",
        "end": "먼저 손을 비우면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-007",
        "wt-003",
        "wt-100"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "대통령 카드",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "대통령 카드는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "손패를 나눈다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 손패를 나눈다",
            "hostCue": "‘준비: 손패를 나눈다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘먼저 손을 비우면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 먼저 손을 비우면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "이전보다 강한 조합을 내거나 패스한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 이전보다 강한 조합을 내거나 패스한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "먼저 손을 비우면 승리한다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 먼저 손을 비우면 승리한다.’"
          }
        ],
        "example": {
          "title": "대통령 카드 한 차례 예시",
          "lines": [
            "실제 행동: 이전보다 강한 조합을 내거나 패스한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "대통령 카드 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "대통령 카드 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "대통령 카드 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "대통령 카드 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "대통령 카드 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "대통령 카드 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "먼저 손을 비우면 승리한다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "pointing-chain",
      "displayName": "더게임오브데스",
      "aliases": [],
      "searchAliases": [
        "더게임오브데스"
      ],
      "family": "지목리듬",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "구호 뒤 모두 한 사람을 가리킨다",
        "action": "지목 수만큼 체인을 이동한다",
        "end": "선택된 사람은 다음 게임/주제/패스를 고른다."
      },
      "sourceObservationIds": [
        "kr-030"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "더게임오브데스",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "더게임오브데스는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "구호 뒤 모두 한 사람을 가리킨다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 구호 뒤 모두 한 사람을 가리킨다",
            "hostCue": "‘준비: 구호 뒤 모두 한 사람을 가리킨다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘선택된 사람은 다음 게임/주제/패스를 고른다.’입니다.",
            "hostCue": "‘성공 조건: 선택된 사람은 다음 게임/주제/패스를 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "지목 수만큼 체인을 이동한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 지목 수만큼 체인을 이동한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "선택된 사람은 다음 게임/주제/패스를 고른다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 선택된 사람은 다음 게임/주제/패스를 고른다.’"
          }
        ],
        "example": {
          "title": "더게임오브데스 한 차례 예시",
          "lines": [
            "실제 행동: 지목 수만큼 체인을 이동한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "더게임오브데스 · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "더게임오브데스 · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "더게임오브데스 · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "더게임오브데스 · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "더게임오브데스 · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "더게임오브데스 · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "선택된 사람은 다음 게임/주제/패스를 고른다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "mafia-local",
      "displayName": "마피아",
      "aliases": [],
      "searchAliases": [
        "마피아게임"
      ],
      "family": "사회추리",
      "playersMin": 4,
      "props": [
        "역할카드"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "비공개 역할을 나눈다",
        "action": "밤 행동과 낮 토론/투표를 반복한다",
        "end": "시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다."
      },
      "sourceObservationIds": [
        "kr-025"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "비공개 역할, 밤 지목, 낮 토론과 투표를 반복해 시민 또는 마피아 승리를 판정한다.",
        "fun": "숨은 역할을 의심하고 토론으로 판을 뒤집는 순간",
        "firstAction": "인원을 맞춘 뒤 역할을 섞고 1번부터 혼자 확인한다.",
        "reward": "생존 인원과 시민·마피아 승리 결과",
        "durationSec": 180,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "마피아",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "마피아는 비공개 역할, 밤 지목, 낮 토론과 투표를 반복해 시민 또는 마피아 승리를 판정한다. 숨은 역할을 의심하고 토론으로 판을 뒤집는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "비공개 역할을 나눈다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 비공개 역할을 나눈다",
            "hostCue": "‘준비: 비공개 역할을 나눈다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 비공개 역할, 밤 지목, 낮 토론과 투표를 반복해 시민 또는 마피아 승리를 판정한다. 라운드의 끝은 ‘시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 인원을 맞춘 뒤 역할을 섞고 1번부터 혼자 확인한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "밤 행동과 낮 토론/투표를 반복한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 밤 행동과 낮 토론/투표를 반복한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다. 앱은 생존 인원과 시민·마피아 승리 결과를 보여 줍니다.",
            "hostCue": "‘끝: 시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다.’"
          }
        ],
        "example": {
          "title": "마피아 한 차례 예시",
          "lines": [
            "실제 행동: 밤 행동과 낮 토론/투표를 반복한다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "마피아 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "시민/마피아 승리 조건을 먼저 만족한 팀이 이긴다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "odd-drawing-detective",
      "displayName": "마피아게임2",
      "aliases": [],
      "searchAliases": [
        "마피아게임2"
      ],
      "family": "그림추리",
      "playersMin": 4,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "한 사람만 다른 제시어를 받는다",
        "action": "모두 같은 횟수 선을 그린다",
        "end": "토론 뒤 다른 제시어 역할을 찾는다."
      },
      "sourceObservationIds": [
        "kr-026"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "마피아게임2",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "마피아게임2은 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "한 사람만 다른 제시어를 받는다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 한 사람만 다른 제시어를 받는다",
            "hostCue": "‘준비: 한 사람만 다른 제시어를 받는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘토론 뒤 다른 제시어 역할을 찾는다.’입니다.",
            "hostCue": "‘성공 조건: 토론 뒤 다른 제시어 역할을 찾는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "모두 같은 횟수 선을 그린다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 모두 같은 횟수 선을 그린다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "토론 뒤 다른 제시어 역할을 찾는다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 토론 뒤 다른 제시어 역할을 찾는다.’"
          }
        ],
        "example": {
          "title": "마피아게임2 한 차례 예시",
          "lines": [
            "실제 행동: 모두 같은 횟수 선을 그린다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "마피아게임2 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아게임2 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아게임2 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아게임2 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아게임2 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "마피아게임2 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "토론 뒤 다른 제시어 역할을 찾는다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "distance-flight",
      "displayName": "멀리날리기",
      "aliases": [],
      "searchAliases": [
        "멀리날리기"
      ],
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "종이비행기"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "종이비행기 등 안전 물체를 고른다",
        "action": "표시선 뒤에서 던진다",
        "end": "가장 먼 유효 착지가 승리한다."
      },
      "sourceObservationIds": [
        "kr-017"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "멀리날리기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "멀리날리기는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "종이비행기 등 안전 물체를 고른다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 종이비행기 등 안전 물체를 고른다",
            "hostCue": "‘준비: 종이비행기 등 안전 물체를 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘가장 먼 유효 착지가 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 가장 먼 유효 착지가 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "표시선 뒤에서 던진다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 표시선 뒤에서 던진다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "가장 먼 유효 착지가 승리한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 가장 먼 유효 착지가 승리한다.’"
          }
        ],
        "example": {
          "title": "멀리날리기 한 차례 예시",
          "lines": [
            "실제 행동: 표시선 뒤에서 던진다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "멀리날리기 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "멀리날리기 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "멀리날리기 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "멀리날리기 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "멀리날리기 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "멀리날리기 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "가장 먼 유효 착지가 승리한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "red-light-green-light",
      "displayName": "무궁화게임",
      "aliases": [],
      "searchAliases": [
        "무궁화게임"
      ],
      "family": "동작반응",
      "playersMin": 3,
      "props": [
        "공간"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "안전 거리와 정지선을 정한다",
        "action": "신호가 켜질 때만 천천히 이동한다",
        "end": "접촉 없이 먼저 도달하면 승리, 앉은 버전 제공."
      },
      "sourceObservationIds": [
        "kr-014"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "무궁화게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "무궁화게임은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "안전 거리와 정지선을 정한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 안전 거리와 정지선을 정한다",
            "hostCue": "‘준비: 안전 거리와 정지선을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘접촉 없이 먼저 도달하면 승리, 앉은 버전 제공.’입니다.",
            "hostCue": "‘성공 조건: 접촉 없이 먼저 도달하면 승리, 앉은 버전 제공.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "신호가 켜질 때만 천천히 이동한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 신호가 켜질 때만 천천히 이동한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "접촉 없이 먼저 도달하면 승리, 앉은 버전 제공. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 접촉 없이 먼저 도달하면 승리, 앉은 버전 제공.’"
          }
        ],
        "example": {
          "title": "무궁화게임 한 차례 예시",
          "lines": [
            "실제 행동: 신호가 켜질 때만 천천히 이동한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "무궁화게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "무궁화게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "무궁화게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "무궁화게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "무궁화게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "무궁화게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "접촉 없이 먼저 도달하면 승리, 앉은 버전 제공.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "opposite-answer",
      "displayName": "바보게임",
      "aliases": [],
      "searchAliases": [
        "바보게임"
      ],
      "family": "반응",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "질문 규칙을 반대로/엉뚱하게로 정한다",
        "action": "제한 시간에 규칙대로 답한다",
        "end": "정확한 반응 연속 기록."
      },
      "sourceObservationIds": [
        "kr-028"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "바보게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "바보게임은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "질문 규칙을 반대로/엉뚱하게로 정한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 질문 규칙을 반대로/엉뚱하게로 정한다",
            "hostCue": "‘준비: 질문 규칙을 반대로/엉뚱하게로 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘정확한 반응 연속 기록.’입니다.",
            "hostCue": "‘성공 조건: 정확한 반응 연속 기록.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "제한 시간에 규칙대로 답한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 제한 시간에 규칙대로 답한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정확한 반응 연속 기록. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정확한 반응 연속 기록.’"
          }
        ],
        "example": {
          "title": "바보게임 한 차례 예시",
          "lines": [
            "실제 행동: 제한 시간에 규칙대로 답한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "바보게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "바보게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "바보게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "바보게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "바보게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "바보게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "정확한 반응 연속 기록.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "cap-flick-number",
      "displayName": "병뚜껑게임",
      "aliases": [],
      "searchAliases": [
        "병뚜껑게임"
      ],
      "family": "기술/추리",
      "playersMin": 2,
      "props": [
        "병뚜껑"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "병뚜껑을 안전 방향으로 튕긴다",
        "action": "회전/착지 숫자 또는 거리를 예측한다",
        "end": "근접 점수를 얻는다."
      },
      "sourceObservationIds": [
        "kr-036"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "병뚜껑게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "병뚜껑게임은 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "병뚜껑을 안전 방향으로 튕긴다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 병뚜껑을 안전 방향으로 튕긴다",
            "hostCue": "‘준비: 병뚜껑을 안전 방향으로 튕긴다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘근접 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 근접 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "회전/착지 숫자 또는 거리를 예측한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 회전/착지 숫자 또는 거리를 예측한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "근접 점수를 얻는다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 근접 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "병뚜껑게임 한 차례 예시",
          "lines": [
            "실제 행동: 회전/착지 숫자 또는 거리를 예측한다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "병뚜껑게임 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "병뚜껑게임 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "병뚜껑게임 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "병뚜껑게임 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "병뚜껑게임 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "병뚜껑게임 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "근접 점수를 얻는다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "treasure-hunt",
      "displayName": "보물찾기",
      "aliases": [],
      "searchAliases": [
        "보물찾기"
      ],
      "family": "탐색",
      "playersMin": 3,
      "props": [
        "단서"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "허용 공간에 종이 단서를 둔다",
        "action": "팀이 순서대로 푼다",
        "end": "먼저 마지막 단서에 도달하면 승리한다."
      },
      "sourceObservationIds": [
        "kr-046"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "team_score",
        "mode": "hybrid",
        "goal": "팀별 미션을 수행하고 점수를 먼저 모은다.",
        "fun": "역전 가능한 짧은 팀 대결",
        "firstAction": "팀을 나누고 선공 팀을 정한다.",
        "reward": "팀 점수와 승리 공개",
        "durationSec": 75,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "보물찾기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "보물찾기는 팀별 미션을 수행하고 점수를 먼저 모은다. 역전 가능한 짧은 팀 대결을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 팀 나누기·미션·타이머·점수를 맡고, 준비물 미션은 화면 탭·말·몸짓 미션으로 대체합니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "허용 공간에 종이 단서를 둔다",
          "앱이 팀 나누기·미션·타이머·점수를 맡고, 준비물 미션은 화면 탭·말·몸짓 미션으로 대체합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 허용 공간에 종이 단서를 둔다",
            "hostCue": "‘준비: 허용 공간에 종이 단서를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 팀별 미션을 수행하고 점수를 먼저 모은다. 라운드의 끝은 ‘먼저 마지막 단서에 도달하면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 먼저 마지막 단서에 도달하면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 팀을 나누고 선공 팀을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "팀이 순서대로 푼다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 팀이 순서대로 푼다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "먼저 마지막 단서에 도달하면 승리한다. 앱은 팀 점수와 승리 공개를 보여 줍니다.",
            "hostCue": "‘끝: 먼저 마지막 단서에 도달하면 승리한다.’"
          }
        ],
        "example": {
          "title": "보물찾기 한 차례 예시",
          "lines": [
            "실제 행동: 팀이 순서대로 푼다",
            "A팀이 화면 미션 20초 수행",
            "성공하면 A팀 +1",
            "같은 조건으로 B팀 수행"
          ]
        },
        "rounds": [
          {
            "title": "보물찾기 · 1라운드",
            "prompt": "팀 미션: 팀 구호를 같은 박자로 3번",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "보물찾기 · 2라운드",
            "prompt": "팀 미션: 한 단어씩 이어 문장 완성",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "보물찾기 · 3라운드",
            "prompt": "팀 미션: 화면 신호에 팀 전원이 동시에 탭",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "보물찾기 · 4라운드",
            "prompt": "팀 미션: 몸짓 제시어 1개 맞히기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "보물찾기 · 5라운드",
            "prompt": "팀 미션: 관찰 조건 2개 찾기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "보물찾기 · 6라운드",
            "prompt": "팀 미션: 마지막 점수 뒤집기 미션",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          }
        ],
        "practice": {
          "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
          "actionLabel": "팀 점수 연습",
          "success": "팀별 수행과 점수 입력 순서를 익혔어요."
        },
        "winCondition": "먼저 마지막 단서에 도달하면 승리한다.",
        "tip": "팀 인원이 홀수면 한 명은 진행자를 맡고 다음 라운드에 팀과 교대합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "team_track",
          "labels": [
            "A팀",
            "미션",
            "B팀",
            "점수"
          ]
        }
      }
    },
    {
      "canonicalId": "dealer-detective-cards",
      "displayName": "비밀 전달자",
      "aliases": [],
      "searchAliases": [
        "Drug Dealer"
      ],
      "family": "Card/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "역할 카드를 비공개로 나눈다",
        "action": "눈짓/단서로 dealer를 찾는다",
        "end": "직업명은 비밀 전달자로 중립 표시한다."
      },
      "sourceObservationIds": [
        "wt-034"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "비밀 전달자",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "비밀 전달자는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "역할 카드를 비공개로 나눈다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 역할 카드를 비공개로 나눈다",
            "hostCue": "‘준비: 역할 카드를 비공개로 나눈다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘직업명은 비밀 전달자로 중립 표시한다.’입니다.",
            "hostCue": "‘성공 조건: 직업명은 비밀 전달자로 중립 표시한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "눈짓/단서로 dealer를 찾는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 눈짓/단서로 dealer를 찾는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "직업명은 비밀 전달자로 중립 표시한다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 직업명은 비밀 전달자로 중립 표시한다.’"
          }
        ],
        "example": {
          "title": "비밀 전달자 한 차례 예시",
          "lines": [
            "실제 행동: 눈짓/단서로 dealer를 찾는다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "비밀 전달자 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "비밀 전달자 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "비밀 전달자 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "비밀 전달자 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "비밀 전달자 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "비밀 전달자 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "직업명은 비밀 전달자로 중립 표시한다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "camera-freeze",
      "displayName": "사진피하기게임",
      "aliases": [],
      "searchAliases": [
        "사진피하기게임"
      ],
      "family": "촬영/프라이버시",
      "playersMin": 2,
      "props": [
        "카메라"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "저장·업로드 없이 local preview만 허용한다",
        "action": "신호 때 프레임 밖/정지 포즈를 고른다",
        "end": "즉시 삭제 후 라운드 점수만 남긴다."
      },
      "sourceObservationIds": [
        "kr-049"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "사진피하기게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "사진피하기게임은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "저장·업로드 없이 local preview만 허용한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 저장·업로드 없이 local preview만 허용한다",
            "hostCue": "‘준비: 저장·업로드 없이 local preview만 허용한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘즉시 삭제 후 라운드 점수만 남긴다.’입니다.",
            "hostCue": "‘성공 조건: 즉시 삭제 후 라운드 점수만 남긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "신호 때 프레임 밖/정지 포즈를 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 신호 때 프레임 밖/정지 포즈를 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "즉시 삭제 후 라운드 점수만 남긴다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 즉시 삭제 후 라운드 점수만 남긴다.’"
          }
        ],
        "example": {
          "title": "사진피하기게임 한 차례 예시",
          "lines": [
            "실제 행동: 신호 때 프레임 밖/정지 포즈를 고른다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "사진피하기게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "사진피하기게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "사진피하기게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "사진피하기게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "사진피하기게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "사진피하기게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "즉시 삭제 후 라운드 점수만 남긴다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "bottle-flip",
      "displayName": "생수통세우기",
      "aliases": [],
      "searchAliases": [
        "생수통세우기"
      ],
      "family": "기술",
      "playersMin": 1,
      "props": [
        "물병"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "소량의 물이 든 닫힌 병을 둔다",
        "action": "한 번 회전시켜 세운다",
        "end": "제한 시도 성공 수를 센다."
      },
      "sourceObservationIds": [
        "kr-019"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "생수통세우기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "생수통세우기는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "1명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "소량의 물이 든 닫힌 병을 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "1명 이상이 모여 소량의 물이 든 닫힌 병을 둔다",
            "hostCue": "‘준비: 소량의 물이 든 닫힌 병을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘제한 시도 성공 수를 센다.’입니다.",
            "hostCue": "‘성공 조건: 제한 시도 성공 수를 센다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "한 번 회전시켜 세운다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 한 번 회전시켜 세운다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "제한 시도 성공 수를 센다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 제한 시도 성공 수를 센다.’"
          }
        ],
        "example": {
          "title": "생수통세우기 한 차례 예시",
          "lines": [
            "실제 행동: 한 번 회전시켜 세운다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "생수통세우기 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "생수통세우기 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "생수통세우기 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "생수통세우기 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "생수통세우기 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "생수통세우기 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "제한 시도 성공 수를 센다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "three-role-chant-retired-name",
      "displayName": "세 역할 구호",
      "aliases": [],
      "searchAliases": [
        "Wuss, Douche Bag, Fucker"
      ],
      "family": "Vocal/Low",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "차별·모욕 수집 이름은 출처 기록에만 둔다",
        "action": "공개 화면 세 역할 구호",
        "end": "중립 역할 3개로 호출 순서 기억 게임을 실행한다."
      },
      "sourceObservationIds": [
        "wt-104"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "세 역할 구호",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "세 역할 구호는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "차별·모욕 수집 이름은 출처 기록에만 둔다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 차별·모욕 수집 이름은 출처 기록에만 둔다",
            "hostCue": "‘준비: 차별·모욕 수집 이름은 출처 기록에만 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘중립 역할 3개로 호출 순서 기억 게임을 실행한다.’입니다.",
            "hostCue": "‘성공 조건: 중립 역할 3개로 호출 순서 기억 게임을 실행한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공개 화면 세 역할 구호 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공개 화면 세 역할 구호’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "중립 역할 3개로 호출 순서 기억 게임을 실행한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 중립 역할 3개로 호출 순서 기억 게임을 실행한다.’"
          }
        ],
        "example": {
          "title": "세 역할 구호 한 차례 예시",
          "lines": [
            "실제 행동: 공개 화면 세 역할 구호",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "세 역할 구호 · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "세 역할 구호 · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "세 역할 구호 · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "세 역할 구호 · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "세 역할 구호 · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "세 역할 구호 · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "중립 역할 3개로 호출 순서 기억 게임을 실행한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "palm-mirror",
      "displayName": "손바닥끈끈이게임",
      "aliases": [],
      "searchAliases": [
        "손바닥끈끈이게임"
      ],
      "family": "손반응",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "접촉 없이 두 손 사이 간격을 둔다",
        "action": "리더 동작을 거울처럼 따라 한다",
        "end": "정확도/동시성 점수를 얻는다."
      },
      "sourceObservationIds": [
        "kr-048"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "손바닥끈끈이게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "손바닥끈끈이게임은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "접촉 없이 두 손 사이 간격을 둔다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 접촉 없이 두 손 사이 간격을 둔다",
            "hostCue": "‘준비: 접촉 없이 두 손 사이 간격을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘정확도/동시성 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 정확도/동시성 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "리더 동작을 거울처럼 따라 한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 리더 동작을 거울처럼 따라 한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정확도/동시성 점수를 얻는다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정확도/동시성 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "손바닥끈끈이게임 한 차례 예시",
          "lines": [
            "실제 행동: 리더 동작을 거울처럼 따라 한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "손바닥끈끈이게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "손바닥끈끈이게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "손바닥끈끈이게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "손바닥끈끈이게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "손바닥끈끈이게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "손바닥끈끈이게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "정확도/동시성 점수를 얻는다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "five-fingers-statements",
      "displayName": "손병호게임",
      "aliases": [],
      "searchAliases": [
        "손병호게임"
      ],
      "family": "자기공개",
      "playersMin": 3,
      "props": [
        "손"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "가벼운 사실 문장을 말한다",
        "action": "해당자는 손가락을 접는다",
        "end": "민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다."
      },
      "sourceObservationIds": [
        "kr-044"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "손병호게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "손병호게임은 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "가벼운 사실 문장을 말한다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 가벼운 사실 문장을 말한다",
            "hostCue": "‘준비: 가벼운 사실 문장을 말한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다.’입니다.",
            "hostCue": "‘성공 조건: 민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "해당자는 손가락을 접는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 해당자는 손가락을 접는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다.’"
          }
        ],
        "example": {
          "title": "손병호게임 한 차례 예시",
          "lines": [
            "실제 행동: 해당자는 손가락을 접는다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "손병호게임 · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "손병호게임 · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "손병호게임 · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "손병호게임 · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "손병호게임 · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "손병호게임 · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "민감 질문/탈락 없이 정해진 문항 수 뒤 종료한다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "hidden-object-guess",
      "displayName": "숨은 물건 맞히기",
      "aliases": [],
      "searchAliases": [
        "겨드랑이게임"
      ],
      "family": "신체/추리",
      "playersMin": 3,
      "props": [
        "안전소품"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "source의 신체 부위 표현은 display에서 중립화한다",
        "action": "손/상자에 안전 소품을 숨긴다",
        "end": "촉감 없이 질문으로 맞힌다."
      },
      "sourceObservationIds": [
        "kr-041"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "숨은 물건 맞히기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "숨은 물건 맞히기는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "source의 신체 부위 표현은 display에서 중립화한다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 source의 신체 부위 표현은 display에서 중립화한다",
            "hostCue": "‘준비: source의 신체 부위 표현은 display에서 중립화한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘촉감 없이 질문으로 맞힌다.’입니다.",
            "hostCue": "‘성공 조건: 촉감 없이 질문으로 맞힌다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "손/상자에 안전 소품을 숨긴다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 손/상자에 안전 소품을 숨긴다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "촉감 없이 질문으로 맞힌다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 촉감 없이 질문으로 맞힌다.’"
          }
        ],
        "example": {
          "title": "숨은 물건 맞히기 한 차례 예시",
          "lines": [
            "실제 행동: 손/상자에 안전 소품을 숨긴다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "숨은 물건 맞히기 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "숨은 물건 맞히기 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "숨은 물건 맞히기 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "숨은 물건 맞히기 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "숨은 물건 맞히기 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "숨은 물건 맞히기 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "촉감 없이 질문으로 맞힌다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "stopwatch-target",
      "displayName": "스탑워치게임",
      "aliases": [],
      "searchAliases": [
        "스탑워치게임"
      ],
      "family": "시간감각",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "목표 시간을 공개한다",
        "action": "화면을 보지 않고 멈춘다",
        "end": "오차가 가장 작은 사람이 승리한다."
      },
      "sourceObservationIds": [
        "kr-023"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "스탑워치게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "스탑워치게임은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "목표 시간을 공개한다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 목표 시간을 공개한다",
            "hostCue": "‘준비: 목표 시간을 공개한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘오차가 가장 작은 사람이 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 오차가 가장 작은 사람이 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "화면을 보지 않고 멈춘다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 화면을 보지 않고 멈춘다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "오차가 가장 작은 사람이 승리한다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 오차가 가장 작은 사람이 승리한다.’"
          }
        ],
        "example": {
          "title": "스탑워치게임 한 차례 예시",
          "lines": [
            "실제 행동: 화면을 보지 않고 멈춘다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "스탑워치게임 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "스탑워치게임 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "스탑워치게임 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "스탑워치게임 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "스탑워치게임 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "스탑워치게임 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "오차가 가장 작은 사람이 승리한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "balloon-art-target",
      "displayName": "아트풍선사격",
      "aliases": [],
      "searchAliases": [
        "아트풍선사격"
      ],
      "family": "표적",
      "playersMin": 2,
      "props": [
        "안전 다트",
        "풍선"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "비접촉 안전 도구와 과녁을 둔다",
        "action": "지정 색 과녁을 맞힌다",
        "end": "환경/소음 조건 충족 시 점수화한다."
      },
      "sourceObservationIds": [
        "kr-021"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "아트풍선사격",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "아트풍선사격은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "비접촉 안전 도구와 과녁을 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 비접촉 안전 도구와 과녁을 둔다",
            "hostCue": "‘준비: 비접촉 안전 도구와 과녁을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘환경/소음 조건 충족 시 점수화한다.’입니다.",
            "hostCue": "‘성공 조건: 환경/소음 조건 충족 시 점수화한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "지정 색 과녁을 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 지정 색 과녁을 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "환경/소음 조건 충족 시 점수화한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 환경/소음 조건 충족 시 점수화한다.’"
          }
        ],
        "example": {
          "title": "아트풍선사격 한 차례 예시",
          "lines": [
            "실제 행동: 지정 색 과녁을 맞힌다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "아트풍선사격 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "아트풍선사격 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "아트풍선사격 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "아트풍선사격 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "아트풍선사격 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "아트풍선사격 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "환경/소음 조건 충족 시 점수화한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "apartment-hands",
      "displayName": "아파트게임",
      "aliases": [],
      "searchAliases": [
        "아파트게임"
      ],
      "family": "손/숫자",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "손을 층처럼 겹치되 접촉 없는 화면 탭 대체를 제공한다",
        "action": "호스트가 층수를 센다",
        "end": "해당 층이 다음 주제를 고른다."
      },
      "sourceObservationIds": [
        "kr-040"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "아파트게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "아파트게임은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "손을 층처럼 겹치되 접촉 없는 화면 탭 대체를 제공한다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 손을 층처럼 겹치되 접촉 없는 화면 탭 대체를 제공한다",
            "hostCue": "‘준비: 손을 층처럼 겹치되 접촉 없는 화면 탭 대체를 제공한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘해당 층이 다음 주제를 고른다.’입니다.",
            "hostCue": "‘성공 조건: 해당 층이 다음 주제를 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "호스트가 층수를 센다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 호스트가 층수를 센다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "해당 층이 다음 주제를 고른다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 해당 층이 다음 주제를 고른다.’"
          }
        ],
        "example": {
          "title": "아파트게임 한 차례 예시",
          "lines": [
            "실제 행동: 호스트가 층수를 센다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "아파트게임 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "아파트게임 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "아파트게임 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "아파트게임 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "아파트게임 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "아파트게임 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "해당 층이 다음 주제를 고른다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "uno-house-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Drunk Uno"
      ],
      "family": "카드전략",
      "playersMin": 2,
      "props": [
        "상용 카드"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 카드게임의 음주 변형 관찰",
        "action": "일반 규칙과 안전 점수 변형만 안내한다",
        "end": "공식 게임 소유를 요구해 실행 덱은 제공하지 않는다."
      },
      "sourceObservationIds": [
        "bdg-008"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 일반 규칙과 안전 점수 변형만 안내한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "공식 게임 소유를 요구해 실행 덱은 제공하지 않는다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "farkle-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Drunk Farkle"
      ],
      "family": "주사위전략",
      "playersMin": 2,
      "props": [
        "주사위6"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "Farkle 음주 변형 관찰",
        "action": "일반 점수 규칙만 설명한다",
        "end": "상용/지역 규칙표를 복제하지 않는다."
      },
      "sourceObservationIds": [
        "bdg-025"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 일반 점수 규칙만 설명한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "상용/지역 규칙표를 복제하지 않는다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "branded-screen-game",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Ally McBeal Drinking Game",
        "BatBeer",
        "Beers for Cheers",
        "Disney Drinking Game",
        "Hi, Bob",
        "James Bond",
        "Rainman",
        "Red Dwarf Drinking Game",
        "Ren and Stimpy",
        "Rudolph the Red Nosed Reindeer",
        "S*M*A*S*H",
        "Simpsons",
        "Star Trek",
        "Star Trek: Deep Space 9",
        "Star Trek: The Next Generation",
        "Star Wars Drinking Game",
        "Strange Brew",
        "The Jerry Springer Drinking Game",
        "The X-Files Drinking Game",
        "Whoville X-Mas Game"
      ],
      "family": "영상관찰",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 브랜드 음주 규칙의 존재만 보존한다",
        "action": "라이선스 콘텐츠/대사 없이 일반 screen trope bingo를 추천한다",
        "end": "원형 실행 0."
      },
      "sourceObservationIds": [
        "bdg-065",
        "wt-002",
        "wt-005",
        "wt-020",
        "wt-041",
        "wt-047",
        "wt-063",
        "wt-064",
        "wt-068",
        "wt-069",
        "wt-071",
        "wt-073",
        "wt-079",
        "wt-080",
        "wt-081",
        "wt-082",
        "wt-083",
        "wt-087",
        "wt-091",
        "wt-103"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 라이선스 콘텐츠/대사 없이 일반 screen trope bingo를 추천한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "원형 실행 0.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "branded-music-cue",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Roxanne"
      ],
      "family": "음악반응",
      "playersMin": 2,
      "props": [
        "특정 곡"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 곡 반복어 음주 규칙을 보존한다",
        "action": "음악 권리/섭취 없이 일반 music cue pass를 추천한다",
        "end": "원형 실행 0."
      },
      "sourceObservationIds": [
        "bdg-070"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 음악 권리/섭취 없이 일반 music cue pass를 추천한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "원형 실행 0.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "disc-slot-target",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Kan Jam"
      ],
      "family": "야외던지기",
      "playersMin": 4,
      "props": [
        "디스크",
        "목표"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 스포츠 이름을 보존한다",
        "action": "공식 장비/규칙 소유 시 일반 안전 플레이만 안내한다",
        "end": "자체 복제품은 제공하지 않는다."
      },
      "sourceObservationIds": [
        "bdg-081"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식 장비/규칙 소유 시 일반 안전 플레이만 안내한다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "자체 복제품은 제공하지 않는다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "branded-video-game-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Call of Duty Drinking Game",
        "FIFA Drinking Game",
        "Mario Kart Drinking Game",
        "Mario Party Drinking Game",
        "Smash Bros Drinking Game"
      ],
      "family": "비디오게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 게임의 음주 house rule을 보존한다",
        "action": "공식 게임은 자체 규칙으로만 플레이",
        "end": "일반 race-event bingo를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-084",
        "bdg-085",
        "bdg-086",
        "bdg-087",
        "bdg-088"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식 게임은 자체 규칙으로만 플레이",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "일반 race-event bingo를 추천한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "branded-party-game-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Jackbox Drinking Game"
      ],
      "family": "디지털파티",
      "playersMin": 3,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 파티게임의 음주 변형만 보존한다",
        "action": "공식 게임 결과는 점수로만 사용",
        "end": "앱은 음주 규칙을 실행하지 않는다."
      },
      "sourceObservationIds": [
        "bdg-089"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식 게임 결과는 점수로만 사용",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "앱은 음주 규칙을 실행하지 않는다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "color-position-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Drunk Twister"
      ],
      "family": "신체/상용게임",
      "playersMin": 2,
      "props": [
        "특정 IP"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 신체게임의 음주 변형을 보존한다",
        "action": "공식 게임은 동의·접촉 없음 옵션으로만 플레이",
        "end": "자체 보드는 제공하지 않는다."
      },
      "sourceObservationIds": [
        "bdg-103"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식 게임은 동의·접촉 없음 옵션으로만 플레이",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "자체 보드는 제공하지 않는다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "elastic-target",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Beer Bungee"
      ],
      "family": "Strength/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "탄성 도구를 쓰는 지역 게임 관찰",
        "action": "장비 안전 사양이 없어 실행하지 않는다",
        "end": "cap target을 추천한다."
      },
      "sourceObservationIds": [
        "wt-011"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 장비 안전 사양이 없어 실행하지 않는다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "cap target을 추천한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "parcheesi-safe-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Beerchesi"
      ],
      "family": "Board/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 보드게임 변형 존재만 보존한다",
        "action": "공식 보유판은 점수만 사용한다",
        "end": "자체 보드/음주 규칙은 제공하지 않는다."
      },
      "sourceObservationIds": [
        "wt-017"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식 보유판은 점수만 사용한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "자체 보드/음주 규칙은 제공하지 않는다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "backgammon-safe-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Beergammon"
      ],
      "family": "Board/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 보드게임 변형 존재만 보존한다",
        "action": "공식 일반 규칙을 따른다",
        "end": "음주 트리거 0."
      },
      "sourceObservationIds": [
        "wt-018"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식 일반 규칙을 따른다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "음주 트리거 0.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "monopoly-safe-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Beeropoly"
      ],
      "family": "Board/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 부동산 보드게임 음주 변형을 보존한다",
        "action": "공식판 소유 시 일반 플레이만",
        "end": "자체 복제/음주 규칙 0."
      },
      "sourceObservationIds": [
        "wt-019"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식판 소유 시 일반 플레이만",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "자체 복제/음주 규칙 0.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "brain-damage-cards",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Brain Damage"
      ],
      "family": "Card/High-Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "이름과 지역 카드 변형만 보존한다",
        "action": "규칙 signature 확정 전 실행하지 않는다",
        "end": "pyramid cards를 추천한다."
      },
      "sourceObservationIds": [
        "wt-023"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 규칙 signature 확정 전 실행하지 않는다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "pyramid cards를 추천한다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "chutes-ladders-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Chutes and Ladders"
      ],
      "family": "Board/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 보드게임 변형 관찰",
        "action": "공식판 일반 규칙만",
        "end": "음주 house rule 0."
      },
      "sourceObservationIds": [
        "wt-030"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식판 일반 규칙만",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "음주 house rule 0.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "branded-event-bingo",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Eurovision Song Contest Drinking Game"
      ],
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 행사 기반 음주 규칙을 보존한다",
        "action": "일반 music-event bingo를 추천한다",
        "end": "브랜드 에셋/음주 트리거 0."
      },
      "sourceObservationIds": [
        "wt-035"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 일반 music-event bingo를 추천한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "브랜드 에셋/음주 트리거 0.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "multi-party-ruleset",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Multiple Party Game"
      ],
      "family": "Other/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "규칙 식별이 불충분한 수집 제목을 보존한다",
        "action": "상세 출처 기록 확인 전 실행 0",
        "end": "party decathlon 추천."
      },
      "sourceObservationIds": [
        "wt-054"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 상세 출처 기록 확인 전 실행 0",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "party decathlon 추천.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "nothing-dice",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Nothing"
      ],
      "family": "Dice/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "규칙 식별이 불충분한 역사명",
        "action": "source detail 수동 감사 queue",
        "end": "open dice rules 추천."
      },
      "sourceObservationIds": [
        "wt-055"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: source detail 수동 감사 queue",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "open dice rules 추천.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "peuchre-cards",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Peuchre"
      ],
      "family": "Card/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "지역 카드게임 이름을 보존한다",
        "action": "규칙/권리 수동 검증 전 실행하지 않는다",
        "end": "presidents 추천."
      },
      "sourceObservationIds": [
        "wt-058"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 규칙/권리 수동 검증 전 실행하지 않는다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "presidents 추천.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "pursuit-skill",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Pursuit"
      ],
      "family": "Skill/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "규칙 signature가 불명확한 역사 항목",
        "action": "source detail 검토 대기",
        "end": "safe skill pack 추천."
      },
      "sourceObservationIds": [
        "wt-059"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: source detail 검토 대기",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "safe skill pack 추천.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "branded-sports-bingo",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Red Wings Drinking Game"
      ],
      "family": "Sports/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "특정 팀/경기 음주 규칙",
        "action": "일반 sports bingo 추천",
        "end": "팀 상표/음주 트리거 0."
      },
      "sourceObservationIds": [
        "wt-065"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 일반 sports bingo 추천",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "팀 상표/음주 트리거 0.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "licensed-board-variant",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Trivial Pursuit"
      ],
      "family": "Board/Low-Medium",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "상용 퀴즈 보드 변형 존재만 보존한다",
        "action": "공식판은 일반 규칙으로 플레이",
        "end": "자체 문항/보드 복제 0."
      },
      "sourceObservationIds": [
        "wt-095"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 공식판은 일반 규칙으로 플레이",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "자체 문항/보드 복제 0.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "ultimate-loser-cards",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "Ultimate Loser"
      ],
      "family": "Card/High",
      "playersMin": 2,
      "props": [],
      "playability": "reference_only",
      "rules": {
        "setup": "규칙 signature/명칭 위험을 수동 감사한다",
        "action": "확인 전 실행 0",
        "end": "presidents 추천."
      },
      "sourceObservationIds": [
        "wt-097"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 확인 전 실행 0",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "presidents 추천.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "song-intro-guess",
      "displayName": "안전 대체가 필요한 참고 규칙",
      "aliases": [],
      "searchAliases": [
        "첫 소절 게임"
      ],
      "family": "음악추리",
      "playersMin": 2,
      "props": [
        "음원"
      ],
      "playability": "reference_only",
      "rules": {
        "setup": "사용자 보유/권리 확보 음원만 사용한다",
        "action": "첫 짧은 구간에서 제목을 맞힌다",
        "end": "스트리밍 복제 없이 점수만 기록한다."
      },
      "sourceObservationIds": [
        "kr-011"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "screen-trope-bingo",
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "안전 대체가 필요한 참고 규칙",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "안전 대체가 필요한 참고 규칙은 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "안전 대체가 필요한 참고 규칙의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "안전 대체가 필요한 참고 규칙 한 차례 예시",
          "lines": [
            "실제 행동: 첫 짧은 구간에서 제목을 맞힌다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "안전 대체가 필요한 참고 규칙 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "안전 대체가 필요한 참고 규칙 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "스트리밍 복제 없이 점수만 기록한다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "year-quiz",
      "displayName": "연도 퀴즈",
      "aliases": [],
      "searchAliases": [
        "0000년 퀴즈"
      ],
      "family": "퀴즈",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "사건/작품의 연도 질문을 연다",
        "action": "숫자를 동시에 고른다",
        "end": "가장 가까운 답이 점수를 얻는다."
      },
      "sourceObservationIds": [
        "kr-012"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "서로 다른 연도 문제 다섯 개를 풀고 실제 정답 수를 확인한다.",
        "fun": "기억 속 연도를 고른 직후 정답이 드러나는 순간",
        "firstAction": "첫 문제를 읽고 세 연도 중 하나를 고른다.",
        "reward": "다섯 문제의 실제 정답 수",
        "durationSec": 70,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "연도 퀴즈",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "연도 퀴즈는 서로 다른 연도 문제 다섯 개를 풀고 실제 정답 수를 확인한다. 기억 속 연도를 고른 직후 정답이 드러나는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "사건/작품의 연도 질문을 연다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 사건/작품의 연도 질문을 연다",
            "hostCue": "‘준비: 사건/작품의 연도 질문을 연다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 서로 다른 연도 문제 다섯 개를 풀고 실제 정답 수를 확인한다. 라운드의 끝은 ‘가장 가까운 답이 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 가장 가까운 답이 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 첫 문제를 읽고 세 연도 중 하나를 고른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "숫자를 동시에 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 숫자를 동시에 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "가장 가까운 답이 점수를 얻는다. 앱은 다섯 문제의 실제 정답 수를 보여 줍니다.",
            "hostCue": "‘끝: 가장 가까운 답이 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "연도 퀴즈 한 차례 예시",
          "lines": [
            "실제 행동: 숫자를 동시에 고른다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "연도 퀴즈 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "연도 퀴즈 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "연도 퀴즈 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "연도 퀴즈 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "연도 퀴즈 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "연도 퀴즈 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "가장 가까운 답이 점수를 얻는다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "word-association",
      "displayName": "연상 단어 잇기",
      "aliases": [],
      "searchAliases": [
        "Word Association"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "시작 단어를 공개한다",
        "action": "앞 단어와 연상되는 새 단어를 잇는다",
        "end": "중복/설명 실패 시 다음 seed로 간다."
      },
      "sourceObservationIds": [
        "bdg-040"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "현재 단어와 가장 직접 이어지는 연상 카드를 골라 다섯 칸을 완주한다.",
        "fun": "세 선택지 중 숨은 연결을 빠르게 찾아 다음 장면을 여는 순간",
        "firstAction": "‘비’와 가장 가까운 ‘우산’ 카드를 고른다.",
        "reward": "이유와 함께 완성한 다섯 단계 연상 경로",
        "durationSec": 55,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "연상 단어 잇기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "연상 단어 잇기는 현재 단어와 가장 직접 이어지는 연상 카드를 골라 다섯 칸을 완주한다. 세 선택지 중 숨은 연결을 빠르게 찾아 다음 장면을 여는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "시작 단어를 공개한다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 시작 단어를 공개한다",
            "hostCue": "‘준비: 시작 단어를 공개한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 현재 단어와 가장 직접 이어지는 연상 카드를 골라 다섯 칸을 완주한다. 라운드의 끝은 ‘중복/설명 실패 시 다음 seed로 간다.’입니다.",
            "hostCue": "‘성공 조건: 중복/설명 실패 시 다음 seed로 간다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: ‘비’와 가장 가까운 ‘우산’ 카드를 고른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "앞 단어와 연상되는 새 단어를 잇는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 앞 단어와 연상되는 새 단어를 잇는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "중복/설명 실패 시 다음 seed로 간다. 앱은 이유와 함께 완성한 다섯 단계 연상 경로를 보여 줍니다.",
            "hostCue": "‘끝: 중복/설명 실패 시 다음 seed로 간다.’"
          }
        ],
        "example": {
          "title": "연상 단어 잇기 한 차례 예시",
          "lines": [
            "실제 행동: 앞 단어와 연상되는 새 단어를 잇는다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "연상 단어 잇기 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "연상 단어 잇기 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "연상 단어 잇기 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "연상 단어 잇기 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "연상 단어 잇기 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "연상 단어 잇기 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "중복/설명 실패 시 다음 seed로 간다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "english-word-chain",
      "displayName": "영어릴레이퀴즈",
      "aliases": [],
      "searchAliases": [
        "영어릴레이퀴즈"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "시작 영어 단어를 연다",
        "action": "마지막 글자로 새 단어를 잇는다",
        "end": "중복/지연 전 기록."
      },
      "sourceObservationIds": [
        "kr-010"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "영어릴레이퀴즈",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "영어릴레이퀴즈는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "시작 영어 단어를 연다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 시작 영어 단어를 연다",
            "hostCue": "‘준비: 시작 영어 단어를 연다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘중복/지연 전 기록.’입니다.",
            "hostCue": "‘성공 조건: 중복/지연 전 기록.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "마지막 글자로 새 단어를 잇는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 마지막 글자로 새 단어를 잇는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "중복/지연 전 기록. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 중복/지연 전 기록.’"
          }
        ],
        "example": {
          "title": "영어릴레이퀴즈 한 차례 예시",
          "lines": [
            "실제 행동: 마지막 글자로 새 단어를 잇는다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "영어릴레이퀴즈 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "영어릴레이퀴즈 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "영어릴레이퀴즈 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "영어릴레이퀴즈 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "영어릴레이퀴즈 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "영어릴레이퀴즈 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "중복/지연 전 기록.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "king-orders-safe",
      "displayName": "왕게임",
      "aliases": [],
      "searchAliases": [
        "왕게임"
      ],
      "family": "역할/미션",
      "playersMin": 3,
      "props": [
        "카드",
        "앱"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "익명 번호와 왕을 뽑는다",
        "action": "왕은 사전 검수 안전 미션만 두 번호에 제시한다",
        "end": "당사자는 패스/대체 후 왕을 교대한다."
      },
      "sourceObservationIds": [
        "kr-035"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "왕게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "왕게임은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "익명 번호와 왕을 뽑는다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 익명 번호와 왕을 뽑는다",
            "hostCue": "‘준비: 익명 번호와 왕을 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘당사자는 패스/대체 후 왕을 교대한다.’입니다.",
            "hostCue": "‘성공 조건: 당사자는 패스/대체 후 왕을 교대한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "왕은 사전 검수 안전 미션만 두 번호에 제시한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 왕은 사전 검수 안전 미션만 두 번호에 제시한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "당사자는 패스/대체 후 왕을 교대한다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 당사자는 패스/대체 후 왕을 교대한다.’"
          }
        ],
        "example": {
          "title": "왕게임 한 차례 예시",
          "lines": [
            "실제 행동: 왕은 사전 검수 안전 미션만 두 번호에 제시한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "왕게임 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "왕게임 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "왕게임 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "왕게임 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "왕게임 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "왕게임 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "당사자는 패스/대체 후 왕을 교대한다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "sound-guess",
      "displayName": "이상한듣기평가",
      "aliases": [],
      "searchAliases": [
        "이상한듣기평가"
      ],
      "family": "청각추리",
      "playersMin": 2,
      "props": [
        "음원"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "권리 확보 효과음을 튼다",
        "action": "무엇인지 고른다",
        "end": "정답과 자막 설명을 공개한다."
      },
      "sourceObservationIds": [
        "kr-009"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "이상한듣기평가",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "이상한듣기평가는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "권리 확보 효과음을 튼다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 권리 확보 효과음을 튼다",
            "hostCue": "‘준비: 권리 확보 효과음을 튼다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘정답과 자막 설명을 공개한다.’입니다.",
            "hostCue": "‘성공 조건: 정답과 자막 설명을 공개한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "무엇인지 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 무엇인지 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정답과 자막 설명을 공개한다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 정답과 자막 설명을 공개한다.’"
          }
        ],
        "example": {
          "title": "이상한듣기평가 한 차례 예시",
          "lines": [
            "실제 행동: 무엇인지 고른다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "이상한듣기평가 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "이상한듣기평가 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "이상한듣기평가 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "이상한듣기평가 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "이상한듣기평가 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "이상한듣기평가 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "정답과 자막 설명을 공개한다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "commander-signal",
      "displayName": "이순신게임",
      "aliases": [],
      "searchAliases": [
        "이순신게임"
      ],
      "family": "명령반응",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "함대 방향 손 신호를 정한다",
        "action": "지휘 신호에 맞는 동작을 한다",
        "end": "접촉/굴욕 명령 없이 연속 정확도를 겨룬다."
      },
      "sourceObservationIds": [
        "kr-037"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "이순신게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "이순신게임은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "함대 방향 손 신호를 정한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 함대 방향 손 신호를 정한다",
            "hostCue": "‘준비: 함대 방향 손 신호를 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘접촉/굴욕 명령 없이 연속 정확도를 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 접촉/굴욕 명령 없이 연속 정확도를 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "지휘 신호에 맞는 동작을 한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 지휘 신호에 맞는 동작을 한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "접촉/굴욕 명령 없이 연속 정확도를 겨룬다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 접촉/굴욕 명령 없이 연속 정확도를 겨룬다.’"
          }
        ],
        "example": {
          "title": "이순신게임 한 차례 예시",
          "lines": [
            "실제 행동: 지휘 신호에 맞는 동작을 한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "이순신게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "이순신게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "이순신게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "이순신게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "이순신게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "이순신게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "접촉/굴욕 명령 없이 연속 정확도를 겨룬다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "nature-observation-bingo",
      "displayName": "자연촬영게임",
      "aliases": [],
      "searchAliases": [
        "자연촬영게임"
      ],
      "family": "야외관찰",
      "playersMin": 2,
      "props": [
        "카메라선택"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "사람/사유지/위치 정보 없는 자연 항목을 고른다",
        "action": "촬영 대신 체크도 허용한다",
        "end": "빙고 줄을 완성한다."
      },
      "sourceObservationIds": [
        "kr-043"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "자연촬영게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "자연촬영게임은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "사람/사유지/위치 정보 없는 자연 항목을 고른다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 사람/사유지/위치 정보 없는 자연 항목을 고른다",
            "hostCue": "‘준비: 사람/사유지/위치 정보 없는 자연 항목을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘빙고 줄을 완성한다.’입니다.",
            "hostCue": "‘성공 조건: 빙고 줄을 완성한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "촬영 대신 체크도 허용한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 촬영 대신 체크도 허용한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "빙고 줄을 완성한다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 빙고 줄을 완성한다.’"
          }
        ],
        "example": {
          "title": "자연촬영게임 한 차례 예시",
          "lines": [
            "실제 행동: 촬영 대신 체크도 허용한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "자연촬영게임 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "자연촬영게임 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "자연촬영게임 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "자연촬영게임 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "자연촬영게임 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "자연촬영게임 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "빙고 줄을 완성한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "catch-mole-rhythm",
      "displayName": "잡아라 쥐돌이",
      "aliases": [],
      "searchAliases": [
        "잡아라 쥐돌이"
      ],
      "family": "리듬반응",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "화면 구멍을 고른다",
        "action": "신호가 나온 칸을 탭한다",
        "end": "제한 시간 정확도/연속 기록을 겨룬다."
      },
      "sourceObservationIds": [
        "kr-024"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "잡아라 쥐돌이",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "잡아라 쥐돌이는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "화면 구멍을 고른다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 화면 구멍을 고른다",
            "hostCue": "‘준비: 화면 구멍을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘제한 시간 정확도/연속 기록을 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 제한 시간 정확도/연속 기록을 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "신호가 나온 칸을 탭한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 신호가 나온 칸을 탭한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "제한 시간 정확도/연속 기록을 겨룬다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 제한 시간 정확도/연속 기록을 겨룬다.’"
          }
        ],
        "example": {
          "title": "잡아라 쥐돌이 한 차례 예시",
          "lines": [
            "실제 행동: 신호가 나온 칸을 탭한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "잡아라 쥐돌이 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "잡아라 쥐돌이 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "잡아라 쥐돌이 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "잡아라 쥐돌이 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "잡아라 쥐돌이 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "잡아라 쥐돌이 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "제한 시간 정확도/연속 기록을 겨룬다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "jegichagi",
      "displayName": "제기차기",
      "aliases": [],
      "searchAliases": [
        "제기차기"
      ],
      "family": "신체기술",
      "playersMin": 2,
      "props": [
        "제기"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "안전 공간/앉은 손 버전을 고른다",
        "action": "제기를 연속으로 찬다",
        "end": "최고 기록을 비교한다."
      },
      "sourceObservationIds": [
        "kr-016"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "제기차기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "제기차기는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "안전 공간/앉은 손 버전을 고른다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 안전 공간/앉은 손 버전을 고른다",
            "hostCue": "‘준비: 안전 공간/앉은 손 버전을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘최고 기록을 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 최고 기록을 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "제기를 연속으로 찬다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 제기를 연속으로 찬다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "최고 기록을 비교한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 최고 기록을 비교한다.’"
          }
        ],
        "example": {
          "title": "제기차기 한 차례 예시",
          "lines": [
            "실제 행동: 제기를 연속으로 찬다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "제기차기 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "제기차기 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "제기차기 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "제기차기 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "제기차기 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "제기차기 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "최고 기록을 비교한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "zombie-safe-zone",
      "displayName": "좀비게임",
      "aliases": [],
      "searchAliases": [
        "좀비게임"
      ],
      "family": "공간추리",
      "playersMin": 4,
      "props": [
        "공간"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "걷기만 허용하고 안전 구역을 표시한다",
        "action": "태그 대신 근거리 손 신호로 감염을 전달한다",
        "end": "제한 시간 생존 팀을 공개한다."
      },
      "sourceObservationIds": [
        "kr-031"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "좀비게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "좀비게임은 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "걷기만 허용하고 안전 구역을 표시한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 걷기만 허용하고 안전 구역을 표시한다",
            "hostCue": "‘준비: 걷기만 허용하고 안전 구역을 표시한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘제한 시간 생존 팀을 공개한다.’입니다.",
            "hostCue": "‘성공 조건: 제한 시간 생존 팀을 공개한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "태그 대신 근거리 손 신호로 감염을 전달한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 태그 대신 근거리 손 신호로 감염을 전달한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "제한 시간 생존 팀을 공개한다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 제한 시간 생존 팀을 공개한다.’"
          }
        ],
        "example": {
          "title": "좀비게임 한 차례 예시",
          "lines": [
            "실제 행동: 태그 대신 근거리 손 신호로 감염을 전달한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "좀비게임 · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "좀비게임 · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "좀비게임 · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "좀비게임 · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "좀비게임 · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "좀비게임 · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "제한 시간 생존 팀을 공개한다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "general-quiz",
      "displayName": "종합퀴즈존",
      "aliases": [],
      "searchAliases": [
        "종합퀴즈존"
      ],
      "family": "퀴즈",
      "playersMin": 1,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "난도/주제를 고른다",
        "action": "객관식/짧은 답을 푼다",
        "end": "정답 수를 합친다."
      },
      "sourceObservationIds": [
        "kr-008"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "종합퀴즈존",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "종합퀴즈존은 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "1명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "난도/주제를 고른다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "1명 이상이 모여 난도/주제를 고른다",
            "hostCue": "‘준비: 난도/주제를 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘정답 수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 정답 수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "객관식/짧은 답을 푼다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 객관식/짧은 답을 푼다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정답 수를 합친다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 정답 수를 합친다.’"
          }
        ],
        "example": {
          "title": "종합퀴즈존 한 차례 예시",
          "lines": [
            "실제 행동: 객관식/짧은 답을 푼다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "종합퀴즈존 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "종합퀴즈존 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "종합퀴즈존 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "종합퀴즈존 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "종합퀴즈존 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "종합퀴즈존 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "정답 수를 합친다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "open-dice-rules",
      "displayName": "주사위 세 번",
      "aliases": [],
      "searchAliases": [
        "Dice"
      ],
      "family": "Dice/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "안전 주사위 액션 6개를 고른다",
        "action": "굴린 면의 점수/질문을 수행한다",
        "end": "정해진 라운드로 끝낸다."
      },
      "sourceObservationIds": [
        "wt-032"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "주사위를 세 번 굴려 나온 눈과 합계를 확인한다.",
        "fun": "누를 때마다 예측할 수 없는 눈이 공개되는 순간",
        "firstAction": "주사위를 눌러 첫 번째 눈을 공개한다.",
        "reward": "세 번의 눈과 최종 합계",
        "durationSec": 35,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "주사위 세 번",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "주사위 세 번은 주사위를 세 번 굴려 나온 눈과 합계를 확인한다. 누를 때마다 예측할 수 없는 눈이 공개되는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "안전 주사위 액션 6개를 고른다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 안전 주사위 액션 6개를 고른다",
            "hostCue": "‘준비: 안전 주사위 액션 6개를 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 주사위를 세 번 굴려 나온 눈과 합계를 확인한다. 라운드의 끝은 ‘정해진 라운드로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 라운드로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 주사위를 눌러 첫 번째 눈을 공개한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "굴린 면의 점수/질문을 수행한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 굴린 면의 점수/질문을 수행한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 라운드로 끝낸다. 앱은 세 번의 눈과 최종 합계를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 라운드로 끝낸다.’"
          }
        ],
        "example": {
          "title": "주사위 세 번 한 차례 예시",
          "lines": [
            "실제 행동: 굴린 면의 점수/질문을 수행한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "주사위 세 번 · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "주사위 세 번 · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "주사위 세 번 · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "주사위 세 번 · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "주사위 세 번 · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "주사위 세 번 · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "정해진 라운드로 끝낸다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "categories",
      "displayName": "주제 단어 잇기",
      "aliases": [],
      "searchAliases": [
        "단어게임",
        "Categories"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "주제를 뽑는다",
        "action": "겹치지 않는 단어를 차례로 말한다",
        "end": "반복/시간 초과 시 라운드가 끝난다."
      },
      "sourceObservationIds": [
        "bdg-038",
        "kr-001"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "여섯 카드 중 주제에 맞는 네 장을 골라 다섯 라운드를 통과한다.",
        "fun": "시간이 줄어드는 동안 함정 카드를 피해 정답을 연달아 찾는 순간",
        "firstAction": "과일 주제를 보고 사과처럼 맞는 단어 카드를 고른다.",
        "reward": "두 번의 기회를 지키며 찾은 정답 20개",
        "durationSec": 90,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english",
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "주제 단어 잇기",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "주제 단어 잇기는 여섯 카드 중 주제에 맞는 네 장을 골라 다섯 라운드를 통과한다. 시간이 줄어드는 동안 함정 카드를 피해 정답을 연달아 찾는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주제를 뽑는다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 주제를 뽑는다",
            "hostCue": "‘준비: 주제를 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 여섯 카드 중 주제에 맞는 네 장을 골라 다섯 라운드를 통과한다. 라운드의 끝은 ‘반복/시간 초과 시 라운드가 끝난다.’입니다.",
            "hostCue": "‘성공 조건: 반복/시간 초과 시 라운드가 끝난다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 과일 주제를 보고 사과처럼 맞는 단어 카드를 고른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "겹치지 않는 단어를 차례로 말한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 겹치지 않는 단어를 차례로 말한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "반복/시간 초과 시 라운드가 끝난다. 앱은 두 번의 기회를 지키며 찾은 정답 20개를 보여 줍니다.",
            "hostCue": "‘끝: 반복/시간 초과 시 라운드가 끝난다.’"
          }
        ],
        "example": {
          "title": "주제 단어 잇기 한 차례 예시",
          "lines": [
            "실제 행동: 겹치지 않는 단어를 차례로 말한다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "주제 단어 잇기 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "주제 단어 잇기 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "주제 단어 잇기 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "주제 단어 잇기 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "주제 단어 잇기 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "주제 단어 잇기 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "반복/시간 초과 시 라운드가 끝난다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "power-hour",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Power Hour"
      ],
      "family": "속주",
      "playersMin": 1,
      "props": [
        "타이머"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "매분 음주하는 원형을 정보로만 보존한다",
        "action": "실행 타이머는 제공하지 않는다",
        "end": "음악 1분 퀴즈로 대체한다."
      },
      "sourceObservationIds": [
        "bdg-060"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 타이머는 제공하지 않는다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "음악 1분 퀴즈로 대체한다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "hands-bound-challenge",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Edward Fortyhands"
      ],
      "family": "구속/섭취",
      "playersMin": 2,
      "props": [
        "테이프",
        "대용량주류"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "손에 술병을 고정하는 원형만 정보로 보존한다",
        "action": "구속·섭취 실행 0",
        "end": "한 손 협동 그림을 추천한다."
      },
      "sourceObservationIds": [
        "bdg-073"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "performance",
        "mode": "hosted",
        "goal": "그림·몸짓·소리·연기로 팀이 답을 맞히게 한다.",
        "fun": "엉뚱한 표현과 극적인 정답",
        "firstAction": "표현할 사람과 첫 제시어를 정한다.",
        "reward": "맞힌 수와 관객 반응",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 그림·몸짓·소리·연기로 팀이 답을 맞히게 한다. 엉뚱한 표현과 극적인 정답을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 구속·섭취 실행 0",
            "표현자만 연습 제시어 ‘고양이’ 확인",
            "말 없이 수염·발 동작 표현",
            "다른 사람이 답을 외침"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "표현 제시어: 양치하기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "표현 제시어: 버스 놓치기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "표현 제시어: 사진 찍기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "표현 제시어: 요리하기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "표현 제시어: 길 찾기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "표현 제시어: 선물 열기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 제시어를 보고 말하지 않고 몸짓 또는 소리로 5초 동안 표현하세요.",
          "actionLabel": "표현 연습",
          "success": "표현자와 맞히는 사람의 역할을 익혔어요."
        },
        "winCondition": "한 손 협동 그림을 추천한다.",
        "tip": "외모·장애·억양을 흉내 내지 않고 사물·동물·행동 중심 제시어를 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "stage",
          "labels": [
            "제시어",
            "표현",
            "추측",
            "정답"
          ]
        }
      }
    },
    {
      "canonicalId": "dizzy-bat",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Dizzy Bat"
      ],
      "family": "회전/달리기",
      "playersMin": 2,
      "props": [
        "방망이"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "회전 뒤 달리는 원형은 낙상 위험으로 차단한다",
        "action": "실행 안내 0",
        "end": "앉아서 손가락 미로 릴레이를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-074"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "team_score",
        "mode": "hybrid",
        "goal": "팀별 미션을 수행하고 점수를 먼저 모은다.",
        "fun": "역전 가능한 짧은 팀 대결",
        "firstAction": "팀을 나누고 선공 팀을 정한다.",
        "reward": "팀 점수와 승리 공개",
        "durationSec": 75,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 팀별 미션을 수행하고 점수를 먼저 모은다. 역전 가능한 짧은 팀 대결을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 안내 0",
            "A팀이 화면 미션 20초 수행",
            "성공하면 A팀 +1",
            "같은 조건으로 B팀 수행"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "팀 미션: 팀 구호를 같은 박자로 3번",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "팀 미션: 한 단어씩 이어 문장 완성",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "팀 미션: 화면 신호에 팀 전원이 동시에 탭",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "팀 미션: 몸짓 제시어 1개 맞히기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "팀 미션: 관찰 조건 2개 찾기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "팀 미션: 마지막 점수 뒤집기 미션",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          }
        ],
        "practice": {
          "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
          "actionLabel": "팀 점수 연습",
          "success": "팀별 수행과 점수 입력 순서를 익혔어요."
        },
        "winCondition": "앉아서 손가락 미로 릴레이를 추천한다.",
        "tip": "팀 인원이 홀수면 한 명은 진행자를 맡고 다음 라운드에 팀과 교대합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "team_track",
          "labels": [
            "A팀",
            "미션",
            "B팀",
            "점수"
          ]
        }
      }
    },
    {
      "canonicalId": "slip-n-flip",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Slip 'N Flip"
      ],
      "family": "미끄럼/릴레이",
      "playersMin": 4,
      "props": [
        "물",
        "시트"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "미끄러운 바닥과 속도 경쟁 원형을 차단한다",
        "action": "실행 안내 0",
        "end": "마른 바닥 flip-cup relay를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-077"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 안내 0",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "마른 바닥 flip-cup relay를 추천한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "beer-mile",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Beer Mile"
      ],
      "family": "속주/달리기",
      "playersMin": 1,
      "props": [
        "술",
        "트랙"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "반복 음주와 달리기 결합 원형을 차단한다",
        "action": "실행 타이머 0",
        "end": "일반 걷기 빙고를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-079"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 타이머 0",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "일반 걷기 빙고를 추천한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "keg-stand",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Keg Stand"
      ],
      "family": "역자세/강제섭취",
      "playersMin": 2,
      "props": [
        "술통"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "사람을 거꾸로 들고 마시는 원형을 차단한다",
        "action": "실행·타이머 0",
        "end": "벽 기대기 팀 퀴즈도 신체 위험 때문에 기본 비추천한다."
      },
      "sourceObservationIds": [
        "bdg-082"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행·타이머 0",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "벽 기대기 팀 퀴즈도 신체 위험 때문에 기본 비추천한다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "boot-glass-challenge",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Das Boot"
      ],
      "family": "용기/섭취",
      "playersMin": 2,
      "props": [
        "부츠잔"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "대형 잔 연속 섭취 원형을 정보로만 보존한다",
        "action": "실행 0",
        "end": "컵 모양 그림 맞히기를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-083"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "performance",
        "mode": "hosted",
        "goal": "그림·몸짓·소리·연기로 팀이 답을 맞히게 한다.",
        "fun": "엉뚱한 표현과 극적인 정답",
        "firstAction": "표현할 사람과 첫 제시어를 정한다.",
        "reward": "맞힌 수와 관객 반응",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 그림·몸짓·소리·연기로 팀이 답을 맞히게 한다. 엉뚱한 표현과 극적인 정답을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 0",
            "표현자만 연습 제시어 ‘고양이’ 확인",
            "말 없이 수염·발 동작 표현",
            "다른 사람이 답을 외침"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "표현 제시어: 양치하기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "표현 제시어: 버스 놓치기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "표현 제시어: 사진 찍기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "표현 제시어: 요리하기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "표현 제시어: 길 찾기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "표현 제시어: 선물 열기",
            "options": [
              "몸짓",
              "허밍·효과음"
            ],
            "reveal": "정답 단어를 직접 말하지 않고 맞힌 수를 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 제시어를 보고 말하지 않고 몸짓 또는 소리로 5초 동안 표현하세요.",
          "actionLabel": "표현 연습",
          "success": "표현자와 맞히는 사람의 역할을 익혔어요."
        },
        "winCondition": "컵 모양 그림 맞히기를 추천한다.",
        "tip": "외모·장애·억양을 흉내 내지 않고 사물·동물·행동 중심 제시어를 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "stage",
          "labels": [
            "제시어",
            "표현",
            "추측",
            "정답"
          ]
        }
      }
    },
    {
      "canonicalId": "hammer-nail-race",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Hammerschlagen"
      ],
      "family": "도구기술",
      "playersMin": 2,
      "props": [
        "망치",
        "못"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "음주 환경에서 망치·못을 쓰는 원형을 차단한다",
        "action": "실행 안내 0",
        "end": "자석 핀 밀기를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-091"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 안내 0",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "자석 핀 밀기를 추천한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "rotary-container-game",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Goon of Fortune"
      ],
      "family": "회전/대용량섭취",
      "playersMin": 3,
      "props": [
        "빨랫줄",
        "주류"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "회전 주류 용기에서 마시는 원형을 차단한다",
        "action": "실행 0",
        "end": "회전 화살표 안전 질문을 추천한다."
      },
      "sourceObservationIds": [
        "bdg-093"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 0",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "회전 화살표 안전 질문을 추천한다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "crate-walk",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Kastenlauf"
      ],
      "family": "이동/대량주류",
      "playersMin": 2,
      "props": [
        "상자",
        "주류"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "술 상자를 들고 장거리 이동·섭취하는 원형을 차단한다",
        "action": "실행 0",
        "end": "동네 관찰 빙고를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-097"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 0",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "동네 관찰 빙고를 추천한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "centurion",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Centurion",
        "Century Club"
      ],
      "family": "속주",
      "playersMin": 1,
      "props": [
        "타이머"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "100회 시간 음주 원형을 차단한다",
        "action": "실행·알림 0",
        "end": "100초 협동 퀴즈를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-098",
        "wt-029"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행·알림 0",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "100초 협동 퀴즈를 추천한다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "beer-bong",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Beer Bong"
      ],
      "family": "강제/속주",
      "playersMin": 1,
      "props": [
        "깔때기"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "깔때기로 빠르게 마시는 원형을 차단한다",
        "action": "실행 안내·용량·타이머 0",
        "end": "안전 게임 추천만 제공한다."
      },
      "sourceObservationIds": [
        "bdg-104"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 안내·용량·타이머 0",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "안전 게임 추천만 제공한다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "card-pass-air",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Suck and Blow"
      ],
      "family": "접촉/호흡",
      "playersMin": 4,
      "props": [
        "카드"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "입으로 카드를 전달하는 접촉·위생 원형을 차단한다",
        "action": "실행 0",
        "end": "손등 카드 릴레이를 추천한다."
      },
      "sourceObservationIds": [
        "bdg-106"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "team_score",
        "mode": "hybrid",
        "goal": "팀별 미션을 수행하고 점수를 먼저 모은다.",
        "fun": "역전 가능한 짧은 팀 대결",
        "firstAction": "팀을 나누고 선공 팀을 정한다.",
        "reward": "팀 점수와 승리 공개",
        "durationSec": 75,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 팀별 미션을 수행하고 점수를 먼저 모은다. 역전 가능한 짧은 팀 대결을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 0",
            "A팀이 화면 미션 20초 수행",
            "성공하면 A팀 +1",
            "같은 조건으로 B팀 수행"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "팀 미션: 팀 구호를 같은 박자로 3번",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "팀 미션: 한 단어씩 이어 문장 완성",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "팀 미션: 화면 신호에 팀 전원이 동시에 탭",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "팀 미션: 몸짓 제시어 1개 맞히기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "팀 미션: 관찰 조건 2개 찾기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "팀 미션: 마지막 점수 뒤집기 미션",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          }
        ],
        "practice": {
          "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
          "actionLabel": "팀 점수 연습",
          "success": "팀별 수행과 점수 입력 순서를 익혔어요."
        },
        "winCondition": "손등 카드 릴레이를 추천한다.",
        "tip": "팀 인원이 홀수면 한 명은 진행자를 맡고 다음 라운드에 팀과 교대합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "team_track",
          "labels": [
            "A팀",
            "미션",
            "B팀",
            "점수"
          ]
        }
      }
    },
    {
      "canonicalId": "shotgun-beer",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Shotgun",
        "Shotgunning a Beer"
      ],
      "family": "속주/용기훼손",
      "playersMin": 1,
      "props": [
        "캔"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "캔을 뚫어 빠르게 마시는 원형을 차단한다",
        "action": "방법·도구·타이머 0",
        "end": "안전 대체만 제공한다."
      },
      "sourceObservationIds": [
        "bdg-108",
        "wt-072"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 방법·도구·타이머 0",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "안전 대체만 제공한다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "beat-the-barman",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Beat the Barman"
      ],
      "family": "Endurance/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "rules": {
        "setup": "제한 시간 연속 섭취 경쟁을 차단한다",
        "action": "용량·속도 안내 0",
        "end": "주문 기억 릴레이를 추천한다."
      },
      "sourceObservationIds": [
        "wt-006"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 용량·속도 안내 0",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "주문 기억 릴레이를 추천한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "hidden-container-roulette",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Beer Hunter",
        "Russian Beer Roulette"
      ],
      "family": "Other/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "rules": {
        "setup": "일부 용기에 위험 음료를 숨기는 원형을 차단한다",
        "action": "음식/음료 러시안룰렛 0",
        "end": "숨은 색 토큰 추리를 추천한다."
      },
      "sourceObservationIds": [
        "wt-013",
        "wt-070"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 음식/음료 러시안룰렛 0",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "숨은 색 토큰 추리를 추천한다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "beer-race",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Beer Race"
      ],
      "family": "Speed/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "rules": {
        "setup": "속주 릴레이를 차단한다",
        "action": "실행 타이머 0",
        "end": "flip-cup relay를 추천한다."
      },
      "sourceObservationIds": [
        "wt-016"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행 타이머 0",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "flip-cup relay를 추천한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "kings-blood-variant",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "Kings and Blood"
      ],
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "rules": {
        "setup": "혼합 음료/강제 섭취가 핵심인 지역 변형 규칙를 차단한다",
        "action": "일반 Kings Cup 안전 덱 추천.",
        "end": "정해진 라운드 뒤 종료한다."
      },
      "sourceObservationIds": [
        "wt-049"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 일반 Kings Cup 안전 덱 추천.",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "정해진 라운드 뒤 종료한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "spicy-food-roulette",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "고추냉이게임"
      ],
      "family": "음식위험",
      "playersMin": 2,
      "props": [
        "음식"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "알레르기·자극 식품 러시안룰렛을 차단한다",
        "action": "섭취 미션 0",
        "end": "숨은 색 토큰 추리를 추천한다."
      },
      "sourceObservationIds": [
        "kr-020"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 섭취 미션 0",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "숨은 색 토큰 추리를 추천한다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "consent-contact-roulette",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "뽀뽀게임"
      ],
      "family": "무동의접촉",
      "playersMin": 2,
      "props": [],
      "playability": "safety_blocked",
      "rules": {
        "setup": "키스/신체 접촉 룰렛을 차단한다",
        "action": "실행·대상 지목 0",
        "end": "칭찬 한마디/패스 룰렛을 추천한다."
      },
      "sourceObservationIds": [
        "kr-047"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 실행·대상 지목 0",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "칭찬 한마디/패스 룰렛을 추천한다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "question-message",
      "displayName": "직접 실행하지 않는 위험 원형",
      "aliases": [],
      "searchAliases": [
        "질문문자보내기"
      ],
      "family": "외부메시지/프라이버시",
      "playersMin": 2,
      "props": [
        "연락처"
      ],
      "playability": "safety_blocked",
      "rules": {
        "setup": "제3자에게 무단 메시지를 보내는 원형을 차단한다",
        "action": "연락처 접근·전송 0",
        "end": "방 안 익명 질문 카드로 대체한다."
      },
      "sourceObservationIds": [
        "kr-051"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": "categories",
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "reference_only",
        "publicTitle": "직접 실행하지 않는 위험 원형",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "직접 실행하지 않는 위험 원형은 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": false,
        "appOnlyMode": "이 원형은 앱에서 실행하지 않습니다. 화면이 이유를 설명하고 안전한 대체 게임의 전체 가이드로 연결합니다.",
        "setupChecklist": [
          "원형을 직접 시작하지 않습니다.",
          "차단 또는 참고 사유를 먼저 읽습니다.",
          "화면에 연결된 안전 대체 게임을 선택합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "원형을 확인해요",
            "instruction": "직접 실행하지 않는 위험 원형의 수집 이름과 맥락만 확인합니다.",
            "hostCue": "‘이 원형은 직접 실행하지 않아요.’"
          },
          {
            "id": "learn",
            "title": "차단 이유를 읽어요",
            "instruction": "위험·권리·동의 문제가 있는 핵심 행동은 따라 하지 않습니다.",
            "hostCue": "‘안전한 핵심만 다른 게임으로 이어 갈게요.’"
          },
          {
            "id": "practice",
            "title": "대체를 열어요",
            "instruction": "화면의 안전 대체 카드에서 상세 규칙을 엽니다.",
            "hostCue": "‘대체 게임을 처음부터 같이 익혀요.’"
          },
          {
            "id": "play",
            "title": "대체 게임을 해요",
            "instruction": "대체 게임의 앱 단독 연습을 마친 뒤 실전을 시작합니다.",
            "hostCue": "‘원형 대신 이 규칙으로 시작합니다.’"
          },
          {
            "id": "finish",
            "title": "안전 결과만 남겨요",
            "instruction": "점수·대화·휴식·패스만 결과로 남습니다.",
            "hostCue": "‘술 벌칙 없이 게임 결과만 기록해요.’"
          }
        ],
        "example": {
          "title": "직접 실행하지 않는 위험 원형 한 차례 예시",
          "lines": [
            "실제 행동: 연락처 접근·전송 0",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "직접 실행하지 않는 위험 원형 · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "직접 실행하지 않는 위험 원형 · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "방 안 익명 질문 카드로 대체한다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "initial-search",
      "displayName": "초성검색",
      "aliases": [],
      "searchAliases": [
        "초성검색"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "카테고리와 초성을 공개한다",
        "action": "가능한 단어를 먼저 입력/말한다",
        "end": "검증된 답이 점수를 얻는다."
      },
      "sourceObservationIds": [
        "kr-006"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "초성검색",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "초성검색은 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "카테고리와 초성을 공개한다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 카테고리와 초성을 공개한다",
            "hostCue": "‘준비: 카테고리와 초성을 공개한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘검증된 답이 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 검증된 답이 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "가능한 단어를 먼저 입력/말한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 가능한 단어를 먼저 입력/말한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "검증된 답이 점수를 얻는다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 검증된 답이 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "초성검색 한 차례 예시",
          "lines": [
            "실제 행동: 가능한 단어를 먼저 입력/말한다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "초성검색 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "초성검색 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "초성검색 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "초성검색 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "초성검색 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "초성검색 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "검증된 답이 점수를 얻는다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "two-card-sum",
      "displayName": "카드게임",
      "aliases": [],
      "searchAliases": [
        "카드게임"
      ],
      "family": "카드운",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "두 장씩 뽑는다",
        "action": "합/조합을 공개한다",
        "end": "가장 높은 유효 합이 점수를 얻는다."
      },
      "sourceObservationIds": [
        "kr-034"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "카드게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "카드게임은 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 장씩 뽑는다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 두 장씩 뽑는다",
            "hostCue": "‘준비: 두 장씩 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘가장 높은 유효 합이 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 가장 높은 유효 합이 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "합/조합을 공개한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 합/조합을 공개한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "가장 높은 유효 합이 점수를 얻는다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 가장 높은 유효 합이 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "카드게임 한 차례 예시",
          "lines": [
            "실제 행동: 합/조합을 공개한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "카드게임 · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "카드게임 · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "카드게임 · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "카드게임 · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "카드게임 · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "카드게임 · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "가장 높은 유효 합이 점수를 얻는다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "three-syllable-chain",
      "displayName": "쿵쿵따",
      "aliases": [],
      "searchAliases": [
        "쿵쿵따"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "세 글자 단어로 시작한다",
        "action": "끝 글자로 새 세 글자 단어를 잇는다",
        "end": "중복/실수 전 기록."
      },
      "sourceObservationIds": [
        "kr-007"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "끝 글자로 시작하는 세 글자 단어 카드를 골라 여섯 번 이어 간다.",
        "fun": "제한시간 안에 함정 카드 사이에서 정확한 끝말을 찾는 연쇄",
        "firstAction": "강아지의 끝 글자 ‘지’로 시작하는 세 글자 카드를 고른다.",
        "reward": "하트를 지키며 완성한 여섯 단어 연쇄",
        "durationSec": 75,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "쿵쿵따",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "쿵쿵따는 끝 글자로 시작하는 세 글자 단어 카드를 골라 여섯 번 이어 간다. 제한시간 안에 함정 카드 사이에서 정확한 끝말을 찾는 연쇄를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "세 글자 단어로 시작한다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 세 글자 단어로 시작한다",
            "hostCue": "‘준비: 세 글자 단어로 시작한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 끝 글자로 시작하는 세 글자 단어 카드를 골라 여섯 번 이어 간다. 라운드의 끝은 ‘중복/실수 전 기록.’입니다.",
            "hostCue": "‘성공 조건: 중복/실수 전 기록.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 강아지의 끝 글자 ‘지’로 시작하는 세 글자 카드를 고른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "끝 글자로 새 세 글자 단어를 잇는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 끝 글자로 새 세 글자 단어를 잇는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "중복/실수 전 기록. 앱은 하트를 지키며 완성한 여섯 단어 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 중복/실수 전 기록.’"
          }
        ],
        "example": {
          "title": "쿵쿵따 한 차례 예시",
          "lines": [
            "실제 행동: 끝 글자로 새 세 글자 단어를 잇는다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "쿵쿵따 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "쿵쿵따 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "쿵쿵따 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "쿵쿵따 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "쿵쿵따 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "쿵쿵따 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "중복/실수 전 기록.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "table-ball-blow",
      "displayName": "탁구공불기게임",
      "aliases": [],
      "searchAliases": [
        "탁구공불기게임"
      ],
      "family": "호흡/기술",
      "playersMin": 2,
      "props": [
        "개인 공",
        "테이블"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "개인별 세척 공과 레인을 둔다",
        "action": "손 대신 바람/부채로 결승까지 보낸다",
        "end": "타액 공유 없이 먼저 도착하면 승리한다."
      },
      "sourceObservationIds": [
        "kr-022"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "탁구공불기게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "탁구공불기게임은 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "개인별 세척 공과 레인을 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 개인별 세척 공과 레인을 둔다",
            "hostCue": "‘준비: 개인별 세척 공과 레인을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘타액 공유 없이 먼저 도착하면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 타액 공유 없이 먼저 도착하면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "손 대신 바람/부채로 결승까지 보낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 손 대신 바람/부채로 결승까지 보낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "타액 공유 없이 먼저 도착하면 승리한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 타액 공유 없이 먼저 도착하면 승리한다.’"
          }
        ],
        "example": {
          "title": "탁구공불기게임 한 차례 예시",
          "lines": [
            "실제 행동: 손 대신 바람/부채로 결승까지 보낸다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "탁구공불기게임 · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "탁구공불기게임 · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "탁구공불기게임 · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "탁구공불기게임 · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "탁구공불기게임 · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "탁구공불기게임 · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "타액 공유 없이 먼저 도착하면 승리한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "bundle-memory",
      "displayName": "할머니게임",
      "aliases": [],
      "searchAliases": [
        "할머니게임"
      ],
      "family": "기억",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "보따리 안에로 시작한다",
        "action": "각자 물건 하나를 누적한다",
        "end": "전체 순서를 목표 바퀴까지 재현한다."
      },
      "sourceObservationIds": [
        "kr-042"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "할머니게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "할머니게임은 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "보따리 안에로 시작한다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 보따리 안에로 시작한다",
            "hostCue": "‘준비: 보따리 안에로 시작한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘전체 순서를 목표 바퀴까지 재현한다.’입니다.",
            "hostCue": "‘성공 조건: 전체 순서를 목표 바퀴까지 재현한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "각자 물건 하나를 누적한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 각자 물건 하나를 누적한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "전체 순서를 목표 바퀴까지 재현한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 전체 순서를 목표 바퀴까지 재현한다.’"
          }
        ],
        "example": {
          "title": "할머니게임 한 차례 예시",
          "lines": [
            "실제 행동: 각자 물건 하나를 누적한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "할머니게임 · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "할머니게임 · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "할머니게임 · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "할머니게임 · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "할머니게임 · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "할머니게임 · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "전체 순서를 목표 바퀴까지 재현한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "came-alone-rhythm",
      "displayName": "혼자왔습니다",
      "aliases": [],
      "searchAliases": [
        "혼자왔습니다"
      ],
      "family": "리듬/기억",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "인원 증가 구호와 동작을 정한다",
        "action": "순서대로 누적 재현한다",
        "end": "목표 인원 단계까지 협동한다."
      },
      "sourceObservationIds": [
        "kr-033"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "혼자왔습니다",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "혼자왔습니다는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "인원 증가 구호와 동작을 정한다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 인원 증가 구호와 동작을 정한다",
            "hostCue": "‘준비: 인원 증가 구호와 동작을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘목표 인원 단계까지 협동한다.’입니다.",
            "hostCue": "‘성공 조건: 목표 인원 단계까지 협동한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "순서대로 누적 재현한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 순서대로 누적 재현한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표 인원 단계까지 협동한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 목표 인원 단계까지 협동한다.’"
          }
        ],
        "example": {
          "title": "혼자왔습니다 한 차례 예시",
          "lines": [
            "실제 행동: 순서대로 누적 재현한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "혼자왔습니다 · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "혼자왔습니다 · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "혼자왔습니다 · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "혼자왔습니다 · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "혼자왔습니다 · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "혼자왔습니다 · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "목표 인원 단계까지 협동한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "hunmin-initials",
      "displayName": "훈민게임",
      "aliases": [],
      "searchAliases": [
        "훈민게임"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "초성 두 개를 뽑는다",
        "action": "맞는 단어를 차례로 말한다",
        "end": "중복/시간 초과 전 연속 기록."
      },
      "sourceObservationIds": [
        "kr-004"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "훈민게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "훈민게임은 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "초성 두 개를 뽑는다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 초성 두 개를 뽑는다",
            "hostCue": "‘준비: 초성 두 개를 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘중복/시간 초과 전 연속 기록.’입니다.",
            "hostCue": "‘성공 조건: 중복/시간 초과 전 연속 기록.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "맞는 단어를 차례로 말한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 맞는 단어를 차례로 말한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "중복/시간 초과 전 연속 기록. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 중복/시간 초과 전 연속 기록.’"
          }
        ],
        "example": {
          "title": "훈민게임 한 차례 예시",
          "lines": [
            "실제 행동: 맞는 단어를 차례로 말한다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "훈민게임 · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "훈민게임 · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "훈민게임 · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "훈민게임 · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "훈민게임 · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "훈민게임 · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "중복/시간 초과 전 연속 기록.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "pour-limit-puzzle",
      "displayName": "Anchorman",
      "aliases": [],
      "searchAliases": [
        "Anchorman"
      ],
      "family": "정밀",
      "playersMin": 3,
      "props": [
        "물",
        "컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "공용 물병과 표시 컵을 둔다",
        "action": "선을 넘지 않게 소량 따른다",
        "end": "넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다."
      },
      "sourceObservationIds": [
        "bdg-057"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Anchorman",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Anchorman는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "공용 물병과 표시 컵을 둔다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 공용 물병과 표시 컵을 둔다",
            "hostCue": "‘준비: 공용 물병과 표시 컵을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다.’입니다.",
            "hostCue": "‘성공 조건: 넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "선을 넘지 않게 소량 따른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 선을 넘지 않게 소량 따른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다.’"
          }
        ],
        "example": {
          "title": "Anchorman 한 차례 예시",
          "lines": [
            "실제 행동: 선을 넘지 않게 소량 따른다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Anchorman · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Anchorman · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Anchorman · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Anchorman · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Anchorman · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Anchorman · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "넘긴 사람은 정리 미션, 컵 물은 마시기 강제 없이 버리거나 나눈다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "coin-baseball",
      "displayName": "Baseball",
      "aliases": [],
      "searchAliases": [
        "Baseball"
      ],
      "family": "Coin/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "동전 성공 구간을 루로 정한다",
        "action": "차례로 튕겨 주자를 전진한다",
        "end": "이닝 득점을 비교한다."
      },
      "sourceObservationIds": [
        "wt-004"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Baseball",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Baseball는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "동전 성공 구간을 루로 정한다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 동전 성공 구간을 루로 정한다",
            "hostCue": "‘준비: 동전 성공 구간을 루로 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘이닝 득점을 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 이닝 득점을 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "차례로 튕겨 주자를 전진한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 차례로 튕겨 주자를 전진한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "이닝 득점을 비교한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 이닝 득점을 비교한다.’"
          }
        ],
        "example": {
          "title": "Baseball 한 차례 예시",
          "lines": [
            "실제 행동: 차례로 튕겨 주자를 전진한다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Baseball · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Baseball · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Baseball · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Baseball · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Baseball · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Baseball · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "이닝 득점을 비교한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "grid-target-cups",
      "displayName": "Battleshots",
      "aliases": [],
      "searchAliases": [
        "Battleshots"
      ],
      "family": "추리",
      "playersMin": 2,
      "props": [
        "격자",
        "빈컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "각자 격자에 빈 컵 함대를 숨긴다",
        "action": "좌표를 부른다",
        "end": "명중 컵을 제거해 먼저 전부 찾으면 이긴다."
      },
      "sourceObservationIds": [
        "bdg-080"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Battleshots",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Battleshots는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "각자 격자에 빈 컵 함대를 숨긴다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 각자 격자에 빈 컵 함대를 숨긴다",
            "hostCue": "‘준비: 각자 격자에 빈 컵 함대를 숨긴다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘명중 컵을 제거해 먼저 전부 찾으면 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 명중 컵을 제거해 먼저 전부 찾으면 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "좌표를 부른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 좌표를 부른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "명중 컵을 제거해 먼저 전부 찾으면 이긴다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 명중 컵을 제거해 먼저 전부 찾으면 이긴다.’"
          }
        ],
        "example": {
          "title": "Battleshots 한 차례 예시",
          "lines": [
            "실제 행동: 좌표를 부른다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Battleshots · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Battleshots · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Battleshots · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Battleshots · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Battleshots · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Battleshots · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "명중 컵을 제거해 먼저 전부 찾으면 이긴다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "ninety-nine-cards",
      "displayName": "Beer 99 #1",
      "aliases": [],
      "searchAliases": [
        "Beer 99 #1",
        "Beer 99 #2"
      ],
      "family": "Card/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "카드 값을 더하되 합계 99를 넘기지 않는다",
        "action": "특수 숫자 효과를 적용한다",
        "end": "마지막 생존 토큰이 승리한다."
      },
      "sourceObservationIds": [
        "wt-007",
        "wt-008"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer 99 #1",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer 99 #1는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "카드 값을 더하되 합계 99를 넘기지 않는다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 카드 값을 더하되 합계 99를 넘기지 않는다",
            "hostCue": "‘준비: 카드 값을 더하되 합계 99를 넘기지 않는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘마지막 생존 토큰이 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 마지막 생존 토큰이 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "특수 숫자 효과를 적용한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 특수 숫자 효과를 적용한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "마지막 생존 토큰이 승리한다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 마지막 생존 토큰이 승리한다.’"
          }
        ],
        "example": {
          "title": "Beer 99 #1 한 차례 예시",
          "lines": [
            "실제 행동: 특수 숫자 효과를 적용한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Beer 99 #1 · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer 99 #1 · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer 99 #1 · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer 99 #1 · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer 99 #1 · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer 99 #1 · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "마지막 생존 토큰이 승리한다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "table-ball-target",
      "displayName": "Beer Ball",
      "aliases": [],
      "searchAliases": [
        "Beer Ball"
      ],
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "공",
        "빈캔"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 팀의 빈 캔 목표를 둔다",
        "action": "공으로 상대 목표를 맞힌다",
        "end": "회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다."
      },
      "sourceObservationIds": [
        "bdg-058"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Ball",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Ball는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 팀의 빈 캔 목표를 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 두 팀의 빈 캔 목표를 둔다",
            "hostCue": "‘준비: 두 팀의 빈 캔 목표를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공으로 상대 목표를 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공으로 상대 목표를 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다.’"
          }
        ],
        "example": {
          "title": "Beer Ball 한 차례 예시",
          "lines": [
            "실제 행동: 공으로 상대 목표를 맞힌다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Beer Ball · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Ball · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Ball · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Ball · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Ball · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Ball · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "회수 전 팀 토큰을 옮겨 먼저 끝낸 팀이 승리한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "cup-baseball",
      "displayName": "Beer Baseball",
      "aliases": [],
      "searchAliases": [
        "Beer Baseball"
      ],
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "컵을 1~4루 점수로 둔다",
        "action": "팀별로 공을 던진다",
        "end": "이닝 뒤 득점을 비교한다."
      },
      "sourceObservationIds": [
        "bdg-054"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Baseball",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Baseball는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "컵을 1~4루 점수로 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 컵을 1~4루 점수로 둔다",
            "hostCue": "‘준비: 컵을 1~4루 점수로 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘이닝 뒤 득점을 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 이닝 뒤 득점을 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "팀별로 공을 던진다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 팀별로 공을 던진다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "이닝 뒤 득점을 비교한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 이닝 뒤 득점을 비교한다.’"
          }
        ],
        "example": {
          "title": "Beer Baseball 한 차례 예시",
          "lines": [
            "실제 행동: 팀별로 공을 던진다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Beer Baseball · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Baseball · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Baseball · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Baseball · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Baseball · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Baseball · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "이닝 뒤 득점을 비교한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "card-blow-stack",
      "displayName": "Beer Blow",
      "aliases": [],
      "searchAliases": [
        "Beer Blow"
      ],
      "family": "Card/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "컵 위 카드 더미를 둔다",
        "action": "한 번씩 불어 일부만 떨어뜨린다",
        "end": "마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다."
      },
      "sourceObservationIds": [
        "wt-009"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Blow",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Blow는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "컵 위 카드 더미를 둔다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 컵 위 카드 더미를 둔다",
            "hostCue": "‘준비: 컵 위 카드 더미를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다.’입니다.",
            "hostCue": "‘성공 조건: 마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "한 번씩 불어 일부만 떨어뜨린다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 한 번씩 불어 일부만 떨어뜨린다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다.’"
          }
        ],
        "example": {
          "title": "Beer Blow 한 차례 예시",
          "lines": [
            "실제 행동: 한 번씩 불어 일부만 떨어뜨린다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Beer Blow · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer Blow · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer Blow · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer Blow · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer Blow · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Beer Blow · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "마지막 카드를 떨어뜨린 사람이 정리 미션을 고른다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "chess-safe-variant",
      "displayName": "Beer Chess",
      "aliases": [],
      "searchAliases": [
        "Beer Chess"
      ],
      "family": "Board/Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "체스 한 판을 둔다",
        "action": "잡힌 말마다 마시기 대신 상대가 퀴즈/점수 중 하나를 고른다",
        "end": "체크메이트로 끝낸다."
      },
      "sourceObservationIds": [
        "wt-012"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Chess",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Chess는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "체스 한 판을 둔다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 체스 한 판을 둔다",
            "hostCue": "‘준비: 체스 한 판을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘체크메이트로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 체크메이트로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "잡힌 말마다 마시기 대신 상대가 퀴즈/점수 중 하나를 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 잡힌 말마다 마시기 대신 상대가 퀴즈/점수 중 하나를 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "체크메이트로 끝낸다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 체크메이트로 끝낸다.’"
          }
        ],
        "example": {
          "title": "Beer Chess 한 차례 예시",
          "lines": [
            "실제 행동: 잡힌 말마다 마시기 대신 상대가 퀴즈/점수 중 하나를 고른다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Beer Chess · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "Beer Chess · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Beer Chess · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "Beer Chess · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Beer Chess · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "Beer Chess · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "체크메이트로 끝낸다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "table-die",
      "displayName": "Beer Die",
      "aliases": [],
      "searchAliases": [
        "Beer Die"
      ],
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "주사위",
        "테이블"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 팀이 테이블 양쪽에 선다",
        "action": "주사위를 안전 높이로 던져 바운드 목표를 만든다",
        "end": "캐치/착지 점수를 겨룬다."
      },
      "sourceObservationIds": [
        "bdg-024"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Die",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Die는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 팀이 테이블 양쪽에 선다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 두 팀이 테이블 양쪽에 선다",
            "hostCue": "‘준비: 두 팀이 테이블 양쪽에 선다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘캐치/착지 점수를 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 캐치/착지 점수를 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "주사위를 안전 높이로 던져 바운드 목표를 만든다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 주사위를 안전 높이로 던져 바운드 목표를 만든다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "캐치/착지 점수를 겨룬다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 캐치/착지 점수를 겨룬다.’"
          }
        ],
        "example": {
          "title": "Beer Die 한 차례 예시",
          "lines": [
            "실제 행동: 주사위를 안전 높이로 던져 바운드 목표를 만든다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Beer Die · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Beer Die · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Beer Die · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Beer Die · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Beer Die · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Beer Die · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "캐치/착지 점수를 겨룬다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "party-decathlon",
      "displayName": "Beer Olympics",
      "aliases": [],
      "searchAliases": [
        "Beer Olympics"
      ],
      "family": "종합",
      "playersMin": 4,
      "props": [
        "선택"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "안전 미니게임 3~7개를 고른다",
        "action": "팀별 점수를 누적한다",
        "end": "총점과 페어플레이 배지를 함께 공개한다."
      },
      "sourceObservationIds": [
        "bdg-071"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Olympics",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Olympics는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "안전 미니게임 3~7개를 고른다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 안전 미니게임 3~7개를 고른다",
            "hostCue": "‘준비: 안전 미니게임 3~7개를 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘총점과 페어플레이 배지를 함께 공개한다.’입니다.",
            "hostCue": "‘성공 조건: 총점과 페어플레이 배지를 함께 공개한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "팀별 점수를 누적한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 팀별 점수를 누적한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "총점과 페어플레이 배지를 함께 공개한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 총점과 페어플레이 배지를 함께 공개한다.’"
          }
        ],
        "example": {
          "title": "Beer Olympics 한 차례 예시",
          "lines": [
            "실제 행동: 팀별 점수를 누적한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "Beer Olympics · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Beer Olympics · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Beer Olympics · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Beer Olympics · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Beer Olympics · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Beer Olympics · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "총점과 페어플레이 배지를 함께 공개한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "cup-target",
      "displayName": "Beer Pong",
      "aliases": [],
      "searchAliases": [
        "Beer Pong"
      ],
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "컵",
        "공"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "빈 컵을 삼각형으로 둔다",
        "action": "탁구공을 던져 컵을 맞힌다",
        "end": "맞은 컵을 제거하고 먼저 모두 없애면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-047",
        "wt-014"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Pong",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Pong는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "빈 컵을 삼각형으로 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 빈 컵을 삼각형으로 둔다",
            "hostCue": "‘준비: 빈 컵을 삼각형으로 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘맞은 컵을 제거하고 먼저 모두 없애면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 맞은 컵을 제거하고 먼저 모두 없애면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "탁구공을 던져 컵을 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 탁구공을 던져 컵을 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "맞은 컵을 제거하고 먼저 모두 없애면 승리한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 맞은 컵을 제거하고 먼저 모두 없애면 승리한다.’"
          }
        ],
        "example": {
          "title": "Beer Pong 한 차례 예시",
          "lines": [
            "실제 행동: 탁구공을 던져 컵을 맞힌다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Beer Pong · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pong · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pong · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pong · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pong · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pong · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "맞은 컵을 제거하고 먼저 모두 없애면 승리한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "coin-pot",
      "displayName": "Beer Pot",
      "aliases": [],
      "searchAliases": [
        "Beer Pot"
      ],
      "family": "Skill/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "중앙 빈 컵/그릇을 둔다",
        "action": "동전을 튕겨 목표 구역에 넣는다",
        "end": "정해진 시도 뒤 점수를 비교한다."
      },
      "sourceObservationIds": [
        "wt-015"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beer Pot",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beer Pot는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "중앙 빈 컵/그릇을 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 중앙 빈 컵/그릇을 둔다",
            "hostCue": "‘준비: 중앙 빈 컵/그릇을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘정해진 시도 뒤 점수를 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 시도 뒤 점수를 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동전을 튕겨 목표 구역에 넣는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동전을 튕겨 목표 구역에 넣는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 시도 뒤 점수를 비교한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 시도 뒤 점수를 비교한다.’"
          }
        ],
        "example": {
          "title": "Beer Pot 한 차례 예시",
          "lines": [
            "실제 행동: 동전을 튕겨 목표 구역에 넣는다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Beer Pot · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pot · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pot · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pot · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pot · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beer Pot · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "정해진 시도 뒤 점수를 비교한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "flying-disc-target",
      "displayName": "Beersbee",
      "aliases": [],
      "searchAliases": [
        "Beersbee"
      ],
      "family": "야외던지기",
      "playersMin": 4,
      "props": [
        "디스크",
        "목표"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "넓고 안전한 야외에 목표를 둔다",
        "action": "디스크로 목표를 맞힌다",
        "end": "명중/캐치 점수로 끝낸다."
      },
      "sourceObservationIds": [
        "bdg-075"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Beersbee",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Beersbee는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "넓고 안전한 야외에 목표를 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 넓고 안전한 야외에 목표를 둔다",
            "hostCue": "‘준비: 넓고 안전한 야외에 목표를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘명중/캐치 점수로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 명중/캐치 점수로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "디스크로 목표를 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 디스크로 목표를 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "명중/캐치 점수로 끝낸다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 명중/캐치 점수로 끝낸다.’"
          }
        ],
        "example": {
          "title": "Beersbee 한 차례 예시",
          "lines": [
            "실제 행동: 디스크로 목표를 맞힌다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Beersbee · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beersbee · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beersbee · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beersbee · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beersbee · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Beersbee · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "명중/캐치 점수로 끝낸다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "bizz-buzz",
      "displayName": "Bizz Buzz",
      "aliases": [],
      "searchAliases": [
        "Bizz Buzz",
        "Buzz"
      ],
      "family": "숫자반응",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "숫자를 순서대로 센다",
        "action": "배수는 정해진 말로 바꾼다",
        "end": "목표 수까지 실수 없이 가면 성공한다."
      },
      "sourceObservationIds": [
        "bdg-044",
        "wt-026"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Bizz Buzz",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Bizz Buzz는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "숫자를 순서대로 센다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 숫자를 순서대로 센다",
            "hostCue": "‘준비: 숫자를 순서대로 센다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘목표 수까지 실수 없이 가면 성공한다.’입니다.",
            "hostCue": "‘성공 조건: 목표 수까지 실수 없이 가면 성공한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "배수는 정해진 말로 바꾼다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 배수는 정해진 말로 바꾼다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표 수까지 실수 없이 가면 성공한다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 목표 수까지 실수 없이 가면 성공한다.’"
          }
        ],
        "example": {
          "title": "Bizz Buzz 한 차례 예시",
          "lines": [
            "실제 행동: 배수는 정해진 말로 바꾼다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Bizz Buzz · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Bizz Buzz · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Bizz Buzz · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Bizz Buzz · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Bizz Buzz · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Bizz Buzz · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "목표 수까지 실수 없이 가면 성공한다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "buffalo-hand-rule",
      "displayName": "Buffalo",
      "aliases": [],
      "searchAliases": [
        "Buffalo"
      ],
      "family": "지속규칙",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "세션 동안 특정 손 사용 금지를 켠다",
        "action": "위반을 발견하면 팀에 알린다",
        "end": "위반자는 안전 미션/점수 -1을 고른다."
      },
      "sourceObservationIds": [
        "bdg-032",
        "wt-024"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "team_score",
        "mode": "hybrid",
        "goal": "팀별 미션을 수행하고 점수를 먼저 모은다.",
        "fun": "역전 가능한 짧은 팀 대결",
        "firstAction": "팀을 나누고 선공 팀을 정한다.",
        "reward": "팀 점수와 승리 공개",
        "durationSec": 75,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Buffalo",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Buffalo는 팀별 미션을 수행하고 점수를 먼저 모은다. 역전 가능한 짧은 팀 대결을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 팀 나누기·미션·타이머·점수를 맡고, 준비물 미션은 화면 탭·말·몸짓 미션으로 대체합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "세션 동안 특정 손 사용 금지를 켠다",
          "앱이 팀 나누기·미션·타이머·점수를 맡고, 준비물 미션은 화면 탭·말·몸짓 미션으로 대체합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 세션 동안 특정 손 사용 금지를 켠다",
            "hostCue": "‘준비: 세션 동안 특정 손 사용 금지를 켠다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 팀별 미션을 수행하고 점수를 먼저 모은다. 라운드의 끝은 ‘위반자는 안전 미션/점수 -1을 고른다.’입니다.",
            "hostCue": "‘성공 조건: 위반자는 안전 미션/점수 -1을 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 팀을 나누고 선공 팀을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "위반을 발견하면 팀에 알린다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 위반을 발견하면 팀에 알린다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "위반자는 안전 미션/점수 -1을 고른다. 앱은 팀 점수와 승리 공개를 보여 줍니다.",
            "hostCue": "‘끝: 위반자는 안전 미션/점수 -1을 고른다.’"
          }
        ],
        "example": {
          "title": "Buffalo 한 차례 예시",
          "lines": [
            "실제 행동: 위반을 발견하면 팀에 알린다",
            "A팀이 화면 미션 20초 수행",
            "성공하면 A팀 +1",
            "같은 조건으로 B팀 수행"
          ]
        },
        "rounds": [
          {
            "title": "Buffalo · 1라운드",
            "prompt": "팀 미션: 팀 구호를 같은 박자로 3번",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Buffalo · 2라운드",
            "prompt": "팀 미션: 한 단어씩 이어 문장 완성",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Buffalo · 3라운드",
            "prompt": "팀 미션: 화면 신호에 팀 전원이 동시에 탭",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Buffalo · 4라운드",
            "prompt": "팀 미션: 몸짓 제시어 1개 맞히기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Buffalo · 5라운드",
            "prompt": "팀 미션: 관찰 조건 2개 찾기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Buffalo · 6라운드",
            "prompt": "팀 미션: 마지막 점수 뒤집기 미션",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          }
        ],
        "practice": {
          "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
          "actionLabel": "팀 점수 연습",
          "success": "팀별 수행과 점수 입력 순서를 익혔어요."
        },
        "winCondition": "위반자는 안전 미션/점수 -1을 고른다.",
        "tip": "팀 인원이 홀수면 한 명은 진행자를 맡고 다음 라운드에 팀과 교대합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "team_track",
          "labels": [
            "A팀",
            "미션",
            "B팀",
            "점수"
          ]
        }
      }
    },
    {
      "canonicalId": "bullshit-cards",
      "displayName": "Bullshit",
      "aliases": [],
      "searchAliases": [
        "Bullshit"
      ],
      "family": "카드블러핑",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "선언한 숫자의 카드를 뒤집어 낸다",
        "action": "의심하면 검증한다",
        "end": "먼저 손을 비우면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-012",
        "wt-025"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "bluff_strategy",
        "mode": "hosted",
        "goal": "선언을 믿을지 도전할지 선택해 판을 읽는다.",
        "fun": "허세와 역추리가 맞붙는 선택",
        "firstAction": "첫 선언이나 입찰을 제시한다.",
        "reward": "도전 성공과 전략 점수",
        "durationSec": 70,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Bullshit",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Bullshit는 선언을 믿을지 도전할지 선택해 판을 읽는다. 허세와 역추리가 맞붙는 선택을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "선언한 숫자의 카드를 뒤집어 낸다",
          "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 선언한 숫자의 카드를 뒤집어 낸다",
            "hostCue": "‘준비: 선언한 숫자의 카드를 뒤집어 낸다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 선언을 믿을지 도전할지 선택해 판을 읽는다. 라운드의 끝은 ‘먼저 손을 비우면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 먼저 손을 비우면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
            "hostCue": "‘연습만 한 번: 첫 선언이나 입찰을 제시한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "의심하면 검증한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 의심하면 검증한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "먼저 손을 비우면 승리한다. 앱은 도전 성공과 전략 점수를 보여 줍니다.",
            "hostCue": "‘끝: 먼저 손을 비우면 승리한다.’"
          }
        ],
        "example": {
          "title": "Bullshit 한 차례 예시",
          "lines": [
            "실제 행동: 의심하면 검증한다",
            "1번: ‘이번 기록은 4 이상이야’라고 선언",
            "2번: 믿기 또는 도전 선택",
            "도전이면 화면 결과를 공개"
          ]
        },
        "rounds": [
          {
            "title": "Bullshit · 1라운드",
            "prompt": "선언: “이번 무작위 수는 4 이상이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Bullshit · 2라운드",
            "prompt": "선언: “내 다음 선택은 왼쪽이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Bullshit · 3라운드",
            "prompt": "선언: “이번 기록은 앞선 기록보다 높다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Bullshit · 4라운드",
            "prompt": "선언: “나는 같은 선택을 두 번 했다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Bullshit · 5라운드",
            "prompt": "선언: “이번 결과는 짝수다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Bullshit · 6라운드",
            "prompt": "선언: “마지막 선택을 바꾸지 않았다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          }
        ],
        "practice": {
          "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
          "actionLabel": "연습 도전",
          "success": "선언→판단→공개 흐름을 익혔어요."
        },
        "winCondition": "먼저 손을 비우면 승리한다.",
        "tip": "개인 비밀이나 모욕을 블러핑 소재로 쓰지 않고 화면이 제시한 게임 정보만 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "challenge",
          "labels": [
            "선언",
            "믿기",
            "도전",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "cap-target",
      "displayName": "Caps",
      "aliases": [],
      "searchAliases": [
        "Caps"
      ],
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "병뚜껑",
        "컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "빈 컵을 목표로 둔다",
        "action": "병뚜껑을 던진다",
        "end": "명중 시 상대가 같은 시도로 방어하고 점수를 정한다."
      },
      "sourceObservationIds": [
        "bdg-102",
        "wt-027"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Caps",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Caps는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "빈 컵을 목표로 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 빈 컵을 목표로 둔다",
            "hostCue": "‘준비: 빈 컵을 목표로 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘명중 시 상대가 같은 시도로 방어하고 점수를 정한다.’입니다.",
            "hostCue": "‘성공 조건: 명중 시 상대가 같은 시도로 방어하고 점수를 정한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "병뚜껑을 던진다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 병뚜껑을 던진다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "명중 시 상대가 같은 시도로 방어하고 점수를 정한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 명중 시 상대가 같은 시도로 방어하고 점수를 정한다.’"
          }
        ],
        "example": {
          "title": "Caps 한 차례 예시",
          "lines": [
            "실제 행동: 병뚜껑을 던진다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Caps · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Caps · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Caps · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Caps · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Caps · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Caps · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "명중 시 상대가 같은 시도로 방어하고 점수를 정한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "cardinal-puff-memory",
      "displayName": "Cardinal Puff",
      "aliases": [],
      "searchAliases": [
        "Cardinal Puff"
      ],
      "family": "Vocal/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "긴 말·동작 순서를 시범 카드로 배운다",
        "action": "순서대로 재현한다",
        "end": "완주 횟수를 기록한다."
      },
      "sourceObservationIds": [
        "wt-028"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Cardinal Puff",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Cardinal Puff는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "긴 말·동작 순서를 시범 카드로 배운다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 긴 말·동작 순서를 시범 카드로 배운다",
            "hostCue": "‘준비: 긴 말·동작 순서를 시범 카드로 배운다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘완주 횟수를 기록한다.’입니다.",
            "hostCue": "‘성공 조건: 완주 횟수를 기록한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "순서대로 재현한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 순서대로 재현한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "완주 횟수를 기록한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 완주 횟수를 기록한다.’"
          }
        ],
        "example": {
          "title": "Cardinal Puff 한 차례 예시",
          "lines": [
            "실제 행동: 순서대로 재현한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "Cardinal Puff · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cardinal Puff · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cardinal Puff · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cardinal Puff · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cardinal Puff · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cardinal Puff · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "완주 횟수를 기록한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "chandelier-cups",
      "displayName": "Chandelier",
      "aliases": [],
      "searchAliases": [
        "Chandelier"
      ],
      "family": "던지기",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "중앙/개인 빈 컵을 둔다",
        "action": "공을 튕겨 목표 컵에 넣는다",
        "end": "개인 컵 명중은 점수, 중앙은 모두 위치 교대다."
      },
      "sourceObservationIds": [
        "bdg-052"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Chandelier",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Chandelier는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "중앙/개인 빈 컵을 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 중앙/개인 빈 컵을 둔다",
            "hostCue": "‘준비: 중앙/개인 빈 컵을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘개인 컵 명중은 점수, 중앙은 모두 위치 교대다.’입니다.",
            "hostCue": "‘성공 조건: 개인 컵 명중은 점수, 중앙은 모두 위치 교대다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공을 튕겨 목표 컵에 넣는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공을 튕겨 목표 컵에 넣는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "개인 컵 명중은 점수, 중앙은 모두 위치 교대다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 개인 컵 명중은 점수, 중앙은 모두 위치 교대다.’"
          }
        ],
        "example": {
          "title": "Chandelier 한 차례 예시",
          "lines": [
            "실제 행동: 공을 튕겨 목표 컵에 넣는다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Chandelier · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Chandelier · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Chandelier · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Chandelier · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Chandelier · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Chandelier · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "개인 컵 명중은 점수, 중앙은 모두 위치 교대다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "governor-count",
      "displayName": "Cheers to the Governor",
      "aliases": [],
      "searchAliases": [
        "21",
        "Cheers to the Governor"
      ],
      "family": "기억",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "1부터 목표까지 돌아가며 센다",
        "action": "특정 숫자 규칙을 성공자가 추가한다",
        "end": "목표에 도달하면 모두 성공한다."
      },
      "sourceObservationIds": [
        "bdg-033",
        "bdg-034"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Cheers to the Governor",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Cheers to the Governor는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "1부터 목표까지 돌아가며 센다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 1부터 목표까지 돌아가며 센다",
            "hostCue": "‘준비: 1부터 목표까지 돌아가며 센다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘목표에 도달하면 모두 성공한다.’입니다.",
            "hostCue": "‘성공 조건: 목표에 도달하면 모두 성공한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "특정 숫자 규칙을 성공자가 추가한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 특정 숫자 규칙을 성공자가 추가한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표에 도달하면 모두 성공한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 목표에 도달하면 모두 성공한다.’"
          }
        ],
        "example": {
          "title": "Cheers to the Governor 한 차례 예시",
          "lines": [
            "실제 행동: 특정 숫자 규칙을 성공자가 추가한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "Cheers to the Governor · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cheers to the Governor · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cheers to the Governor · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cheers to the Governor · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cheers to the Governor · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Cheers to the Governor · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "목표에 도달하면 모두 성공한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "multi-ball-cup-target",
      "displayName": "Civil War",
      "aliases": [],
      "searchAliases": [
        "Civil War"
      ],
      "family": "던지기",
      "playersMin": 6,
      "props": [
        "컵",
        "공3"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 팀에 빈 컵과 공을 나눈다",
        "action": "동시에 상대 컵을 노린다",
        "end": "안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다."
      },
      "sourceObservationIds": [
        "bdg-053"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Civil War",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Civil War는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "6명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 팀에 빈 컵과 공을 나눈다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "6명 이상이 모여 두 팀에 빈 컵과 공을 나눈다",
            "hostCue": "‘준비: 두 팀에 빈 컵과 공을 나눈다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동시에 상대 컵을 노린다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동시에 상대 컵을 노린다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다.’"
          }
        ],
        "example": {
          "title": "Civil War 한 차례 예시",
          "lines": [
            "실제 행동: 동시에 상대 컵을 노린다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Civil War · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Civil War · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Civil War · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Civil War · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Civil War · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Civil War · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "안전선 밖 이동 없이 먼저 컵을 없앤 팀이 이긴다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "ad-break-prompt",
      "displayName": "Commercial Break",
      "aliases": [],
      "searchAliases": [
        "Commercial Break"
      ],
      "family": "관찰/대화",
      "playersMin": 2,
      "props": [
        "영상"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "광고 휴식 때 짧은 주제를 연다",
        "action": "전원이 한 답을 낸다",
        "end": "일치 답으로 팀 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-067"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Commercial Break",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Commercial Break는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "광고 휴식 때 짧은 주제를 연다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 광고 휴식 때 짧은 주제를 연다",
            "hostCue": "‘준비: 광고 휴식 때 짧은 주제를 연다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘일치 답으로 팀 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 일치 답으로 팀 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "전원이 한 답을 낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 전원이 한 답을 낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "일치 답으로 팀 점수를 얻는다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 일치 답으로 팀 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Commercial Break 한 차례 예시",
          "lines": [
            "실제 행동: 전원이 한 답을 낸다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Commercial Break · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Commercial Break · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Commercial Break · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Commercial Break · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Commercial Break · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Commercial Break · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "일치 답으로 팀 점수를 얻는다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "coin-drop-precision",
      "displayName": "Drop the Dime",
      "aliases": [],
      "searchAliases": [
        "Drop the Dime"
      ],
      "family": "Skill/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "물이 든 투명 그릇 아래 목표를 둔다",
        "action": "동전을 떨어뜨려 목표와 겹친다",
        "end": "근접 점수를 합친다."
      },
      "sourceObservationIds": [
        "wt-033"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Drop the Dime",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Drop the Dime는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "물이 든 투명 그릇 아래 목표를 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 물이 든 투명 그릇 아래 목표를 둔다",
            "hostCue": "‘준비: 물이 든 투명 그릇 아래 목표를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘근접 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 근접 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동전을 떨어뜨려 목표와 겹친다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동전을 떨어뜨려 목표와 겹친다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "근접 점수를 합친다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 근접 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Drop the Dime 한 차례 예시",
          "lines": [
            "실제 행동: 동전을 떨어뜨려 목표와 겹친다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Drop the Dime · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drop the Dime · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drop the Dime · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drop the Dime · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drop the Dime · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drop the Dime · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "근접 점수를 합친다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "cornhole",
      "displayName": "Drunk Cornhole",
      "aliases": [],
      "searchAliases": [
        "Drunk Cornhole"
      ],
      "family": "던지기",
      "playersMin": 2,
      "props": [
        "보드",
        "주머니"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "보드와 주머니를 둔다",
        "action": "구멍/보드에 던진다",
        "end": "표준 점수만 쓰고 음주 요소를 제거한다."
      },
      "sourceObservationIds": [
        "bdg-076"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Drunk Cornhole",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Drunk Cornhole는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "보드와 주머니를 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 보드와 주머니를 둔다",
            "hostCue": "‘준비: 보드와 주머니를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘표준 점수만 쓰고 음주 요소를 제거한다.’입니다.",
            "hostCue": "‘성공 조건: 표준 점수만 쓰고 음주 요소를 제거한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "구멍/보드에 던진다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 구멍/보드에 던진다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "표준 점수만 쓰고 음주 요소를 제거한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 표준 점수만 쓰고 음주 요소를 제거한다.’"
          }
        ],
        "example": {
          "title": "Drunk Cornhole 한 차례 예시",
          "lines": [
            "실제 행동: 구멍/보드에 던진다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Drunk Cornhole · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drunk Cornhole · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drunk Cornhole · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drunk Cornhole · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drunk Cornhole · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Drunk Cornhole · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "표준 점수만 쓰고 음주 요소를 제거한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "tower-safe-prompts",
      "displayName": "Drunk Jenga",
      "aliases": [],
      "searchAliases": [
        "Drunk Jenga",
        "Jenga"
      ],
      "family": "균형",
      "playersMin": 2,
      "props": [
        "블록"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "블록에 안전 질문/점수를 붙인다",
        "action": "한 블록을 빼고 미션을 고른다",
        "end": "탑이 무너지면 모두 재시작 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-078",
        "wt-048"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Drunk Jenga",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Drunk Jenga는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "블록에 안전 질문/점수를 붙인다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 블록에 안전 질문/점수를 붙인다",
            "hostCue": "‘준비: 블록에 안전 질문/점수를 붙인다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘탑이 무너지면 모두 재시작 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 탑이 무너지면 모두 재시작 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "한 블록을 빼고 미션을 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 한 블록을 빼고 미션을 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "탑이 무너지면 모두 재시작 점수를 얻는다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 탑이 무너지면 모두 재시작 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Drunk Jenga 한 차례 예시",
          "lines": [
            "실제 행동: 한 블록을 빼고 미션을 고른다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Drunk Jenga · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Drunk Jenga · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Drunk Jenga · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Drunk Jenga · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Drunk Jenga · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Drunk Jenga · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "탑이 무너지면 모두 재시작 점수를 얻는다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "electricity-cards",
      "displayName": "Electricity",
      "aliases": [],
      "searchAliases": [
        "Electricity"
      ],
      "family": "팀반응",
      "playersMin": 4,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 팀이 손 신호 사슬을 만든다",
        "action": "목표 카드가 나오면 신호를 전달한다",
        "end": "끝 사람이 먼저 목표를 잡으면 점수다."
      },
      "sourceObservationIds": [
        "bdg-016"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Electricity",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Electricity는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 팀이 손 신호 사슬을 만든다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 두 팀이 손 신호 사슬을 만든다",
            "hostCue": "‘준비: 두 팀이 손 신호 사슬을 만든다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘끝 사람이 먼저 목표를 잡으면 점수다.’입니다.",
            "hostCue": "‘성공 조건: 끝 사람이 먼저 목표를 잡으면 점수다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "목표 카드가 나오면 신호를 전달한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 목표 카드가 나오면 신호를 전달한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "끝 사람이 먼저 목표를 잡으면 점수다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 끝 사람이 먼저 목표를 잡으면 점수다.’"
          }
        ],
        "example": {
          "title": "Electricity 한 차례 예시",
          "lines": [
            "실제 행동: 목표 카드가 나오면 신호를 전달한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Electricity · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Electricity · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Electricity · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Electricity · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Electricity · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Electricity · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "끝 사람이 먼저 목표를 잡으면 점수다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "fingers-guess",
      "displayName": "Fingers",
      "aliases": [],
      "searchAliases": [
        "Fingers"
      ],
      "family": "추리",
      "playersMin": 3,
      "props": [
        "손",
        "컵대체"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "모두 손가락 하나를 중앙에 둔다",
        "action": "남을 총 손가락 수를 예측하며 동시에 뺄지 정한다",
        "end": "정확히 맞히면 토큰을 얻는다."
      },
      "sourceObservationIds": [
        "bdg-035"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Fingers",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Fingers는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "모두 손가락 하나를 중앙에 둔다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 모두 손가락 하나를 중앙에 둔다",
            "hostCue": "‘준비: 모두 손가락 하나를 중앙에 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘정확히 맞히면 토큰을 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 정확히 맞히면 토큰을 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "남을 총 손가락 수를 예측하며 동시에 뺄지 정한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 남을 총 손가락 수를 예측하며 동시에 뺄지 정한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정확히 맞히면 토큰을 얻는다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 정확히 맞히면 토큰을 얻는다.’"
          }
        ],
        "example": {
          "title": "Fingers 한 차례 예시",
          "lines": [
            "실제 행동: 남을 총 손가락 수를 예측하며 동시에 뺄지 정한다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Fingers · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Fingers · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Fingers · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Fingers · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Fingers · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Fingers · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "정확히 맞히면 토큰을 얻는다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "flip-cup-relay",
      "displayName": "Flip Cup",
      "aliases": [],
      "searchAliases": [
        "Boat Race",
        "Boat Races",
        "Flip Cup",
        "Flip the cup"
      ],
      "family": "기술릴레이",
      "playersMin": 2,
      "props": [
        "빈컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "빈 컵을 가장자리에 둔다",
        "action": "차례로 손가락으로 뒤집어 세운다",
        "end": "전원이 먼저 성공한 팀이 이긴다."
      },
      "sourceObservationIds": [
        "bdg-048",
        "bdg-055",
        "wt-021",
        "wt-036"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Flip Cup",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Flip Cup는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "빈 컵을 가장자리에 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 빈 컵을 가장자리에 둔다",
            "hostCue": "‘준비: 빈 컵을 가장자리에 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘전원이 먼저 성공한 팀이 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 전원이 먼저 성공한 팀이 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "차례로 손가락으로 뒤집어 세운다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 차례로 손가락으로 뒤집어 세운다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "전원이 먼저 성공한 팀이 이긴다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 전원이 먼저 성공한 팀이 이긴다.’"
          }
        ],
        "example": {
          "title": "Flip Cup 한 차례 예시",
          "lines": [
            "실제 행동: 차례로 손가락으로 뒤집어 세운다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Flip Cup · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flip Cup · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flip Cup · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flip Cup · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flip Cup · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flip Cup · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "전원이 먼저 성공한 팀이 이긴다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "bottle-target-relay",
      "displayName": "Flunkyball",
      "aliases": [],
      "searchAliases": [
        "Flunkyball"
      ],
      "family": "야외던지기",
      "playersMin": 4,
      "props": [
        "공",
        "빈병"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 팀 사이 빈 목표를 둔다",
        "action": "공으로 쓰러뜨리고 회수한다",
        "end": "정해진 명중 수를 먼저 채우면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-090"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Flunkyball",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Flunkyball는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 팀 사이 빈 목표를 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 두 팀 사이 빈 목표를 둔다",
            "hostCue": "‘준비: 두 팀 사이 빈 목표를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘정해진 명중 수를 먼저 채우면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 명중 수를 먼저 채우면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공으로 쓰러뜨리고 회수한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공으로 쓰러뜨리고 회수한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 명중 수를 먼저 채우면 승리한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 명중 수를 먼저 채우면 승리한다.’"
          }
        ],
        "example": {
          "title": "Flunkyball 한 차례 예시",
          "lines": [
            "실제 행동: 공으로 쓰러뜨리고 회수한다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Flunkyball · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flunkyball · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flunkyball · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flunkyball · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flunkyball · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Flunkyball · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "정해진 명중 수를 먼저 채우면 승리한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "fuzzy-duck",
      "displayName": "Fuzzy Duck",
      "aliases": [],
      "searchAliases": [
        "Fuzzy Duck",
        "Fuzzy Duck #1",
        "Fuzzy Duck #2"
      ],
      "family": "발음반응",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "정방향 구호를 돌린다",
        "action": "전환어가 나오면 방향/구호를 바꾼다",
        "end": "실수 없는 연속 횟수를 기록한다."
      },
      "sourceObservationIds": [
        "bdg-043",
        "wt-037",
        "wt-038"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Fuzzy Duck",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Fuzzy Duck는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "정방향 구호를 돌린다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 정방향 구호를 돌린다",
            "hostCue": "‘준비: 정방향 구호를 돌린다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘실수 없는 연속 횟수를 기록한다.’입니다.",
            "hostCue": "‘성공 조건: 실수 없는 연속 횟수를 기록한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "전환어가 나오면 방향/구호를 바꾼다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 전환어가 나오면 방향/구호를 바꾼다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "실수 없는 연속 횟수를 기록한다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 실수 없는 연속 횟수를 기록한다.’"
          }
        ],
        "example": {
          "title": "Fuzzy Duck 한 차례 예시",
          "lines": [
            "실제 행동: 전환어가 나오면 방향/구호를 바꾼다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Fuzzy Duck · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Fuzzy Duck · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Fuzzy Duck · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Fuzzy Duck · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Fuzzy Duck · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Fuzzy Duck · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "실수 없는 연속 횟수를 기록한다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "give-take-cards",
      "displayName": "Give and Take",
      "aliases": [],
      "searchAliases": [
        "Give and Take",
        "Give One, Take One"
      ],
      "family": "카드운",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "개인 카드와 두 줄을 배치한다",
        "action": "같은 숫자가 나오면 안전 미션을 주거나 받는다",
        "end": "줄이 끝나면 종료한다."
      },
      "sourceObservationIds": [
        "bdg-014",
        "wt-039"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Give and Take",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Give and Take는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "개인 카드와 두 줄을 배치한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 개인 카드와 두 줄을 배치한다",
            "hostCue": "‘준비: 개인 카드와 두 줄을 배치한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘줄이 끝나면 종료한다.’입니다.",
            "hostCue": "‘성공 조건: 줄이 끝나면 종료한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "같은 숫자가 나오면 안전 미션을 주거나 받는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 같은 숫자가 나오면 안전 미션을 주거나 받는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "줄이 끝나면 종료한다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 줄이 끝나면 종료한다.’"
          }
        ],
        "example": {
          "title": "Give and Take 한 차례 예시",
          "lines": [
            "실제 행동: 같은 숫자가 나오면 안전 미션을 주거나 받는다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Give and Take · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Give and Take · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Give and Take · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Give and Take · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Give and Take · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Give and Take · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "줄이 끝나면 종료한다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "guess-the-note",
      "displayName": "Guess the Note",
      "aliases": [],
      "searchAliases": [
        "Guess the Note"
      ],
      "family": "Other/Low",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "권리 확보 음원의 한 음/짧은 효과음을 튼다",
        "action": "곡/악기/높낮이를 맞힌다",
        "end": "정답 점수를 합친다."
      },
      "sourceObservationIds": [
        "wt-040"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Guess the Note",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Guess the Note는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "권리 확보 음원의 한 음/짧은 효과음을 튼다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 권리 확보 음원의 한 음/짧은 효과음을 튼다",
            "hostCue": "‘준비: 권리 확보 음원의 한 음/짧은 효과음을 튼다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘정답 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 정답 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "곡/악기/높낮이를 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 곡/악기/높낮이를 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정답 점수를 합친다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 정답 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Guess the Note 한 차례 예시",
          "lines": [
            "실제 행동: 곡/악기/높낮이를 맞힌다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Guess the Note · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "Guess the Note · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Guess the Note · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "Guess the Note · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Guess the Note · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "Guess the Note · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "정답 점수를 합친다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "higher-lower",
      "displayName": "Higher or Lower",
      "aliases": [],
      "searchAliases": [
        "High or Low",
        "Higher or Lower"
      ],
      "family": "카드추리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "다음 카드가 높을지 낮을지 고른다",
        "action": "카드를 공개한다",
        "end": "연속 정답 점수를 겨룬다."
      },
      "sourceObservationIds": [
        "bdg-006",
        "wt-042"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Higher or Lower",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Higher or Lower는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "다음 카드가 높을지 낮을지 고른다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 다음 카드가 높을지 낮을지 고른다",
            "hostCue": "‘준비: 다음 카드가 높을지 낮을지 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘연속 정답 점수를 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 연속 정답 점수를 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "카드를 공개한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 카드를 공개한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "연속 정답 점수를 겨룬다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 연속 정답 점수를 겨룬다.’"
          }
        ],
        "example": {
          "title": "Higher or Lower 한 차례 예시",
          "lines": [
            "실제 행동: 카드를 공개한다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Higher or Lower · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "Higher or Lower · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Higher or Lower · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "Higher or Lower · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Higher or Lower · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "Higher or Lower · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "연속 정답 점수를 겨룬다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "hockey-cards",
      "displayName": "Hockey",
      "aliases": [],
      "searchAliases": [
        "Hockey"
      ],
      "family": "Card/Medium-Extremely high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "카드 숫자를 공격/수비 신호로 매핑한다",
        "action": "팀별로 공개·대응한다",
        "end": "정해진 피리어드 득점을 비교한다."
      },
      "sourceObservationIds": [
        "wt-043"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Hockey",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Hockey는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "카드 숫자를 공격/수비 신호로 매핑한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 카드 숫자를 공격/수비 신호로 매핑한다",
            "hostCue": "‘준비: 카드 숫자를 공격/수비 신호로 매핑한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘정해진 피리어드 득점을 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 피리어드 득점을 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "팀별로 공개·대응한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 팀별로 공개·대응한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 피리어드 득점을 비교한다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 피리어드 득점을 비교한다.’"
          }
        ],
        "example": {
          "title": "Hockey 한 차례 예시",
          "lines": [
            "실제 행동: 팀별로 공개·대응한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Hockey · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Hockey · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Hockey · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Hockey · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Hockey · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Hockey · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "정해진 피리어드 득점을 비교한다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "horse-race-cards",
      "displayName": "Horse Race",
      "aliases": [],
      "searchAliases": [
        "Horse Race"
      ],
      "family": "카드운",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "네 무늬를 말로 선택한다",
        "action": "공개 카드에 따라 트랙을 전진한다",
        "end": "먼저 결승에 온 무늬의 팀이 이긴다."
      },
      "sourceObservationIds": [
        "bdg-005"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Horse Race",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Horse Race는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "네 무늬를 말로 선택한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 네 무늬를 말로 선택한다",
            "hostCue": "‘준비: 네 무늬를 말로 선택한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘먼저 결승에 온 무늬의 팀이 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 먼저 결승에 온 무늬의 팀이 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공개 카드에 따라 트랙을 전진한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공개 카드에 따라 트랙을 전진한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "먼저 결승에 온 무늬의 팀이 이긴다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 먼저 결승에 온 무늬의 팀이 이긴다.’"
          }
        ],
        "example": {
          "title": "Horse Race 한 차례 예시",
          "lines": [
            "실제 행동: 공개 카드에 따라 트랙을 전진한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Horse Race · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Horse Race · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Horse Race · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Horse Race · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Horse Race · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Horse Race · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "먼저 결승에 온 무늬의 팀이 이긴다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "ice-tray-coin-target",
      "displayName": "Icetray Quarters",
      "aliases": [],
      "searchAliases": [
        "Icetray Quarters"
      ],
      "family": "Coin/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "얼음틀/칸 목표에 동전을 튕긴다",
        "action": "칸별 점수를 얻는다",
        "end": "위생상 음식/음료와 분리한다."
      },
      "sourceObservationIds": [
        "wt-045"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Icetray Quarters",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Icetray Quarters는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "얼음틀/칸 목표에 동전을 튕긴다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 얼음틀/칸 목표에 동전을 튕긴다",
            "hostCue": "‘준비: 얼음틀/칸 목표에 동전을 튕긴다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘위생상 음식/음료와 분리한다.’입니다.",
            "hostCue": "‘성공 조건: 위생상 음식/음료와 분리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "칸별 점수를 얻는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 칸별 점수를 얻는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "위생상 음식/음료와 분리한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 위생상 음식/음료와 분리한다.’"
          }
        ],
        "example": {
          "title": "Icetray Quarters 한 차례 예시",
          "lines": [
            "실제 행동: 칸별 점수를 얻는다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Icetray Quarters · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Icetray Quarters · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Icetray Quarters · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Icetray Quarters · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Icetray Quarters · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Icetray Quarters · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "위생상 음식/음료와 분리한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "indian-poker",
      "displayName": "Indian Poker",
      "aliases": [],
      "searchAliases": [
        "Indian Poker"
      ],
      "family": "카드심리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "자기만 못 보는 카드를 이마 앞에 든다",
        "action": "상대 행동을 보고 계속/포기한다",
        "end": "높은 카드가 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-011",
        "wt-046"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "bluff_strategy",
        "mode": "hosted",
        "goal": "선언을 믿을지 도전할지 선택해 판을 읽는다.",
        "fun": "허세와 역추리가 맞붙는 선택",
        "firstAction": "첫 선언이나 입찰을 제시한다.",
        "reward": "도전 성공과 전략 점수",
        "durationSec": 70,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Indian Poker",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Indian Poker는 선언을 믿을지 도전할지 선택해 판을 읽는다. 허세와 역추리가 맞붙는 선택을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "자기만 못 보는 카드를 이마 앞에 든다",
          "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 자기만 못 보는 카드를 이마 앞에 든다",
            "hostCue": "‘준비: 자기만 못 보는 카드를 이마 앞에 든다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 선언을 믿을지 도전할지 선택해 판을 읽는다. 라운드의 끝은 ‘높은 카드가 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 높은 카드가 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
            "hostCue": "‘연습만 한 번: 첫 선언이나 입찰을 제시한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "상대 행동을 보고 계속/포기한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 상대 행동을 보고 계속/포기한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "높은 카드가 점수를 얻는다. 앱은 도전 성공과 전략 점수를 보여 줍니다.",
            "hostCue": "‘끝: 높은 카드가 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Indian Poker 한 차례 예시",
          "lines": [
            "실제 행동: 상대 행동을 보고 계속/포기한다",
            "1번: ‘이번 기록은 4 이상이야’라고 선언",
            "2번: 믿기 또는 도전 선택",
            "도전이면 화면 결과를 공개"
          ]
        },
        "rounds": [
          {
            "title": "Indian Poker · 1라운드",
            "prompt": "선언: “이번 무작위 수는 4 이상이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Indian Poker · 2라운드",
            "prompt": "선언: “내 다음 선택은 왼쪽이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Indian Poker · 3라운드",
            "prompt": "선언: “이번 기록은 앞선 기록보다 높다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Indian Poker · 4라운드",
            "prompt": "선언: “나는 같은 선택을 두 번 했다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Indian Poker · 5라운드",
            "prompt": "선언: “이번 결과는 짝수다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Indian Poker · 6라운드",
            "prompt": "선언: “마지막 선택을 바꾸지 않았다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          }
        ],
        "practice": {
          "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
          "actionLabel": "연습 도전",
          "success": "선언→판단→공개 흐름을 익혔어요."
        },
        "winCondition": "높은 카드가 점수를 얻는다.",
        "tip": "개인 비밀이나 모욕을 블러핑 소재로 쓰지 않고 화면이 제시한 게임 정보만 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "challenge",
          "labels": [
            "선언",
            "믿기",
            "도전",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "irish-poker",
      "displayName": "Irish Poker",
      "aliases": [],
      "searchAliases": [
        "Irish Poker"
      ],
      "family": "카드추리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "네 장을 뒤집지 않고 놓는다",
        "action": "색/높낮이/안팎을 차례로 추리한다",
        "end": "정답 점수를 합친다."
      },
      "sourceObservationIds": [
        "bdg-010"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Irish Poker",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Irish Poker는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "네 장을 뒤집지 않고 놓는다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 네 장을 뒤집지 않고 놓는다",
            "hostCue": "‘준비: 네 장을 뒤집지 않고 놓는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘정답 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 정답 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "색/높낮이/안팎을 차례로 추리한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 색/높낮이/안팎을 차례로 추리한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정답 점수를 합친다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 정답 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Irish Poker 한 차례 예시",
          "lines": [
            "실제 행동: 색/높낮이/안팎을 차례로 추리한다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Irish Poker · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "Irish Poker · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Irish Poker · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "Irish Poker · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Irish Poker · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "Irish Poker · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "정답 점수를 합친다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "irish-snap",
      "displayName": "Irish Snap",
      "aliases": [],
      "searchAliases": [
        "Irish Snap",
        "Snap"
      ],
      "family": "카드반응",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "차례대로 카드를 뒤집으며 순서를 말한다",
        "action": "일치 시 중앙 신호를 먼저 누른다",
        "end": "카드가 적은 사람이 이긴다."
      },
      "sourceObservationIds": [
        "bdg-009",
        "wt-076"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Irish Snap",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Irish Snap는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "차례대로 카드를 뒤집으며 순서를 말한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 차례대로 카드를 뒤집으며 순서를 말한다",
            "hostCue": "‘준비: 차례대로 카드를 뒤집으며 순서를 말한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘카드가 적은 사람이 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 카드가 적은 사람이 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "일치 시 중앙 신호를 먼저 누른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 일치 시 중앙 신호를 먼저 누른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "카드가 적은 사람이 이긴다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 카드가 적은 사람이 이긴다.’"
          }
        ],
        "example": {
          "title": "Irish Snap 한 차례 예시",
          "lines": [
            "실제 행동: 일치 시 중앙 신호를 먼저 누른다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Irish Snap · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Irish Snap · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Irish Snap · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Irish Snap · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Irish Snap · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Irish Snap · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "카드가 적은 사람이 이긴다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "karaoke-roulette",
      "displayName": "Karaoke Roulette",
      "aliases": [],
      "searchAliases": [
        "Karaoke Roulette"
      ],
      "family": "노래",
      "playersMin": 2,
      "props": [
        "재생기"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "모두 가능한 곡/장르를 넣는다",
        "action": "무작위 곡의 짧은 구간을 선택한다",
        "end": "부르기/허밍/패스 후 박수 점수를 준다."
      },
      "sourceObservationIds": [
        "bdg-068"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Karaoke Roulette",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Karaoke Roulette는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "모두 가능한 곡/장르를 넣는다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 모두 가능한 곡/장르를 넣는다",
            "hostCue": "‘준비: 모두 가능한 곡/장르를 넣는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘부르기/허밍/패스 후 박수 점수를 준다.’입니다.",
            "hostCue": "‘성공 조건: 부르기/허밍/패스 후 박수 점수를 준다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "무작위 곡의 짧은 구간을 선택한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 무작위 곡의 짧은 구간을 선택한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "부르기/허밍/패스 후 박수 점수를 준다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 부르기/허밍/패스 후 박수 점수를 준다.’"
          }
        ],
        "example": {
          "title": "Karaoke Roulette 한 차례 예시",
          "lines": [
            "실제 행동: 무작위 곡의 짧은 구간을 선택한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Karaoke Roulette · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Karaoke Roulette · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Karaoke Roulette · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Karaoke Roulette · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Karaoke Roulette · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Karaoke Roulette · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "부르기/허밍/패스 후 박수 점수를 준다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "kings-cup",
      "displayName": "Kings Cup",
      "aliases": [],
      "searchAliases": [
        "Circle of Death",
        "Death Ring",
        "Kings",
        "Kings Cup"
      ],
      "family": "카드",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "원으로 카드를 둔다",
        "action": "뽑은 카드의 안전 미션을 수행한다",
        "end": "덱이 끝나면 팀 점수를 합친다."
      },
      "sourceObservationIds": [
        "bdg-001",
        "bdg-003",
        "wt-031",
        "wt-050"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Kings Cup",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Kings Cup는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "원으로 카드를 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 원으로 카드를 둔다",
            "hostCue": "‘준비: 원으로 카드를 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘덱이 끝나면 팀 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 덱이 끝나면 팀 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "뽑은 카드의 안전 미션을 수행한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 뽑은 카드의 안전 미션을 수행한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "덱이 끝나면 팀 점수를 합친다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 덱이 끝나면 팀 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Kings Cup 한 차례 예시",
          "lines": [
            "실제 행동: 뽑은 카드의 안전 미션을 수행한다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Kings Cup · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Kings Cup · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Kings Cup · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Kings Cup · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Kings Cup · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Kings Cup · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "덱이 끝나면 팀 점수를 합친다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "coin-spin-obstacles",
      "displayName": "Land Mines",
      "aliases": [],
      "searchAliases": [
        "Land Mines"
      ],
      "family": "기술",
      "playersMin": 3,
      "props": [
        "동전",
        "빈컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "동전을 회전시킨다",
        "action": "멈추기 전 정해진 손동작을 하고 잡는다",
        "end": "성공 시 빈 컵 장애물을 배치한다."
      },
      "sourceObservationIds": [
        "bdg-056"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Land Mines",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Land Mines는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "동전을 회전시킨다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 동전을 회전시킨다",
            "hostCue": "‘준비: 동전을 회전시킨다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘성공 시 빈 컵 장애물을 배치한다.’입니다.",
            "hostCue": "‘성공 조건: 성공 시 빈 컵 장애물을 배치한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "멈추기 전 정해진 손동작을 하고 잡는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 멈추기 전 정해진 손동작을 하고 잡는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "성공 시 빈 컵 장애물을 배치한다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 성공 시 빈 컵 장애물을 배치한다.’"
          }
        ],
        "example": {
          "title": "Land Mines 한 차례 예시",
          "lines": [
            "실제 행동: 멈추기 전 정해진 손동작을 하고 잡는다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Land Mines · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Land Mines · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Land Mines · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Land Mines · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Land Mines · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Land Mines · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "성공 시 빈 컵 장애물을 배치한다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "liars-dice",
      "displayName": "Liar's Dice",
      "aliases": [],
      "searchAliases": [
        "Liar's Dice"
      ],
      "family": "주사위블러핑",
      "playersMin": 2,
      "props": [
        "주사위",
        "컵"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "각자 주사위를 숨긴다",
        "action": "전체 수량을 추정해 입찰한다",
        "end": "도전 후 맞은 쪽이 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-020"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "bluff_strategy",
        "mode": "hosted",
        "goal": "선언을 믿을지 도전할지 선택해 판을 읽는다.",
        "fun": "허세와 역추리가 맞붙는 선택",
        "firstAction": "첫 선언이나 입찰을 제시한다.",
        "reward": "도전 성공과 전략 점수",
        "durationSec": 70,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Liar's Dice",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Liar's Dice는 선언을 믿을지 도전할지 선택해 판을 읽는다. 허세와 역추리가 맞붙는 선택을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "각자 주사위를 숨긴다",
          "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 각자 주사위를 숨긴다",
            "hostCue": "‘준비: 각자 주사위를 숨긴다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 선언을 믿을지 도전할지 선택해 판을 읽는다. 라운드의 끝은 ‘도전 후 맞은 쪽이 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 도전 후 맞은 쪽이 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
            "hostCue": "‘연습만 한 번: 첫 선언이나 입찰을 제시한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "전체 수량을 추정해 입찰한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 전체 수량을 추정해 입찰한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "도전 후 맞은 쪽이 점수를 얻는다. 앱은 도전 성공과 전략 점수를 보여 줍니다.",
            "hostCue": "‘끝: 도전 후 맞은 쪽이 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Liar's Dice 한 차례 예시",
          "lines": [
            "실제 행동: 전체 수량을 추정해 입찰한다",
            "1번: ‘이번 기록은 4 이상이야’라고 선언",
            "2번: 믿기 또는 도전 선택",
            "도전이면 화면 결과를 공개"
          ]
        },
        "rounds": [
          {
            "title": "Liar's Dice · 1라운드",
            "prompt": "선언: “이번 무작위 수는 4 이상이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Liar's Dice · 2라운드",
            "prompt": "선언: “내 다음 선택은 왼쪽이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Liar's Dice · 3라운드",
            "prompt": "선언: “이번 기록은 앞선 기록보다 높다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Liar's Dice · 4라운드",
            "prompt": "선언: “나는 같은 선택을 두 번 했다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Liar's Dice · 5라운드",
            "prompt": "선언: “이번 결과는 짝수다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Liar's Dice · 6라운드",
            "prompt": "선언: “마지막 선택을 바꾸지 않았다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          }
        ],
        "practice": {
          "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
          "actionLabel": "연습 도전",
          "success": "선언→판단→공개 흐름을 익혔어요."
        },
        "winCondition": "도전 후 맞은 쪽이 점수를 얻는다.",
        "tip": "개인 비밀이나 모욕을 블러핑 소재로 쓰지 않고 화면이 제시한 게임 정보만 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "challenge",
          "labels": [
            "선언",
            "믿기",
            "도전",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "lyric-master",
      "displayName": "Lyric Master",
      "aliases": [],
      "searchAliases": [
        "Lyric Master"
      ],
      "family": "음악기억",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "공개 라이선스/사용자 기억 기반 시작 구절 주제를 낸다",
        "action": "다음 말을 직접 이어 부르지 않고 제목/다음 단어를 답한다",
        "end": "정답 점수를 합친다."
      },
      "sourceObservationIds": [
        "bdg-064"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Lyric Master",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Lyric Master는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "공개 라이선스/사용자 기억 기반 시작 구절 주제를 낸다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 공개 라이선스/사용자 기억 기반 시작 구절 주제를 낸다",
            "hostCue": "‘준비: 공개 라이선스/사용자 기억 기반 시작 구절 주제를 낸다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘정답 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 정답 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "다음 말을 직접 이어 부르지 않고 제목/다음 단어를 답한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 다음 말을 직접 이어 부르지 않고 제목/다음 단어를 답한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정답 점수를 합친다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정답 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Lyric Master 한 차례 예시",
          "lines": [
            "실제 행동: 다음 말을 직접 이어 부르지 않고 제목/다음 단어를 답한다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Lyric Master · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Lyric Master · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Lyric Master · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Lyric Master · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Lyric Master · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Lyric Master · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "정답 점수를 합친다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "thumb-master",
      "displayName": "Master of the Thumb",
      "aliases": [],
      "searchAliases": [
        "Master of the Thumb"
      ],
      "family": "Skill/Low",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "한 명이 임의 시점에 엄지를 댄다",
        "action": "다른 사람도 따라 한다",
        "end": "마지막 반응은 점수 -1/패스를 고른다."
      },
      "sourceObservationIds": [
        "wt-051"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Master of the Thumb",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Master of the Thumb는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "한 명이 임의 시점에 엄지를 댄다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 한 명이 임의 시점에 엄지를 댄다",
            "hostCue": "‘준비: 한 명이 임의 시점에 엄지를 댄다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘마지막 반응은 점수 -1/패스를 고른다.’입니다.",
            "hostCue": "‘성공 조건: 마지막 반응은 점수 -1/패스를 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "다른 사람도 따라 한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 다른 사람도 따라 한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "마지막 반응은 점수 -1/패스를 고른다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 마지막 반응은 점수 -1/패스를 고른다.’"
          }
        ],
        "example": {
          "title": "Master of the Thumb 한 차례 예시",
          "lines": [
            "실제 행동: 다른 사람도 따라 한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Master of the Thumb · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Master of the Thumb · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Master of the Thumb · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Master of the Thumb · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Master of the Thumb · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Master of the Thumb · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "마지막 반응은 점수 -1/패스를 고른다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "medusa-look",
      "displayName": "Medusa",
      "aliases": [],
      "searchAliases": [
        "Medusa"
      ],
      "family": "눈치",
      "playersMin": 4,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "모두 고개를 숙인다",
        "action": "신호에 한 사람을 본다",
        "end": "서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다."
      },
      "sourceObservationIds": [
        "bdg-031"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Medusa",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Medusa는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "모두 고개를 숙인다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 모두 고개를 숙인다",
            "hostCue": "‘준비: 모두 고개를 숙인다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다.’입니다.",
            "hostCue": "‘성공 조건: 서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "신호에 한 사람을 본다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 신호에 한 사람을 본다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다.’"
          }
        ],
        "example": {
          "title": "Medusa 한 차례 예시",
          "lines": [
            "실제 행동: 신호에 한 사람을 본다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Medusa · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Medusa · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Medusa · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Medusa · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Medusa · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Medusa · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "서로 눈이 맞은 쌍이 토큰을 얻고 다음 라운드로 간다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "mexicali",
      "displayName": "Mexicali",
      "aliases": [],
      "searchAliases": [
        "Mexicali"
      ],
      "family": "주사위블러핑",
      "playersMin": 2,
      "props": [
        "주사위",
        "컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 주사위를 숨겨 굴린다",
        "action": "이전보다 높은 값이라고 선언한다",
        "end": "거짓 도전 결과로 토큰을 이동한다."
      },
      "sourceObservationIds": [
        "bdg-021",
        "wt-052"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "bluff_strategy",
        "mode": "hosted",
        "goal": "선언을 믿을지 도전할지 선택해 판을 읽는다.",
        "fun": "허세와 역추리가 맞붙는 선택",
        "firstAction": "첫 선언이나 입찰을 제시한다.",
        "reward": "도전 성공과 전략 점수",
        "durationSec": 70,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Mexicali",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Mexicali는 선언을 믿을지 도전할지 선택해 판을 읽는다. 허세와 역추리가 맞붙는 선택을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 주사위를 숨겨 굴린다",
          "앱이 선언 차례·도전 수·결과 공개를 기록합니다. 카드가 필요한 원형은 화면 선언판으로 바뀝니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 두 주사위를 숨겨 굴린다",
            "hostCue": "‘준비: 두 주사위를 숨겨 굴린다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 선언을 믿을지 도전할지 선택해 판을 읽는다. 라운드의 끝은 ‘거짓 도전 결과로 토큰을 이동한다.’입니다.",
            "hostCue": "‘성공 조건: 거짓 도전 결과로 토큰을 이동한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
            "hostCue": "‘연습만 한 번: 첫 선언이나 입찰을 제시한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "이전보다 높은 값이라고 선언한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 이전보다 높은 값이라고 선언한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "거짓 도전 결과로 토큰을 이동한다. 앱은 도전 성공과 전략 점수를 보여 줍니다.",
            "hostCue": "‘끝: 거짓 도전 결과로 토큰을 이동한다.’"
          }
        ],
        "example": {
          "title": "Mexicali 한 차례 예시",
          "lines": [
            "실제 행동: 이전보다 높은 값이라고 선언한다",
            "1번: ‘이번 기록은 4 이상이야’라고 선언",
            "2번: 믿기 또는 도전 선택",
            "도전이면 화면 결과를 공개"
          ]
        },
        "rounds": [
          {
            "title": "Mexicali · 1라운드",
            "prompt": "선언: “이번 무작위 수는 4 이상이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Mexicali · 2라운드",
            "prompt": "선언: “내 다음 선택은 왼쪽이다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Mexicali · 3라운드",
            "prompt": "선언: “이번 기록은 앞선 기록보다 높다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Mexicali · 4라운드",
            "prompt": "선언: “나는 같은 선택을 두 번 했다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Mexicali · 5라운드",
            "prompt": "선언: “이번 결과는 짝수다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          },
          {
            "title": "Mexicali · 6라운드",
            "prompt": "선언: “마지막 선택을 바꾸지 않았다”",
            "options": [
              "믿기",
              "도전"
            ],
            "reveal": "도전을 고르면 앱 결과 또는 기록을 공개합니다."
          }
        ],
        "practice": {
          "instruction": "연습 선언을 한 번 말하고, 다음 사람이 ‘믿기’ 또는 ‘도전’을 골라 보세요.",
          "actionLabel": "연습 도전",
          "success": "선언→판단→공개 흐름을 익혔어요."
        },
        "winCondition": "거짓 도전 결과로 토큰을 이동한다.",
        "tip": "개인 비밀이나 모욕을 블러핑 소재로 쓰지 않고 화면이 제시한 게임 정보만 사용합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "challenge",
          "labels": [
            "선언",
            "믿기",
            "도전",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "mexican-dice",
      "displayName": "Mexican",
      "aliases": [],
      "searchAliases": [
        "Mexican"
      ],
      "family": "Dice/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 주사위 조합 순위를 정한다",
        "action": "숨겨 굴려 선언/도전한다",
        "end": "검증 결과로 토큰을 옮긴다."
      },
      "sourceObservationIds": [
        "wt-053"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Mexican",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Mexican는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 주사위 조합 순위를 정한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 두 주사위 조합 순위를 정한다",
            "hostCue": "‘준비: 두 주사위 조합 순위를 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘검증 결과로 토큰을 옮긴다.’입니다.",
            "hostCue": "‘성공 조건: 검증 결과로 토큰을 옮긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "숨겨 굴려 선언/도전한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 숨겨 굴려 선언/도전한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "검증 결과로 토큰을 옮긴다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 검증 결과로 토큰을 옮긴다.’"
          }
        ],
        "example": {
          "title": "Mexican 한 차례 예시",
          "lines": [
            "실제 행동: 숨겨 굴려 선언/도전한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Mexican · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Mexican · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Mexican · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Mexican · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Mexican · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Mexican · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "검증 결과로 토큰을 옮긴다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "moose-dice",
      "displayName": "Moose",
      "aliases": [],
      "searchAliases": [
        "Moose"
      ],
      "family": "주사위반응",
      "playersMin": 3,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "특정 주사위 조합에 공통 손동작을 정한다",
        "action": "굴릴 때 즉시 반응한다",
        "end": "가장 늦은 사람은 점수 -1/패스를 고른다."
      },
      "sourceObservationIds": [
        "bdg-107"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Moose",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Moose는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "특정 주사위 조합에 공통 손동작을 정한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 특정 주사위 조합에 공통 손동작을 정한다",
            "hostCue": "‘준비: 특정 주사위 조합에 공통 손동작을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘가장 늦은 사람은 점수 -1/패스를 고른다.’입니다.",
            "hostCue": "‘성공 조건: 가장 늦은 사람은 점수 -1/패스를 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "굴릴 때 즉시 반응한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 굴릴 때 즉시 반응한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "가장 늦은 사람은 점수 -1/패스를 고른다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 가장 늦은 사람은 점수 -1/패스를 고른다.’"
          }
        ],
        "example": {
          "title": "Moose 한 차례 예시",
          "lines": [
            "실제 행동: 굴릴 때 즉시 반응한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Moose · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Moose · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Moose · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Moose · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Moose · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Moose · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "가장 늦은 사람은 점수 -1/패스를 고른다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "most-likely",
      "displayName": "Most Likely To",
      "aliases": [],
      "searchAliases": [
        "Most Likely To"
      ],
      "family": "지목",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "비모욕 질문을 읽는다",
        "action": "동시에 자신/동의한 선택지를 가리킨다",
        "end": "다수 일치로 팀 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-027"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Most Likely To",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Most Likely To는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "비모욕 질문을 읽는다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 비모욕 질문을 읽는다",
            "hostCue": "‘준비: 비모욕 질문을 읽는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘다수 일치로 팀 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 다수 일치로 팀 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동시에 자신/동의한 선택지를 가리킨다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동시에 자신/동의한 선택지를 가리킨다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "다수 일치로 팀 점수를 얻는다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 다수 일치로 팀 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Most Likely To 한 차례 예시",
          "lines": [
            "실제 행동: 동시에 자신/동의한 선택지를 가리킨다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Most Likely To · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Most Likely To · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Most Likely To · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Most Likely To · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Most Likely To · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Most Likely To · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "다수 일치로 팀 점수를 얻는다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "screen-trope-bingo",
      "displayName": "Movie Drinking Game",
      "aliases": [],
      "searchAliases": [
        "Movie Drinking Game",
        "TV Show Drinking Game"
      ],
      "family": "영상관찰",
      "playersMin": 2,
      "props": [
        "영상",
        "빙고"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "작품 전에 일반 trope 칸을 고른다",
        "action": "장면이 나오면 칸을 표시한다",
        "end": "한 줄을 먼저 완성하면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-061",
        "bdg-062"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Movie Drinking Game",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Movie Drinking Game는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "작품 전에 일반 trope 칸을 고른다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 작품 전에 일반 trope 칸을 고른다",
            "hostCue": "‘준비: 작품 전에 일반 trope 칸을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘한 줄을 먼저 완성하면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 한 줄을 먼저 완성하면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "장면이 나오면 칸을 표시한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 장면이 나오면 칸을 표시한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "한 줄을 먼저 완성하면 승리한다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 한 줄을 먼저 완성하면 승리한다.’"
          }
        ],
        "example": {
          "title": "Movie Drinking Game 한 차례 예시",
          "lines": [
            "실제 행동: 장면이 나오면 칸을 표시한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "Movie Drinking Game · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Movie Drinking Game · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Movie Drinking Game · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Movie Drinking Game · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Movie Drinking Game · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Movie Drinking Game · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "한 줄을 먼저 완성하면 승리한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "music-roulette",
      "displayName": "Music Roulette",
      "aliases": [],
      "searchAliases": [
        "Music Roulette"
      ],
      "family": "음악추리",
      "playersMin": 2,
      "props": [
        "재생기"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "각자 재생 가능한 곡을 큐에 넣는다",
        "action": "무작위 일부를 듣는다",
        "end": "제목/가수/제출자를 맞혀 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-063"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Music Roulette",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Music Roulette는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "각자 재생 가능한 곡을 큐에 넣는다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 각자 재생 가능한 곡을 큐에 넣는다",
            "hostCue": "‘준비: 각자 재생 가능한 곡을 큐에 넣는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘제목/가수/제출자를 맞혀 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 제목/가수/제출자를 맞혀 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "무작위 일부를 듣는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 무작위 일부를 듣는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "제목/가수/제출자를 맞혀 점수를 얻는다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 제목/가수/제출자를 맞혀 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Music Roulette 한 차례 예시",
          "lines": [
            "실제 행동: 무작위 일부를 듣는다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Music Roulette · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Music Roulette · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Music Roulette · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Music Roulette · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Music Roulette · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Music Roulette · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "제목/가수/제출자를 맞혀 점수를 얻는다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "never-have-i-ever",
      "displayName": "Never Have I Ever",
      "aliases": [],
      "searchAliases": [
        "I Never",
        "Never Have I Ever"
      ],
      "family": "대화",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "안전한 질문만 연다",
        "action": "해당되면 손가락을 접거나 토큰을 놓는다",
        "end": "패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다."
      },
      "sourceObservationIds": [
        "bdg-026",
        "wt-044"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Never Have I Ever",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Never Have I Ever는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "안전한 질문만 연다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 안전한 질문만 연다",
            "hostCue": "‘준비: 안전한 질문만 연다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다.’입니다.",
            "hostCue": "‘성공 조건: 패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "해당되면 손가락을 접거나 토큰을 놓는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 해당되면 손가락을 접거나 토큰을 놓는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다.’"
          }
        ],
        "example": {
          "title": "Never Have I Ever 한 차례 예시",
          "lines": [
            "실제 행동: 해당되면 손가락을 접거나 토큰을 놓는다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Never Have I Ever · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Never Have I Ever · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Never Have I Ever · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Never Have I Ever · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Never Have I Ever · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Never Have I Ever · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "패스 가능, 먼저 토큰이 끝난 사람 없이 함께 종료한다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "ox-quiz",
      "displayName": "O.X게임",
      "aliases": [],
      "searchAliases": [
        "O.X게임"
      ],
      "family": "퀴즈",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "사실 문장을 읽는다",
        "action": "O/X를 동시에 고른다",
        "end": "해설과 정답 점수를 공개한다."
      },
      "sourceObservationIds": [
        "kr-005"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "O.X게임",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "O.X게임은 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "사실 문장을 읽는다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 사실 문장을 읽는다",
            "hostCue": "‘준비: 사실 문장을 읽는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘해설과 정답 점수를 공개한다.’입니다.",
            "hostCue": "‘성공 조건: 해설과 정답 점수를 공개한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "O/X를 동시에 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: O/X를 동시에 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "해설과 정답 점수를 공개한다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 해설과 정답 점수를 공개한다.’"
          }
        ],
        "example": {
          "title": "O.X게임 한 차례 예시",
          "lines": [
            "실제 행동: O/X를 동시에 고른다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "O.X게임 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "O.X게임 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "O.X게임 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "O.X게임 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "O.X게임 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "O.X게임 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "해설과 정답 점수를 공개한다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "one-big-chicken",
      "displayName": "One Big Chicken",
      "aliases": [],
      "searchAliases": [
        "One Big Chicken"
      ],
      "family": "Vocal/High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "누적 숫자와 동물 구호를 순서대로 말한다",
        "action": "지정된 반복/동작을 기억한다",
        "end": "목표 단계까지 협동한다."
      },
      "sourceObservationIds": [
        "wt-056"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "One Big Chicken",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "One Big Chicken는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "누적 숫자와 동물 구호를 순서대로 말한다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 누적 숫자와 동물 구호를 순서대로 말한다",
            "hostCue": "‘준비: 누적 숫자와 동물 구호를 순서대로 말한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘목표 단계까지 협동한다.’입니다.",
            "hostCue": "‘성공 조건: 목표 단계까지 협동한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "지정된 반복/동작을 기억한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 지정된 반복/동작을 기억한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표 단계까지 협동한다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 목표 단계까지 협동한다.’"
          }
        ],
        "example": {
          "title": "One Big Chicken 한 차례 예시",
          "lines": [
            "실제 행동: 지정된 반복/동작을 기억한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "One Big Chicken · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "One Big Chicken · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "One Big Chicken · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "One Big Chicken · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "One Big Chicken · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "One Big Chicken · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "목표 단계까지 협동한다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "paranoia-question",
      "displayName": "Paranoia",
      "aliases": [],
      "searchAliases": [
        "Paranoia"
      ],
      "family": "질문추리",
      "playersMin": 3,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "질문을 귓속말 대신 화면에 비공개 표시한다",
        "action": "답 대상은 공개하되 질문 공개 여부를 선택한다",
        "end": "누구나 패스 후 다음으로 간다."
      },
      "sourceObservationIds": [
        "bdg-028"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Paranoia",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Paranoia는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "질문을 귓속말 대신 화면에 비공개 표시한다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 질문을 귓속말 대신 화면에 비공개 표시한다",
            "hostCue": "‘준비: 질문을 귓속말 대신 화면에 비공개 표시한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘누구나 패스 후 다음으로 간다.’입니다.",
            "hostCue": "‘성공 조건: 누구나 패스 후 다음으로 간다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "답 대상은 공개하되 질문 공개 여부를 선택한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 답 대상은 공개하되 질문 공개 여부를 선택한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "누구나 패스 후 다음으로 간다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 누구나 패스 후 다음으로 간다.’"
          }
        ],
        "example": {
          "title": "Paranoia 한 차례 예시",
          "lines": [
            "실제 행동: 답 대상은 공개하되 질문 공개 여부를 선택한다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Paranoia · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Paranoia · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Paranoia · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Paranoia · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Paranoia · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Paranoia · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "누구나 패스 후 다음으로 간다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "venue-scorecard",
      "displayName": "Pub Golf",
      "aliases": [],
      "searchAliases": [
        "Pub Golf"
      ],
      "family": "이동/종합",
      "playersMin": 2,
      "props": [
        "장소"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "장소별 안전 미션과 파를 정한다",
        "action": "음료 섭취량 대신 퀴즈/사진 없는 관찰 과제를 완료한다",
        "end": "낮은 점수가 승리한다."
      },
      "sourceObservationIds": [
        "bdg-092"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Pub Golf",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Pub Golf는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "장소별 안전 미션과 파를 정한다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 장소별 안전 미션과 파를 정한다",
            "hostCue": "‘준비: 장소별 안전 미션과 파를 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘낮은 점수가 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 낮은 점수가 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "음료 섭취량 대신 퀴즈/사진 없는 관찰 과제를 완료한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 음료 섭취량 대신 퀴즈/사진 없는 관찰 과제를 완료한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "낮은 점수가 승리한다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 낮은 점수가 승리한다.’"
          }
        ],
        "example": {
          "title": "Pub Golf 한 차례 예시",
          "lines": [
            "실제 행동: 음료 섭취량 대신 퀴즈/사진 없는 관찰 과제를 완료한다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Pub Golf · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "Pub Golf · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Pub Golf · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "Pub Golf · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Pub Golf · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "Pub Golf · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "낮은 점수가 승리한다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "pyramid-cards",
      "displayName": "Pyramid",
      "aliases": [],
      "searchAliases": [
        "Pyramid"
      ],
      "family": "카드기억",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "손패와 피라미드 카드를 배치한다",
        "action": "공개 숫자와 같은 손패를 찾아 주장한다",
        "end": "검증된 매치로 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-013"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Pyramid",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Pyramid는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "손패와 피라미드 카드를 배치한다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 손패와 피라미드 카드를 배치한다",
            "hostCue": "‘준비: 손패와 피라미드 카드를 배치한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘검증된 매치로 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 검증된 매치로 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공개 숫자와 같은 손패를 찾아 주장한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공개 숫자와 같은 손패를 찾아 주장한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "검증된 매치로 점수를 얻는다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 검증된 매치로 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Pyramid 한 차례 예시",
          "lines": [
            "실제 행동: 공개 숫자와 같은 손패를 찾아 주장한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "Pyramid · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Pyramid · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Pyramid · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Pyramid · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Pyramid · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Pyramid · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "검증된 매치로 점수를 얻는다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "coin-target",
      "displayName": "Quarters",
      "aliases": [],
      "searchAliases": [
        "Beer Bomb",
        "Pennies In a Pitcher",
        "Quarters",
        "Super Quarters"
      ],
      "family": "기술",
      "playersMin": 2,
      "props": [
        "동전",
        "컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "빈 컵을 목표로 둔다",
        "action": "동전을 한 번 튕겨 넣는다",
        "end": "정해진 횟수의 성공 점수를 겨룬다."
      },
      "sourceObservationIds": [
        "bdg-049",
        "wt-010",
        "wt-057",
        "wt-060",
        "wt-085"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Quarters",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Quarters는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "빈 컵을 목표로 둔다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 빈 컵을 목표로 둔다",
            "hostCue": "‘준비: 빈 컵을 목표로 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘정해진 횟수의 성공 점수를 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 횟수의 성공 점수를 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동전을 한 번 튕겨 넣는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동전을 한 번 튕겨 넣는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 횟수의 성공 점수를 겨룬다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 횟수의 성공 점수를 겨룬다.’"
          }
        ],
        "example": {
          "title": "Quarters 한 차례 예시",
          "lines": [
            "실제 행동: 동전을 한 번 튕겨 넣는다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Quarters · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Quarters · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Quarters · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Quarters · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Quarters · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Quarters · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "정해진 횟수의 성공 점수를 겨룬다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "queens-cards",
      "displayName": "Queens",
      "aliases": [],
      "searchAliases": [
        "Queens"
      ],
      "family": "Card/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "여왕 카드의 질문/팀 규칙을 정한다",
        "action": "차례로 카드를 내며 적용한다",
        "end": "손패가 끝나면 점수를 합친다."
      },
      "sourceObservationIds": [
        "wt-061"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Queens",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Queens는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "여왕 카드의 질문/팀 규칙을 정한다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 여왕 카드의 질문/팀 규칙을 정한다",
            "hostCue": "‘준비: 여왕 카드의 질문/팀 규칙을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘손패가 끝나면 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 손패가 끝나면 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "차례로 카드를 내며 적용한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 차례로 카드를 내며 적용한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "손패가 끝나면 점수를 합친다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 손패가 끝나면 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Queens 한 차례 예시",
          "lines": [
            "실제 행동: 차례로 카드를 내며 적용한다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Queens · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Queens · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Queens · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Queens · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Queens · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Queens · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "손패가 끝나면 점수를 합친다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "questions-only",
      "displayName": "Questions",
      "aliases": [],
      "searchAliases": [
        "Questions"
      ],
      "family": "즉흥",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "장면을 뽑는다",
        "action": "질문으로만 대화한다",
        "end": "평서문/반복/지연 시 상대가 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-042",
        "wt-062"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Questions",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Questions는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "장면을 뽑는다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 장면을 뽑는다",
            "hostCue": "‘준비: 장면을 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘평서문/반복/지연 시 상대가 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 평서문/반복/지연 시 상대가 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "질문으로만 대화한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 질문으로만 대화한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "평서문/반복/지연 시 상대가 점수를 얻는다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 평서문/반복/지연 시 상대가 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Questions 한 차례 예시",
          "lines": [
            "실제 행동: 질문으로만 대화한다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Questions · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Questions · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Questions · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Questions · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Questions · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Questions · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "평서문/반복/지연 시 상대가 점수를 얻는다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "bounce-cup-chase",
      "displayName": "Rage Cage",
      "aliases": [],
      "searchAliases": [
        "Rage Cage",
        "Slap Cup"
      ],
      "family": "기술반응",
      "playersMin": 4,
      "props": [
        "빈컵",
        "공"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 사람이 공을 튕겨 컵에 넣는다",
        "action": "성공하면 컵을 옆으로 넘긴다",
        "end": "추월 토큰 횟수로 끝낸다."
      },
      "sourceObservationIds": [
        "bdg-050",
        "bdg-051"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Rage Cage",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Rage Cage는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "4명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 사람이 공을 튕겨 컵에 넣는다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "4명 이상이 모여 두 사람이 공을 튕겨 컵에 넣는다",
            "hostCue": "‘준비: 두 사람이 공을 튕겨 컵에 넣는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘추월 토큰 횟수로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 추월 토큰 횟수로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "성공하면 컵을 옆으로 넘긴다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 성공하면 컵을 옆으로 넘긴다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "추월 토큰 횟수로 끝낸다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 추월 토큰 횟수로 끝낸다.’"
          }
        ],
        "example": {
          "title": "Rage Cage 한 차례 예시",
          "lines": [
            "실제 행동: 성공하면 컵을 옆으로 넘긴다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Rage Cage · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Rage Cage · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Rage Cage · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Rage Cage · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Rage Cage · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Rage Cage · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "추월 토큰 횟수로 끝낸다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "red-black-cards",
      "displayName": "Red and Black #1",
      "aliases": [],
      "searchAliases": [
        "Red and Black #1",
        "Red and Black #2"
      ],
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "다음 카드 색을 예측한다",
        "action": "공개 후 정답 토큰을 얻는다",
        "end": "정해진 연속 목표로 끝낸다."
      },
      "sourceObservationIds": [
        "wt-066",
        "wt-067"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "quiz_choice",
        "mode": "digital",
        "goal": "질문마다 답을 고르고 정답 또는 다수 선택을 확인한다.",
        "fun": "동시에 고른 답이 갈리는 순간",
        "firstAction": "문제를 읽고 화면의 선택지를 누른다.",
        "reward": "정답 수와 선택 공개",
        "durationSec": 50,
        "energy": "calm",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Red and Black #1",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Red and Black #1는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 동시에 고른 답이 갈리는 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱 화면이 질문판·선택판·득표판을 모두 제공합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "다음 카드 색을 예측한다",
          "앱 화면이 질문판·선택판·득표판을 모두 제공합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 다음 카드 색을 예측한다",
            "hostCue": "‘준비: 다음 카드 색을 예측한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 질문마다 답을 고르고 정답 또는 다수 선택을 확인한다. 라운드의 끝은 ‘정해진 연속 목표로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 연속 목표로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
            "hostCue": "‘연습만 한 번: 문제를 읽고 화면의 선택지를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공개 후 정답 토큰을 얻는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공개 후 정답 토큰을 얻는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 연속 목표로 끝낸다. 앱은 정답 수와 선택 공개를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 연속 목표로 끝낸다.’"
          }
        ],
        "example": {
          "title": "Red and Black #1 한 차례 예시",
          "lines": [
            "실제 행동: 공개 후 정답 토큰을 얻는다",
            "화면: ‘설명을 모두 이해했다’ O / X",
            "각자 말하지 않고 자기 쪽에 한 표 입력",
            "전원이 입력하면 공개 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Red and Black #1 · 1라운드",
            "prompt": "훈민정음 해례본이 반포된 해는?",
            "options": [
              "1446년",
              "1592년"
            ],
            "reveal": "정답: 1446년"
          },
          {
            "title": "Red and Black #1 · 2라운드",
            "prompt": "물은 표준 기압에서 섭씨 100도에 끓는다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Red and Black #1 · 3라운드",
            "prompt": "태양계에서 가장 큰 행성은?",
            "options": [
              "목성",
              "화성"
            ],
            "reveal": "정답: 목성"
          },
          {
            "title": "Red and Black #1 · 4라운드",
            "prompt": "한글 기본 자음은 14개다.",
            "options": [
              "O",
              "X"
            ],
            "reveal": "정답: O"
          },
          {
            "title": "Red and Black #1 · 5라운드",
            "prompt": "WWW가 일반에 공개된 해에 더 가까운 것은?",
            "options": [
              "1991년",
              "2001년"
            ],
            "reveal": "정답: 1991년"
          },
          {
            "title": "Red and Black #1 · 6라운드",
            "prompt": "지구의 유일한 자연 위성은?",
            "options": [
              "달",
              "금성"
            ],
            "reveal": "정답: 달"
          }
        ],
        "practice": {
          "instruction": "연습 문장을 읽고 각자 O 또는 X에 한 표를 입력해 공개하세요.",
          "actionLabel": "연습 선택 입력",
          "success": "두 선택이 동시에 공개됐어요."
        },
        "winCondition": "정해진 연속 목표로 끝낸다.",
        "tip": "다른 사람의 답을 보고 따라가지 않도록 공개 전에는 자신의 선택만 입력합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "choice_split",
          "labels": [
            "질문",
            "O",
            "X",
            "공개"
          ]
        }
      }
    },
    {
      "canonicalId": "rhyme-time",
      "displayName": "Rhyme Time",
      "aliases": [],
      "searchAliases": [
        "Rhyme Time"
      ],
      "family": "어휘",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "기준 단어를 뽑는다",
        "action": "운이 맞는 말을 차례로 낸다",
        "end": "반복/시간 초과 전까지 팀 연속 기록을 만든다."
      },
      "sourceObservationIds": [
        "bdg-039"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Rhyme Time",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Rhyme Time는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "기준 단어를 뽑는다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 기준 단어를 뽑는다",
            "hostCue": "‘준비: 기준 단어를 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘반복/시간 초과 전까지 팀 연속 기록을 만든다.’입니다.",
            "hostCue": "‘성공 조건: 반복/시간 초과 전까지 팀 연속 기록을 만든다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "운이 맞는 말을 차례로 낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 운이 맞는 말을 차례로 낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "반복/시간 초과 전까지 팀 연속 기록을 만든다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 반복/시간 초과 전까지 팀 연속 기록을 만든다.’"
          }
        ],
        "example": {
          "title": "Rhyme Time 한 차례 예시",
          "lines": [
            "실제 행동: 운이 맞는 말을 차례로 낸다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Rhyme Time · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Rhyme Time · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Rhyme Time · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Rhyme Time · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Rhyme Time · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Rhyme Time · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "반복/시간 초과 전까지 팀 연속 기록을 만든다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "ride-the-bus",
      "displayName": "Ride the Bus",
      "aliases": [],
      "searchAliases": [
        "Ride the Bus"
      ],
      "family": "카드추리",
      "playersMin": 2,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "카드의 색/높낮이/무늬를 예측한다",
        "action": "맞히면 전진한다",
        "end": "먼저 노선을 끝내면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-002"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Ride the Bus",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Ride the Bus는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "카드의 색/높낮이/무늬를 예측한다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 카드의 색/높낮이/무늬를 예측한다",
            "hostCue": "‘준비: 카드의 색/높낮이/무늬를 예측한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘먼저 노선을 끝내면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 먼저 노선을 끝내면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "맞히면 전진한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 맞히면 전진한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "먼저 노선을 끝내면 승리한다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 먼저 노선을 끝내면 승리한다.’"
          }
        ],
        "example": {
          "title": "Ride the Bus 한 차례 예시",
          "lines": [
            "실제 행동: 맞히면 전진한다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Ride the Bus · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Ride the Bus · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Ride the Bus · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Ride the Bus · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Ride the Bus · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Ride the Bus · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "먼저 노선을 끝내면 승리한다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "screw-the-dealer",
      "displayName": "Screw the Dealer",
      "aliases": [],
      "searchAliases": [
        "Screw the Dealer"
      ],
      "family": "카드추리",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "딜러 카드 숫자를 추리한다",
        "action": "힌트로 범위를 줄인다",
        "end": "맞힌 횟수로 딜러가 교대한다."
      },
      "sourceObservationIds": [
        "bdg-004"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Screw the Dealer",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Screw the Dealer는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "딜러 카드 숫자를 추리한다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 딜러 카드 숫자를 추리한다",
            "hostCue": "‘준비: 딜러 카드 숫자를 추리한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘맞힌 횟수로 딜러가 교대한다.’입니다.",
            "hostCue": "‘성공 조건: 맞힌 횟수로 딜러가 교대한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "힌트로 범위를 줄인다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 힌트로 범위를 줄인다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "맞힌 횟수로 딜러가 교대한다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 맞힌 횟수로 딜러가 교대한다.’"
          }
        ],
        "example": {
          "title": "Screw the Dealer 한 차례 예시",
          "lines": [
            "실제 행동: 힌트로 범위를 줄인다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Screw the Dealer · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Screw the Dealer · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Screw the Dealer · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Screw the Dealer · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Screw the Dealer · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Screw the Dealer · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "맞힌 횟수로 딜러가 교대한다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "screw-your-neighbor",
      "displayName": "Screw Your Neighbor",
      "aliases": [],
      "searchAliases": [
        "Screw Your Neighbor"
      ],
      "family": "카드교환",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "한 장씩 받고 낮은 카드를 피한다",
        "action": "옆 사람과 교환하거나 유지한다",
        "end": "라운드 최저 카드가 토큰을 잃는다."
      },
      "sourceObservationIds": [
        "bdg-015"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Screw Your Neighbor",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Screw Your Neighbor는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "한 장씩 받고 낮은 카드를 피한다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 한 장씩 받고 낮은 카드를 피한다",
            "hostCue": "‘준비: 한 장씩 받고 낮은 카드를 피한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘라운드 최저 카드가 토큰을 잃는다.’입니다.",
            "hostCue": "‘성공 조건: 라운드 최저 카드가 토큰을 잃는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "옆 사람과 교환하거나 유지한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 옆 사람과 교환하거나 유지한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "라운드 최저 카드가 토큰을 잃는다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 라운드 최저 카드가 토큰을 잃는다.’"
          }
        ],
        "example": {
          "title": "Screw Your Neighbor 한 차례 예시",
          "lines": [
            "실제 행동: 옆 사람과 교환하거나 유지한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Screw Your Neighbor · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Screw Your Neighbor · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Screw Your Neighbor · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Screw Your Neighbor · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Screw Your Neighbor · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Screw Your Neighbor · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "라운드 최저 카드가 토큰을 잃는다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "ship-captain-crew",
      "displayName": "Ship, Captain & Crew",
      "aliases": [],
      "searchAliases": [
        "Ship, Captain & Crew"
      ],
      "family": "주사위",
      "playersMin": 2,
      "props": [
        "주사위5"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "6·5·4를 순서대로 확보한다",
        "action": "남은 주사위 합을 화물 점수로 삼는다",
        "end": "최고 화물이 이긴다."
      },
      "sourceObservationIds": [
        "bdg-019"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Ship, Captain & Crew",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Ship, Captain & Crew는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "6·5·4를 순서대로 확보한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 6·5·4를 순서대로 확보한다",
            "hostCue": "‘준비: 6·5·4를 순서대로 확보한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘최고 화물이 이긴다.’입니다.",
            "hostCue": "‘성공 조건: 최고 화물이 이긴다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "남은 주사위 합을 화물 점수로 삼는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 남은 주사위 합을 화물 점수로 삼는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "최고 화물이 이긴다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 최고 화물이 이긴다.’"
          }
        ],
        "example": {
          "title": "Ship, Captain & Crew 한 차례 예시",
          "lines": [
            "실제 행동: 남은 주사위 합을 화물 점수로 삼는다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Ship, Captain & Crew · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Ship, Captain & Crew · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Ship, Captain & Crew · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Ship, Captain & Crew · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Ship, Captain & Crew · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Ship, Captain & Crew · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "최고 화물이 이긴다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "covered-cup-roulette",
      "displayName": "Shot Roulette",
      "aliases": [],
      "searchAliases": [
        "Shot Roulette"
      ],
      "family": "운",
      "playersMin": 2,
      "props": [
        "불투명 컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "모두 같은 무알코올 음료/빈 컵을 둔다",
        "action": "룰렛이 선택한 컵의 안전 미션을 공개한다",
        "end": "점수 후 컵을 섞는다."
      },
      "sourceObservationIds": [
        "bdg-037"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Shot Roulette",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Shot Roulette는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "모두 같은 무알코올 음료/빈 컵을 둔다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 모두 같은 무알코올 음료/빈 컵을 둔다",
            "hostCue": "‘준비: 모두 같은 무알코올 음료/빈 컵을 둔다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘점수 후 컵을 섞는다.’입니다.",
            "hostCue": "‘성공 조건: 점수 후 컵을 섞는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "룰렛이 선택한 컵의 안전 미션을 공개한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 룰렛이 선택한 컵의 안전 미션을 공개한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "점수 후 컵을 섞는다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 점수 후 컵을 섞는다.’"
          }
        ],
        "example": {
          "title": "Shot Roulette 한 차례 예시",
          "lines": [
            "실제 행동: 룰렛이 선택한 컵의 안전 미션을 공개한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Shot Roulette · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Shot Roulette · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Shot Roulette · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Shot Roulette · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Shot Roulette · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Shot Roulette · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "점수 후 컵을 섞는다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "floating-cup-balance",
      "displayName": "Sink the Ship",
      "aliases": [],
      "searchAliases": [
        "타이타닉게임",
        "Sink the battleship",
        "Sink the Ship",
        "Titanic"
      ],
      "family": "균형",
      "playersMin": 2,
      "props": [
        "대야",
        "물",
        "컵"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "물에 빈 컵을 띄운다",
        "action": "차례로 소량의 물을 더한다",
        "end": "가라앉힌 사람은 정리 담당을 고른다."
      },
      "sourceObservationIds": [
        "bdg-059",
        "bdg-094",
        "kr-045",
        "wt-074"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "well_listed",
        "sourceRegions": [
          "global_english",
          "korea"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Sink the Ship",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Sink the Ship는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "물에 빈 컵을 띄운다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 물에 빈 컵을 띄운다",
            "hostCue": "‘준비: 물에 빈 컵을 띄운다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘가라앉힌 사람은 정리 담당을 고른다.’입니다.",
            "hostCue": "‘성공 조건: 가라앉힌 사람은 정리 담당을 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "차례로 소량의 물을 더한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 차례로 소량의 물을 더한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "가라앉힌 사람은 정리 담당을 고른다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 가라앉힌 사람은 정리 담당을 고른다.’"
          }
        ],
        "example": {
          "title": "Sink the Ship 한 차례 예시",
          "lines": [
            "실제 행동: 차례로 소량의 물을 더한다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Sink the Ship · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Sink the Ship · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Sink the Ship · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Sink the Ship · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Sink the Ship · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Sink the Ship · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "가라앉힌 사람은 정리 담당을 고른다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "sixes-dice",
      "displayName": "Sixes",
      "aliases": [],
      "searchAliases": [
        "Sixes"
      ],
      "family": "주사위운",
      "playersMin": 2,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "목표 숫자 6을 정한다",
        "action": "정해진 횟수 굴려 조합을 만든다",
        "end": "목표 조합 점수를 비교한다."
      },
      "sourceObservationIds": [
        "bdg-022",
        "wt-075"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Sixes",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Sixes는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "목표 숫자 6을 정한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 목표 숫자 6을 정한다",
            "hostCue": "‘준비: 목표 숫자 6을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘목표 조합 점수를 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 목표 조합 점수를 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "정해진 횟수 굴려 조합을 만든다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 정해진 횟수 굴려 조합을 만든다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "목표 조합 점수를 비교한다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 목표 조합 점수를 비교한다.’"
          }
        ],
        "example": {
          "title": "Sixes 한 차례 예시",
          "lines": [
            "실제 행동: 정해진 횟수 굴려 조합을 만든다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Sixes · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Sixes · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Sixes · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Sixes · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Sixes · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Sixes · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "목표 조합 점수를 비교한다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "snake-eyes",
      "displayName": "Snake Eyes",
      "aliases": [],
      "searchAliases": [
        "Snake Eyes"
      ],
      "family": "주사위운",
      "playersMin": 2,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "주사위 합을 예측한다",
        "action": "더블 1이면 보너스 이벤트를 연다",
        "end": "라운드 점수를 합친다."
      },
      "sourceObservationIds": [
        "bdg-023"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Snake Eyes",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Snake Eyes는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주사위 합을 예측한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 주사위 합을 예측한다",
            "hostCue": "‘준비: 주사위 합을 예측한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘라운드 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 라운드 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "더블 1이면 보너스 이벤트를 연다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 더블 1이면 보너스 이벤트를 연다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "라운드 점수를 합친다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 라운드 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Snake Eyes 한 차례 예시",
          "lines": [
            "실제 행동: 더블 1이면 보너스 이벤트를 연다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Snake Eyes · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Snake Eyes · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Snake Eyes · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Snake Eyes · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Snake Eyes · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Snake Eyes · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "라운드 점수를 합친다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "sociables-cards",
      "displayName": "Sociables",
      "aliases": [],
      "searchAliases": [
        "Sociables"
      ],
      "family": "카드종합",
      "playersMin": 3,
      "props": [
        "카드"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "카드마다 안전 카테고리/질문/규칙을 매핑한다",
        "action": "차례로 수행한다",
        "end": "덱 종료 시 팀 성공 수를 합친다."
      },
      "sourceObservationIds": [
        "bdg-105"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Sociables",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Sociables는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "카드마다 안전 카테고리/질문/규칙을 매핑한다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 카드마다 안전 카테고리/질문/규칙을 매핑한다",
            "hostCue": "‘준비: 카드마다 안전 카테고리/질문/규칙을 매핑한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘덱 종료 시 팀 성공 수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 덱 종료 시 팀 성공 수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "차례로 수행한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 차례로 수행한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "덱 종료 시 팀 성공 수를 합친다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 덱 종료 시 팀 성공 수를 합친다.’"
          }
        ],
        "example": {
          "title": "Sociables 한 차례 예시",
          "lines": [
            "실제 행동: 차례로 수행한다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Sociables · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Sociables · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Sociables · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Sociables · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Sociables · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Sociables · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "덱 종료 시 팀 성공 수를 합친다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "speed-quarters",
      "displayName": "Speed Quarters",
      "aliases": [],
      "searchAliases": [
        "Speed Quarters"
      ],
      "family": "Coin/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "두 목표에 동전을 번갈아 튕긴다",
        "action": "명중하면 토큰을 넘긴다",
        "end": "속주 없이 제한 라운드 점수로 끝낸다."
      },
      "sourceObservationIds": [
        "wt-077"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "dexterity",
        "mode": "hybrid",
        "goal": "안전한 도구 또는 손기술로 목표 점수에 도전한다.",
        "fun": "손끝 한 번에 갈리는 성공과 실패",
        "firstAction": "목표와 시도 횟수를 확인하고 첫 시도를 한다.",
        "reward": "명중·연속 성공·완료 점수",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Speed Quarters",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Speed Quarters는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 손끝 한 번에 갈리는 성공과 실패를 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 목표에 동전을 번갈아 튕긴다",
          "준비물이 없어도 화면의 움직이는 표적을 정확한 순간에 탭하는 앱 단독 변형으로 플레이합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 두 목표에 동전을 번갈아 튕긴다",
            "hostCue": "‘준비: 두 목표에 동전을 번갈아 튕긴다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 안전한 도구 또는 손기술로 목표 점수에 도전한다. 라운드의 끝은 ‘속주 없이 제한 라운드 점수로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 속주 없이 제한 라운드 점수로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
            "hostCue": "‘연습만 한 번: 목표와 시도 횟수를 확인하고 첫 시도를 한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "명중하면 토큰을 넘긴다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 명중하면 토큰을 넘긴다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "속주 없이 제한 라운드 점수로 끝낸다. 앱은 명중·연속 성공·완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 속주 없이 제한 라운드 점수로 끝낸다.’"
          }
        ],
        "example": {
          "title": "Speed Quarters 한 차례 예시",
          "lines": [
            "실제 행동: 명중하면 토큰을 넘긴다",
            "시작을 누르면 점이 좌우로 이동",
            "가운데 초록 구역에서 탭",
            "거리 기준으로 0~100점 표시"
          ]
        },
        "rounds": [
          {
            "title": "Speed Quarters · 1라운드",
            "prompt": "타이밍 표적: 가운데 넓은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Speed Quarters · 2라운드",
            "prompt": "타이밍 표적: 가운데 좁은 목표",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Speed Quarters · 3라운드",
            "prompt": "타이밍 표적: 반대손 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Speed Quarters · 4라운드",
            "prompt": "타이밍 표적: 천천히 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Speed Quarters · 5라운드",
            "prompt": "타이밍 표적: 빠르게 한 번",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          },
          {
            "title": "Speed Quarters · 6라운드",
            "prompt": "타이밍 표적: 마지막 합계 시도",
            "options": [
              "시작",
              "목표에서 탭"
            ],
            "reveal": "목표 중앙과 탭 위치의 거리로 0~100점을 계산합니다."
          }
        ],
        "practice": {
          "instruction": "움직이는 점이 가운데 목표 구역에 들어왔을 때 화면을 한 번 탭하세요.",
          "actionLabel": "타이밍 연습",
          "success": "탭 위치가 점수로 바뀌는 방식을 익혔어요."
        },
        "winCondition": "속주 없이 제한 라운드 점수로 끝낸다.",
        "tip": "기기를 던지거나 흔들지 않습니다. 한 손가락 탭만 사용하고 화면을 평평하게 둡니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "target",
          "labels": [
            "시작",
            "움직임",
            "목표 구역",
            "기록"
          ]
        }
      }
    },
    {
      "canonicalId": "spin-selector",
      "displayName": "Spin the Bottle",
      "aliases": [],
      "searchAliases": [
        "Spin the Bottle"
      ],
      "family": "룰렛",
      "playersMin": 3,
      "props": [
        "병",
        "앱"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "병 또는 화면 룰렛을 돌린다",
        "action": "선택된 사람은 질문/미션/패스를 고른다",
        "end": "접촉·키스 미션 없이 다음으로 간다."
      },
      "sourceObservationIds": [
        "bdg-036"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Spin the Bottle",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Spin the Bottle는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "병 또는 화면 룰렛을 돌린다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 병 또는 화면 룰렛을 돌린다",
            "hostCue": "‘준비: 병 또는 화면 룰렛을 돌린다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘접촉·키스 미션 없이 다음으로 간다.’입니다.",
            "hostCue": "‘성공 조건: 접촉·키스 미션 없이 다음으로 간다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "선택된 사람은 질문/미션/패스를 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 선택된 사람은 질문/미션/패스를 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "접촉·키스 미션 없이 다음으로 간다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 접촉·키스 미션 없이 다음으로 간다.’"
          }
        ],
        "example": {
          "title": "Spin the Bottle 한 차례 예시",
          "lines": [
            "실제 행동: 선택된 사람은 질문/미션/패스를 고른다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Spin the Bottle · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Spin the Bottle · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Spin the Bottle · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Spin the Bottle · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Spin the Bottle · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Spin the Bottle · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "접촉·키스 미션 없이 다음으로 간다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "coin-spinner",
      "displayName": "Spinners",
      "aliases": [],
      "searchAliases": [
        "Spinners"
      ],
      "family": "Coin/Low",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "동전을 회전시킨다",
        "action": "멈추기 전 안전 질문에 답하거나 손 신호를 끝낸다",
        "end": "성공 점수를 얻는다."
      },
      "sourceObservationIds": [
        "wt-078"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Spinners",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Spinners는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "동전을 회전시킨다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 동전을 회전시킨다",
            "hostCue": "‘준비: 동전을 회전시킨다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘성공 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 성공 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "멈추기 전 안전 질문에 답하거나 손 신호를 끝낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 멈추기 전 안전 질문에 답하거나 손 신호를 끝낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "성공 점수를 얻는다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 성공 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Spinners 한 차례 예시",
          "lines": [
            "실제 행동: 멈추기 전 안전 질문에 답하거나 손 신호를 끝낸다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Spinners · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Spinners · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Spinners · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Spinners · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Spinners · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Spinners · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "성공 점수를 얻는다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "sports-bingo",
      "displayName": "Sports Drinking Game",
      "aliases": [],
      "searchAliases": [
        "Sports Drinking Game"
      ],
      "family": "스포츠관찰",
      "playersMin": 2,
      "props": [
        "중계",
        "빙고"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "경기 전 일반 사건 칸을 고른다",
        "action": "발생 시 표시한다",
        "end": "한 줄/최다 칸으로 승자를 정한다."
      },
      "sourceObservationIds": [
        "bdg-066"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Sports Drinking Game",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Sports Drinking Game는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "경기 전 일반 사건 칸을 고른다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 경기 전 일반 사건 칸을 고른다",
            "hostCue": "‘준비: 경기 전 일반 사건 칸을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘한 줄/최다 칸으로 승자를 정한다.’입니다.",
            "hostCue": "‘성공 조건: 한 줄/최다 칸으로 승자를 정한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "발생 시 표시한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 발생 시 표시한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "한 줄/최다 칸으로 승자를 정한다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 한 줄/최다 칸으로 승자를 정한다.’"
          }
        ],
        "example": {
          "title": "Sports Drinking Game 한 차례 예시",
          "lines": [
            "실제 행동: 발생 시 표시한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "Sports Drinking Game · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Sports Drinking Game · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Sports Drinking Game · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Sports Drinking Game · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Sports Drinking Game · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Sports Drinking Game · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "한 줄/최다 칸으로 승자를 정한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "status-code-bingo",
      "displayName": "Status Code Drinking Game",
      "aliases": [],
      "searchAliases": [
        "Status Code Drinking Game"
      ],
      "family": "개발/관찰",
      "playersMin": 2,
      "props": [
        "로그",
        "빙고"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "상태코드 이벤트 칸을 만든다",
        "action": "개발/게임 세션 중 발생하면 표시한다",
        "end": "한 줄을 먼저 채우면 승리한다."
      },
      "sourceObservationIds": [
        "bdg-109"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Status Code Drinking Game",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Status Code Drinking Game는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "상태코드 이벤트 칸을 만든다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 상태코드 이벤트 칸을 만든다",
            "hostCue": "‘준비: 상태코드 이벤트 칸을 만든다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘한 줄을 먼저 채우면 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 한 줄을 먼저 채우면 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "개발/게임 세션 중 발생하면 표시한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 개발/게임 세션 중 발생하면 표시한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "한 줄을 먼저 채우면 승리한다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 한 줄을 먼저 채우면 승리한다.’"
          }
        ],
        "example": {
          "title": "Status Code Drinking Game 한 차례 예시",
          "lines": [
            "실제 행동: 개발/게임 세션 중 발생하면 표시한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "Status Code Drinking Game · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Status Code Drinking Game · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Status Code Drinking Game · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Status Code Drinking Game · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Status Code Drinking Game · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "Status Code Drinking Game · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "한 줄을 먼저 채우면 승리한다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "straight-face",
      "displayName": "Straight Face",
      "aliases": [],
      "searchAliases": [
        "Straight Face"
      ],
      "family": "표정",
      "playersMin": 3,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "비모욕 문장을 제출한다",
        "action": "한 사람이 무표정으로 읽는다",
        "end": "웃음이 나면 문장 작성자가 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-101"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Straight Face",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Straight Face는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "비모욕 문장을 제출한다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 비모욕 문장을 제출한다",
            "hostCue": "‘준비: 비모욕 문장을 제출한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘웃음이 나면 문장 작성자가 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 웃음이 나면 문장 작성자가 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "한 사람이 무표정으로 읽는다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 한 사람이 무표정으로 읽는다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "웃음이 나면 문장 작성자가 점수를 얻는다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 웃음이 나면 문장 작성자가 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Straight Face 한 차례 예시",
          "lines": [
            "실제 행동: 한 사람이 무표정으로 읽는다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Straight Face · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Straight Face · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Straight Face · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Straight Face · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Straight Face · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Straight Face · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "웃음이 나면 문장 작성자가 점수를 얻는다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "pool-table-variant",
      "displayName": "Stripes and Solids",
      "aliases": [],
      "searchAliases": [
        "Stripes and Solids"
      ],
      "family": "Other/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "당구 공 종류별 팀을 정한다",
        "action": "공식 장소 규칙대로 친다",
        "end": "포켓/파울을 점수로만 기록한다."
      },
      "sourceObservationIds": [
        "wt-084"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "team_score",
        "mode": "hybrid",
        "goal": "팀별 미션을 수행하고 점수를 먼저 모은다.",
        "fun": "역전 가능한 짧은 팀 대결",
        "firstAction": "팀을 나누고 선공 팀을 정한다.",
        "reward": "팀 점수와 승리 공개",
        "durationSec": 75,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Stripes and Solids",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Stripes and Solids는 팀별 미션을 수행하고 점수를 먼저 모은다. 역전 가능한 짧은 팀 대결을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 팀 나누기·미션·타이머·점수를 맡고, 준비물 미션은 화면 탭·말·몸짓 미션으로 대체합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "당구 공 종류별 팀을 정한다",
          "앱이 팀 나누기·미션·타이머·점수를 맡고, 준비물 미션은 화면 탭·말·몸짓 미션으로 대체합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 당구 공 종류별 팀을 정한다",
            "hostCue": "‘준비: 당구 공 종류별 팀을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 팀별 미션을 수행하고 점수를 먼저 모은다. 라운드의 끝은 ‘포켓/파울을 점수로만 기록한다.’입니다.",
            "hostCue": "‘성공 조건: 포켓/파울을 점수로만 기록한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 팀을 나누고 선공 팀을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "공식 장소 규칙대로 친다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 공식 장소 규칙대로 친다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "포켓/파울을 점수로만 기록한다. 앱은 팀 점수와 승리 공개를 보여 줍니다.",
            "hostCue": "‘끝: 포켓/파울을 점수로만 기록한다.’"
          }
        ],
        "example": {
          "title": "Stripes and Solids 한 차례 예시",
          "lines": [
            "실제 행동: 공식 장소 규칙대로 친다",
            "A팀이 화면 미션 20초 수행",
            "성공하면 A팀 +1",
            "같은 조건으로 B팀 수행"
          ]
        },
        "rounds": [
          {
            "title": "Stripes and Solids · 1라운드",
            "prompt": "팀 미션: 팀 구호를 같은 박자로 3번",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Stripes and Solids · 2라운드",
            "prompt": "팀 미션: 한 단어씩 이어 문장 완성",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Stripes and Solids · 3라운드",
            "prompt": "팀 미션: 화면 신호에 팀 전원이 동시에 탭",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Stripes and Solids · 4라운드",
            "prompt": "팀 미션: 몸짓 제시어 1개 맞히기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Stripes and Solids · 5라운드",
            "prompt": "팀 미션: 관찰 조건 2개 찾기",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          },
          {
            "title": "Stripes and Solids · 6라운드",
            "prompt": "팀 미션: 마지막 점수 뒤집기 미션",
            "options": [
              "A팀 +1",
              "B팀 +1"
            ],
            "reveal": "같은 시간과 조건으로 두 팀이 한 번씩 수행합니다."
          }
        ],
        "practice": {
          "instruction": "A팀과 B팀이 연습 미션을 한 번씩 수행하고 각 팀 점수 버튼을 눌러 보세요.",
          "actionLabel": "팀 점수 연습",
          "success": "팀별 수행과 점수 입력 순서를 익혔어요."
        },
        "winCondition": "포켓/파울을 점수로만 기록한다.",
        "tip": "팀 인원이 홀수면 한 명은 진행자를 맡고 다음 라운드에 팀과 교대합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "team_track",
          "labels": [
            "A팀",
            "미션",
            "B팀",
            "점수"
          ]
        }
      }
    },
    {
      "canonicalId": "name-game",
      "displayName": "The Name Game",
      "aliases": [],
      "searchAliases": [
        "The Name Game"
      ],
      "family": "인물추리",
      "playersMin": 2,
      "props": [
        "종이",
        "앱"
      ],
      "playability": "playable_safe",
      "rules": {
        "setup": "모두 익숙한 인물/캐릭터를 제출한다",
        "action": "설명·한 단어·몸짓 단계로 팀이 맞힌다",
        "end": "총 정답 수를 겨룬다."
      },
      "sourceObservationIds": [
        "bdg-041",
        "wt-088"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "The Name Game",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "The Name Game는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "모두 익숙한 인물/캐릭터를 제출한다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 모두 익숙한 인물/캐릭터를 제출한다",
            "hostCue": "‘준비: 모두 익숙한 인물/캐릭터를 제출한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘총 정답 수를 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 총 정답 수를 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "설명·한 단어·몸짓 단계로 팀이 맞힌다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 설명·한 단어·몸짓 단계로 팀이 맞힌다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "총 정답 수를 겨룬다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 총 정답 수를 겨룬다.’"
          }
        ],
        "example": {
          "title": "The Name Game 한 차례 예시",
          "lines": [
            "실제 행동: 설명·한 단어·몸짓 단계로 팀이 맞힌다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "The Name Game · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "The Name Game · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "The Name Game · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "The Name Game · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "The Name Game · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "The Name Game · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "총 정답 수를 겨룬다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "story-chain",
      "displayName": "The Story Game",
      "aliases": [],
      "searchAliases": [
        "The Story Game"
      ],
      "family": "이야기",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "첫 문장을 뽑는다",
        "action": "각자 한 문장을 더하되 금지어를 피한다",
        "end": "모두 두 바퀴면 결말을 고른다."
      },
      "sourceObservationIds": [
        "bdg-045"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "The Story Game",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "The Story Game는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "첫 문장을 뽑는다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 첫 문장을 뽑는다",
            "hostCue": "‘준비: 첫 문장을 뽑는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘모두 두 바퀴면 결말을 고른다.’입니다.",
            "hostCue": "‘성공 조건: 모두 두 바퀴면 결말을 고른다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "각자 한 문장을 더하되 금지어를 피한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 각자 한 문장을 더하되 금지어를 피한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "모두 두 바퀴면 결말을 고른다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 모두 두 바퀴면 결말을 고른다.’"
          }
        ],
        "example": {
          "title": "The Story Game 한 차례 예시",
          "lines": [
            "실제 행동: 각자 한 문장을 더하되 금지어를 피한다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "The Story Game · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "The Story Game · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "The Story Game · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "The Story Game · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "The Story Game · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "The Story Game · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "모두 두 바퀴면 결말을 고른다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "tower-dice",
      "displayName": "The Tower",
      "aliases": [],
      "searchAliases": [
        "The Tower"
      ],
      "family": "Dice/Unknown",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "주사위 합으로 블록 추가/제거를 정한다",
        "action": "탑을 유지한다",
        "end": "정해진 라운드 안정성 점수."
      },
      "sourceObservationIds": [
        "wt-089"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "The Tower",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "The Tower는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주사위 합으로 블록 추가/제거를 정한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 주사위 합으로 블록 추가/제거를 정한다",
            "hostCue": "‘준비: 주사위 합으로 블록 추가/제거를 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘정해진 라운드 안정성 점수.’입니다.",
            "hostCue": "‘성공 조건: 정해진 라운드 안정성 점수.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "탑을 유지한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 탑을 유지한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 라운드 안정성 점수. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 라운드 안정성 점수.’"
          }
        ],
        "example": {
          "title": "The Tower 한 차례 예시",
          "lines": [
            "실제 행동: 탑을 유지한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "The Tower · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "The Tower · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "The Tower · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "The Tower · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "The Tower · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "The Tower · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "정해진 라운드 안정성 점수.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "vegetable-gesture",
      "displayName": "The Vegetable Game",
      "aliases": [],
      "searchAliases": [
        "The Vegetable Game"
      ],
      "family": "Vocal/Medium",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "각자 채소 이름과 동작을 정한다",
        "action": "자기 신호 뒤 다른 신호를 호출한다",
        "end": "놓치지 않은 연속 기록."
      },
      "sourceObservationIds": [
        "wt-090"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "The Vegetable Game",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "The Vegetable Game는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "각자 채소 이름과 동작을 정한다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 각자 채소 이름과 동작을 정한다",
            "hostCue": "‘준비: 각자 채소 이름과 동작을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘놓치지 않은 연속 기록.’입니다.",
            "hostCue": "‘성공 조건: 놓치지 않은 연속 기록.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "자기 신호 뒤 다른 신호를 호출한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 자기 신호 뒤 다른 신호를 호출한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "놓치지 않은 연속 기록. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 놓치지 않은 연속 기록.’"
          }
        ],
        "example": {
          "title": "The Vegetable Game 한 차례 예시",
          "lines": [
            "실제 행동: 자기 신호 뒤 다른 신호를 호출한다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "The Vegetable Game · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "The Vegetable Game · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "The Vegetable Game · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "The Vegetable Game · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "The Vegetable Game · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "The Vegetable Game · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "놓치지 않은 연속 기록.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "thirty-one-cards",
      "displayName": "Thirty One",
      "aliases": [],
      "searchAliases": [
        "Thirty One"
      ],
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "같은 무늬 3장의 합을 31에 가깝게 만든다",
        "action": "뽑고 버리거나 knock한다",
        "end": "최고 합이 점수를 얻는다."
      },
      "sourceObservationIds": [
        "wt-092"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Thirty One",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Thirty One는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "같은 무늬 3장의 합을 31에 가깝게 만든다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 같은 무늬 3장의 합을 31에 가깝게 만든다",
            "hostCue": "‘준비: 같은 무늬 3장의 합을 31에 가깝게 만든다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘최고 합이 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 최고 합이 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "뽑고 버리거나 knock한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 뽑고 버리거나 knock한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "최고 합이 점수를 얻는다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 최고 합이 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Thirty One 한 차례 예시",
          "lines": [
            "실제 행동: 뽑고 버리거나 knock한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Thirty One · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Thirty One · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Thirty One · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Thirty One · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Thirty One · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Thirty One · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "최고 합이 점수를 얻는다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "three-man",
      "displayName": "Three Man",
      "aliases": [],
      "searchAliases": [
        "Three Man"
      ],
      "family": "주사위",
      "playersMin": 2,
      "props": [
        "주사위"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "역할과 합계 규칙을 정한다",
        "action": "두 주사위를 굴려 안전 액션을 적용한다",
        "end": "정해진 라운드 뒤 점수를 비교한다."
      },
      "sourceObservationIds": [
        "bdg-017",
        "wt-093"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Three Man",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Three Man는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "역할과 합계 규칙을 정한다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 역할과 합계 규칙을 정한다",
            "hostCue": "‘준비: 역할과 합계 규칙을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘정해진 라운드 뒤 점수를 비교한다.’입니다.",
            "hostCue": "‘성공 조건: 정해진 라운드 뒤 점수를 비교한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "두 주사위를 굴려 안전 액션을 적용한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 두 주사위를 굴려 안전 액션을 적용한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "정해진 라운드 뒤 점수를 비교한다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 정해진 라운드 뒤 점수를 비교한다.’"
          }
        ],
        "example": {
          "title": "Three Man 한 차례 예시",
          "lines": [
            "실제 행동: 두 주사위를 굴려 안전 액션을 적용한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Three Man · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Three Man · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Three Man · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Three Man · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Three Man · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Three Man · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "정해진 라운드 뒤 점수를 비교한다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "thumper",
      "displayName": "Thumper",
      "aliases": [],
      "searchAliases": [
        "Thumper"
      ],
      "family": "동작기억",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "각자 손동작을 정한다",
        "action": "자기 동작 뒤 다음 사람 동작을 보낸다",
        "end": "놓치기 전 연속 기록을 겨룬다."
      },
      "sourceObservationIds": [
        "bdg-046",
        "wt-094"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "memory_chain",
        "mode": "hosted",
        "goal": "앞사람의 순서를 기억하고 한 단계를 더한다.",
        "fun": "길어지는 연쇄와 아슬아슬한 기억",
        "firstAction": "첫 동작·단어·숫자를 등록한다.",
        "reward": "끊기지 않은 최고 연쇄",
        "durationSec": 60,
        "energy": "wild",
        "novelty": "cross_listed",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Thumper",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Thumper는 앞사람의 순서를 기억하고 한 단계를 더한다. 길어지는 연쇄와 아슬아슬한 기억을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "각자 손동작을 정한다",
          "앱이 현재 차례와 최고 연쇄를 보여 줍니다. 참가자는 화면 지시에 맞춰 말이나 동작만 이어 가면 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 각자 손동작을 정한다",
            "hostCue": "‘준비: 각자 손동작을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 앞사람의 순서를 기억하고 한 단계를 더한다. 라운드의 끝은 ‘놓치기 전 연속 기록을 겨룬다.’입니다.",
            "hostCue": "‘성공 조건: 놓치기 전 연속 기록을 겨룬다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
            "hostCue": "‘연습만 한 번: 첫 동작·단어·숫자를 등록한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "자기 동작 뒤 다음 사람 동작을 보낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 자기 동작 뒤 다음 사람 동작을 보낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "놓치기 전 연속 기록을 겨룬다. 앱은 끊기지 않은 최고 연쇄를 보여 줍니다.",
            "hostCue": "‘끝: 놓치기 전 연속 기록을 겨룬다.’"
          }
        ],
        "example": {
          "title": "Thumper 한 차례 예시",
          "lines": [
            "실제 행동: 자기 동작 뒤 다음 사람 동작을 보낸다",
            "1번: 사과",
            "2번: 사과, 우산",
            "3번: 사과, 우산, 별"
          ]
        },
        "rounds": [
          {
            "title": "Thumper · 1라운드",
            "prompt": "기억 연쇄 씨앗: 사과",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Thumper · 2라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Thumper · 3라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Thumper · 4라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Thumper · 5라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          },
          {
            "title": "Thumper · 6라운드",
            "prompt": "기억 연쇄 씨앗: 사과 → 우산 → 별 → 기차 → 고양이 → 바다",
            "options": [
              "정확히 재현",
              "하나 더하기"
            ],
            "reveal": "빠뜨리면 벌칙 없이 현재 최고 연쇄만 남깁니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람이 한 요소를 말하고 다음 사람이 그대로 반복한 뒤 하나를 더하세요.",
          "actionLabel": "연쇄 1회 연습",
          "success": "앞 순서에 하나를 더하는 방식을 익혔어요."
        },
        "winCondition": "놓치기 전 연속 기록을 겨룬다.",
        "tip": "서로 말이 겹치면 현재 차례 표시를 먼저 보고, 틀린 사람을 벌주지 말고 연쇄만 새로 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "circle_pass",
          "labels": [
            "1번",
            "2번",
            "3번",
            "다시 1번"
          ]
        }
      }
    },
    {
      "canonicalId": "music-cue-pass",
      "displayName": "Thunderstruck",
      "aliases": [],
      "searchAliases": [
        "Thunderstruck"
      ],
      "family": "음악반응",
      "playersMin": 3,
      "props": [
        "재생기"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "반복 신호가 있는 권리 확보 음악을 튼다",
        "action": "신호마다 토큰을 옆으로 넘긴다",
        "end": "곡 종료 시 연속 성공을 기록한다."
      },
      "sourceObservationIds": [
        "bdg-069"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "reflex",
        "mode": "digital",
        "goal": "신호를 기다렸다가 가장 빠르게 반응한다.",
        "fun": "예측할 수 없는 신호와 밀리초 기록",
        "firstAction": "준비 버튼을 누르고 신호가 뜰 때까지 기다린다.",
        "reward": "반응 시간 기록과 라운드 점수",
        "durationSec": 35,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Thunderstruck",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Thunderstruck는 신호를 기다렸다가 가장 빠르게 반응한다. 예측할 수 없는 신호와 밀리초 기록을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "반복 신호가 있는 권리 확보 음악을 튼다",
          "앱이 예측할 수 없는 신호와 밀리초 기록을 만들므로 진행자와 스톱워치가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 반복 신호가 있는 권리 확보 음악을 튼다",
            "hostCue": "‘준비: 반복 신호가 있는 권리 확보 음악을 튼다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 신호를 기다렸다가 가장 빠르게 반응한다. 라운드의 끝은 ‘곡 종료 시 연속 성공을 기록한다.’입니다.",
            "hostCue": "‘성공 조건: 곡 종료 시 연속 성공을 기록한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
            "hostCue": "‘연습만 한 번: 준비 버튼을 누르고 신호가 뜰 때까지 기다린다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "신호마다 토큰을 옆으로 넘긴다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 신호마다 토큰을 옆으로 넘긴다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "곡 종료 시 연속 성공을 기록한다. 앱은 반응 시간 기록과 라운드 점수를 보여 줍니다.",
            "hostCue": "‘끝: 곡 종료 시 연속 성공을 기록한다.’"
          }
        ],
        "example": {
          "title": "Thunderstruck 한 차례 예시",
          "lines": [
            "실제 행동: 신호마다 토큰을 옆으로 넘긴다",
            "1번이 준비하기를 누름",
            "보라색 ‘기다려요’ 동안 손을 멈춤",
            "살구색 ‘지금 탭!’이 뜨면 즉시 탭"
          ]
        },
        "rounds": [
          {
            "title": "Thunderstruck · 1라운드",
            "prompt": "살구색 ‘지금 탭!’ 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Thunderstruck · 2라운드",
            "prompt": "두 번째 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Thunderstruck · 3라운드",
            "prompt": "방향 전환 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Thunderstruck · 4라운드",
            "prompt": "팀 대표 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Thunderstruck · 5라운드",
            "prompt": "반대손 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          },
          {
            "title": "Thunderstruck · 6라운드",
            "prompt": "마지막 결승 신호",
            "options": [
              "준비",
              "신호 뒤 탭"
            ],
            "reveal": "화면이 실제 반응 시간을 밀리초로 기록합니다."
          }
        ],
        "practice": {
          "instruction": "준비를 누르고 화면 색이 바뀐 뒤에만 탭하세요. 먼저 누르면 연습을 다시 합니다.",
          "actionLabel": "반응 연습",
          "success": "신호 뒤 탭이 기록되는 방식을 익혔어요."
        },
        "winCondition": "곡 종료 시 연속 성공을 기록한다.",
        "tip": "기기를 가운데 평평하게 두고 모두 같은 거리에서 손을 시작합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "signal_tap",
          "labels": [
            "준비",
            "기다림",
            "신호",
            "탭"
          ]
        }
      }
    },
    {
      "canonicalId": "truth-or-dare-safe",
      "displayName": "Truth or Dare",
      "aliases": [],
      "searchAliases": [
        "Truth or Dare"
      ],
      "family": "질문/미션",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "진실/미션/패스를 고른다",
        "action": "사전 검수된 비접촉 문항을 수행한다",
        "end": "완료 토큰만 기록한다."
      },
      "sourceObservationIds": [
        "bdg-029"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Truth or Dare",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Truth or Dare는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "진실/미션/패스를 고른다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 진실/미션/패스를 고른다",
            "hostCue": "‘준비: 진실/미션/패스를 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘완료 토큰만 기록한다.’입니다.",
            "hostCue": "‘성공 조건: 완료 토큰만 기록한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "사전 검수된 비접촉 문항을 수행한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 사전 검수된 비접촉 문항을 수행한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "완료 토큰만 기록한다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 완료 토큰만 기록한다.’"
          }
        ],
        "example": {
          "title": "Truth or Dare 한 차례 예시",
          "lines": [
            "실제 행동: 사전 검수된 비접촉 문항을 수행한다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Truth or Dare · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Truth or Dare · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Truth or Dare · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Truth or Dare · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Truth or Dare · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Truth or Dare · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "완료 토큰만 기록한다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    },
    {
      "canonicalId": "character-bingo",
      "displayName": "TV Characters",
      "aliases": [],
      "searchAliases": [
        "TV Characters"
      ],
      "family": "TV/Movie/High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "일반 캐릭터 trope 칸을 고른다",
        "action": "화면에서 나타나면 표시한다",
        "end": "한 줄 빙고로 끝낸다."
      },
      "sourceObservationIds": [
        "wt-086"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "observation",
        "mode": "hybrid",
        "goal": "장면이나 주변에서 조건을 찾아 칸을 완성한다.",
        "fun": "남들이 놓친 순간을 먼저 발견",
        "firstAction": "관찰할 조건 한 칸을 선택한다.",
        "reward": "발견한 칸과 빙고 완성",
        "durationSec": 75,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "TV Characters",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "TV Characters는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 남들이 놓친 순간을 먼저 발견을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "일반 캐릭터 trope 칸을 고른다",
          "앱이 찾아야 할 조건과 체크판·타이머를 제공합니다. 별도 빙고판이 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 일반 캐릭터 trope 칸을 고른다",
            "hostCue": "‘준비: 일반 캐릭터 trope 칸을 고른다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 장면이나 주변에서 조건을 찾아 칸을 완성한다. 라운드의 끝은 ‘한 줄 빙고로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 한 줄 빙고로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
            "hostCue": "‘연습만 한 번: 관찰할 조건 한 칸을 선택한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "화면에서 나타나면 표시한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 화면에서 나타나면 표시한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "한 줄 빙고로 끝낸다. 앱은 발견한 칸과 빙고 완성을 보여 줍니다.",
            "hostCue": "‘끝: 한 줄 빙고로 끝낸다.’"
          }
        ],
        "example": {
          "title": "TV Characters 한 차례 예시",
          "lines": [
            "실제 행동: 화면에서 나타나면 표시한다",
            "화면 조건: ‘둥근 모양’",
            "주변 또는 제시 장면에서 조건 찾기",
            "먼저 찾은 사람이 체크"
          ]
        },
        "rounds": [
          {
            "title": "TV Characters · 1라운드",
            "prompt": "찾을 조건: 둥근 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "TV Characters · 2라운드",
            "prompt": "찾을 조건: 파란 물건",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "TV Characters · 3라운드",
            "prompt": "찾을 조건: 글자 세 개",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "TV Characters · 4라운드",
            "prompt": "찾을 조건: 대칭인 모양",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "TV Characters · 5라운드",
            "prompt": "찾을 조건: 움직이는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          },
          {
            "title": "TV Characters · 6라운드",
            "prompt": "찾을 조건: 소리 없이 찾을 수 있는 것",
            "options": [
              "발견 +1",
              "조건 바꾸기"
            ],
            "reveal": "공개된 주변이나 화면에서 찾은 조건만 체크합니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 조건 하나를 읽고 발견했다고 가정해 체크해 보세요.",
          "actionLabel": "연습 조건 체크",
          "success": "발견한 조건을 기록하는 방식을 익혔어요."
        },
        "winCondition": "한 줄 빙고로 끝낸다.",
        "tip": "타인의 몸·가방·휴대폰을 허락 없이 관찰 대상으로 삼지 않고 공개된 장면만 봅니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "search_grid",
          "labels": [
            "조건",
            "찾기",
            "체크",
            "완성"
          ]
        }
      }
    },
    {
      "canonicalId": "twenty-one-aces-dice",
      "displayName": "Twenty-One Aces",
      "aliases": [],
      "searchAliases": [
        "Twenty-One Aces"
      ],
      "family": "Dice/Medium-High",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "주사위로 21에 가까운 합을 만든다",
        "action": "ace 변형 규칙 효과를 선택한다",
        "end": "넘지 않은 최고 합이 승리한다."
      },
      "sourceObservationIds": [
        "wt-096"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "chance_reveal",
        "mode": "digital",
        "goal": "무작위 신호를 펼치고 해당 안전 규칙을 수행한다.",
        "fun": "무엇이 나올지 모르는 공개 순간",
        "firstAction": "카드·주사위·룰렛 펼치기를 누른다.",
        "reward": "공개 결과와 완료 점수",
        "durationSec": 40,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Twenty-One Aces",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Twenty-One Aces는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 무엇이 나올지 모르는 공개 순간을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "주사위로 21에 가까운 합을 만든다",
          "앱이 카드·주사위·룰렛을 대신하고 각 숫자의 안전한 행동을 화면에 표시합니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 주사위로 21에 가까운 합을 만든다",
            "hostCue": "‘준비: 주사위로 21에 가까운 합을 만든다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 무작위 신호를 펼치고 해당 안전 규칙을 수행한다. 라운드의 끝은 ‘넘지 않은 최고 합이 승리한다.’입니다.",
            "hostCue": "‘성공 조건: 넘지 않은 최고 합이 승리한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
            "hostCue": "‘연습만 한 번: 카드·주사위·룰렛 펼치기를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "ace 변형 규칙 효과를 선택한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: ace 변형 규칙 효과를 선택한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "넘지 않은 최고 합이 승리한다. 앱은 공개 결과와 완료 점수를 보여 줍니다.",
            "hostCue": "‘끝: 넘지 않은 최고 합이 승리한다.’"
          }
        ],
        "example": {
          "title": "Twenty-One Aces 한 차례 예시",
          "lines": [
            "실제 행동: ace 변형 규칙 효과를 선택한다",
            "카드 펼치기 탭",
            "화면 결과: 3",
            "3번 안전 행동을 함께 수행"
          ]
        },
        "rounds": [
          {
            "title": "Twenty-One Aces · 1라운드",
            "prompt": "1번 안전 행동: 팀 구호를 5초 안에 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Twenty-One Aces · 2라운드",
            "prompt": "2번 안전 행동: 한 단어씩 이어 문장 만들기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Twenty-One Aces · 3라운드",
            "prompt": "3번 안전 행동: 모두 동시에 같은 포즈 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Twenty-One Aces · 4라운드",
            "prompt": "4번 안전 행동: 다음 주제를 한 명이 고르기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Twenty-One Aces · 5라운드",
            "prompt": "5번 안전 행동: 5초 박수 리듬 따라 하기",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          },
          {
            "title": "Twenty-One Aces · 6라운드",
            "prompt": "6번 안전 행동: 아무 불이익 없이 패스 또는 완료 선택",
            "options": [
              "완료",
              "패스"
            ],
            "reveal": "술 섭취 대신 완료 점수만 기록합니다."
          }
        ],
        "practice": {
          "instruction": "연습 카드를 한 번 펼치고 나온 번호를 소리 내어 확인하세요.",
          "actionLabel": "연습 카드 펼치기",
          "success": "무작위 결과를 확인하고 완료하는 방식을 익혔어요."
        },
        "winCondition": "넘지 않은 최고 합이 승리한다.",
        "tip": "화면 결과를 다시 뽑아 유리하게 바꾸지 않습니다. 수행하기 싫으면 점수 차감 없이 패스합니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "reveal",
          "labels": [
            "뒤집기",
            "결과",
            "안전 행동",
            "완료"
          ]
        }
      }
    },
    {
      "canonicalId": "two-truths-one-lie",
      "displayName": "Two Truths and a Lie",
      "aliases": [],
      "searchAliases": [
        "Two Truths and a Lie"
      ],
      "family": "대화추리",
      "playersMin": 3,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "각자 안전한 사실 2개와 허구 1개를 낸다",
        "action": "나머지가 거짓을 고른다",
        "end": "맞힌 사람과 속인 사람이 점수를 얻는다."
      },
      "sourceObservationIds": [
        "bdg-099"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "deduction",
        "mode": "hosted",
        "goal": "단서와 토론으로 숨은 답이나 역할을 찾아낸다.",
        "fun": "의심이 뒤집히는 토론과 최종 지목",
        "firstAction": "진행자가 비밀 역할 또는 답을 정한다.",
        "reward": "추리 성공과 토론 기록",
        "durationSec": 90,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Two Truths and a Lie",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Two Truths and a Lie는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 의심이 뒤집히는 토론과 최종 지목을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다.",
        "setupChecklist": [
          "3명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "각자 안전한 사실 2개와 허구 1개를 낸다",
          "앱이 비밀 정답·토론 시간·최종 지목 수를 관리합니다. 역할 카드나 메모가 없어도 됩니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "3명 이상이 모여 각자 안전한 사실 2개와 허구 1개를 낸다",
            "hostCue": "‘준비: 각자 안전한 사실 2개와 허구 1개를 낸다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 단서와 토론으로 숨은 답이나 역할을 찾아낸다. 라운드의 끝은 ‘맞힌 사람과 속인 사람이 점수를 얻는다.’입니다.",
            "hostCue": "‘성공 조건: 맞힌 사람과 속인 사람이 점수를 얻는다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
            "hostCue": "‘연습만 한 번: 진행자가 비밀 역할 또는 답을 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "나머지가 거짓을 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 나머지가 거짓을 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "맞힌 사람과 속인 사람이 점수를 얻는다. 앱은 추리 성공과 토론 기록을 보여 줍니다.",
            "hostCue": "‘끝: 맞힌 사람과 속인 사람이 점수를 얻는다.’"
          }
        ],
        "example": {
          "title": "Two Truths and a Lie 한 차례 예시",
          "lines": [
            "실제 행동: 나머지가 거짓을 고른다",
            "비밀 답: 바다(연습에서는 모두 확인)",
            "1번 단서: 파랗다",
            "2번 단서: 넓다"
          ]
        },
        "rounds": [
          {
            "title": "Two Truths and a Lie · 1라운드",
            "prompt": "비밀 답: 우산",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Two Truths and a Lie · 2라운드",
            "prompt": "비밀 답: 자전거",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Two Truths and a Lie · 3라운드",
            "prompt": "비밀 답: 고양이",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Two Truths and a Lie · 4라운드",
            "prompt": "비밀 답: 캠핑",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Two Truths and a Lie · 5라운드",
            "prompt": "비밀 답: 로봇",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          },
          {
            "title": "Two Truths and a Lie · 6라운드",
            "prompt": "비밀 답: 바다",
            "options": [
              "단서 말하기",
              "최종 지목"
            ],
            "reveal": "답을 직접 말하지 않은 단서를 모아 한 번에 지목합니다."
          }
        ],
        "practice": {
          "instruction": "공개 연습 답 하나를 정하고, 답을 직접 말하지 않는 단서 한 개를 말해 보세요.",
          "actionLabel": "연습 단서 제출",
          "success": "정답을 숨긴 채 단서를 주는 방식을 익혔어요."
        },
        "winCondition": "맞힌 사람과 속인 사람이 점수를 얻는다.",
        "tip": "비밀 화면은 해당 사람만 보고 바로 덮습니다. 실수로 봤다면 역할을 다시 뽑습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "clue_board",
          "labels": [
            "비밀",
            "단서",
            "토론",
            "지목"
          ]
        }
      }
    },
    {
      "canonicalId": "up-down-river-cards",
      "displayName": "Up and Down the River",
      "aliases": [],
      "searchAliases": [
        "Up and Down the River"
      ],
      "family": "Card/Very high",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "카드를 단계별로 공개해 자기 카드와 매치한다",
        "action": "올라갈 때 획득, 내려갈 때 반환 토큰을 계산한다",
        "end": "순점수로 끝낸다."
      },
      "sourceObservationIds": [
        "wt-098"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Up and Down the River",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Up and Down the River는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "카드를 단계별로 공개해 자기 카드와 매치한다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 카드를 단계별로 공개해 자기 카드와 매치한다",
            "hostCue": "‘준비: 카드를 단계별로 공개해 자기 카드와 매치한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘순점수로 끝낸다.’입니다.",
            "hostCue": "‘성공 조건: 순점수로 끝낸다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "올라갈 때 획득, 내려갈 때 반환 토큰을 계산한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 올라갈 때 획득, 내려갈 때 반환 토큰을 계산한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "순점수로 끝낸다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 순점수로 끝낸다.’"
          }
        ],
        "example": {
          "title": "Up and Down the River 한 차례 예시",
          "lines": [
            "실제 행동: 올라갈 때 획득, 내려갈 때 반환 토큰을 계산한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Up and Down the River · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Up and Down the River · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Up and Down the River · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Up and Down the River · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Up and Down the River · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Up and Down the River · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "순점수로 끝낸다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "viking-gesture",
      "displayName": "Viking",
      "aliases": [],
      "searchAliases": [
        "Viking"
      ],
      "family": "Hands/Low",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "역할별 머리/노 젓기 동작을 정한다",
        "action": "호출된 사람이 다음 역할을 보낸다",
        "end": "늦지 않은 연속 기록."
      },
      "sourceObservationIds": [
        "wt-099"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Viking",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Viking는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "역할별 머리/노 젓기 동작을 정한다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 역할별 머리/노 젓기 동작을 정한다",
            "hostCue": "‘준비: 역할별 머리/노 젓기 동작을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘늦지 않은 연속 기록.’입니다.",
            "hostCue": "‘성공 조건: 늦지 않은 연속 기록.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "호출된 사람이 다음 역할을 보낸다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 호출된 사람이 다음 역할을 보낸다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "늦지 않은 연속 기록. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 늦지 않은 연속 기록.’"
          }
        ],
        "example": {
          "title": "Viking 한 차례 예시",
          "lines": [
            "실제 행동: 호출된 사람이 다음 역할을 보낸다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Viking · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Viking · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Viking · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Viking · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Viking · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Viking · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "늦지 않은 연속 기록.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "whale-tales",
      "displayName": "Whales Tales",
      "aliases": [],
      "searchAliases": [
        "Whales Tales"
      ],
      "family": "Vocal/High",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "해양 단어와 동작을 정한다",
        "action": "이야기 속 키워드마다 맞는 동작을 한다",
        "end": "팀 정확도를 기록한다."
      },
      "sourceObservationIds": [
        "wt-101"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "word_race",
        "mode": "hosted",
        "goal": "제한 시간 안에 규칙에 맞는 말을 이어 간다.",
        "fun": "속도와 어휘가 맞부딪히는 연쇄 성공",
        "firstAction": "첫 주제나 단어를 정하고 타이머를 누른다.",
        "reward": "완주한 연속 기록과 팀 점수",
        "durationSec": 45,
        "energy": "wild",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Whales Tales",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Whales Tales는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 속도와 어휘가 맞부딪히는 연쇄 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "해양 단어와 동작을 정한다",
          "앱이 주제·차례·타이머·연속 기록을 맡습니다. 종이나 다른 타이머는 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 해양 단어와 동작을 정한다",
            "hostCue": "‘준비: 해양 단어와 동작을 정한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 제한 시간 안에 규칙에 맞는 말을 이어 간다. 라운드의 끝은 ‘팀 정확도를 기록한다.’입니다.",
            "hostCue": "‘성공 조건: 팀 정확도를 기록한다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
            "hostCue": "‘연습만 한 번: 첫 주제나 단어를 정하고 타이머를 누른다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "이야기 속 키워드마다 맞는 동작을 한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 이야기 속 키워드마다 맞는 동작을 한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "팀 정확도를 기록한다. 앱은 완주한 연속 기록과 팀 점수를 보여 줍니다.",
            "hostCue": "‘끝: 팀 정확도를 기록한다.’"
          }
        ],
        "example": {
          "title": "Whales Tales 한 차례 예시",
          "lines": [
            "실제 행동: 이야기 속 키워드마다 맞는 동작을 한다",
            "화면: 연습 주제 ‘과일’",
            "1번: 사과 → 성공 버튼",
            "2번: 포도 → 성공 버튼"
          ]
        },
        "rounds": [
          {
            "title": "Whales Tales · 1라운드",
            "prompt": "주제: 과일 이름",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Whales Tales · 2라운드",
            "prompt": "주제: 가방 속 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Whales Tales · 3라운드",
            "prompt": "주제: 비 오는 날 갈 곳",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Whales Tales · 4라운드",
            "prompt": "주제: 주말에 하는 일",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Whales Tales · 5라운드",
            "prompt": "주제: 파란 물건",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          },
          {
            "title": "Whales Tales · 6라운드",
            "prompt": "주제: 게임 장르",
            "options": [
              "성공 +1",
              "연쇄 다시"
            ],
            "reveal": "같은 말 없이 이어 간 횟수가 기록됩니다."
          }
        ],
        "practice": {
          "instruction": "화면의 연습 주제를 보고 한 사람씩 예시 단어를 말한 뒤 성공 버튼을 누르세요.",
          "actionLabel": "연습 단어 성공",
          "success": "말한 단어가 연쇄에 1회 기록됐어요."
        },
        "winCondition": "팀 정확도를 기록한다.",
        "tip": "판정이 갈리면 다수결로 5초 안에 정하고, 애매한 단어는 인정한 뒤 다음 차례로 갑니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "chain",
          "labels": [
            "주제",
            "1번",
            "2번",
            "연쇄"
          ]
        }
      }
    },
    {
      "canonicalId": "what-are-the-odds-safe",
      "displayName": "What Are the Odds?",
      "aliases": [],
      "searchAliases": [
        "What Are the Odds?"
      ],
      "family": "합의/숫자",
      "playersMin": 2,
      "props": [],
      "playability": "adapted_safe",
      "rules": {
        "setup": "수행 가능한 안전 미션과 2~10 범위를 합의한다",
        "action": "동시에 숫자를 말한다",
        "end": "일치하면 수행/패스, 불일치는 종료다."
      },
      "sourceObservationIds": [
        "bdg-100"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "What Are the Odds?",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "What Are the Odds?는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "수행 가능한 안전 미션과 2~10 범위를 합의한다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 수행 가능한 안전 미션과 2~10 범위를 합의한다",
            "hostCue": "‘준비: 수행 가능한 안전 미션과 2~10 범위를 합의한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘일치하면 수행/패스, 불일치는 종료다.’입니다.",
            "hostCue": "‘성공 조건: 일치하면 수행/패스, 불일치는 종료다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동시에 숫자를 말한다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동시에 숫자를 말한다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "일치하면 수행/패스, 불일치는 종료다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 일치하면 수행/패스, 불일치는 종료다.’"
          }
        ],
        "example": {
          "title": "What Are the Odds? 한 차례 예시",
          "lines": [
            "실제 행동: 동시에 숫자를 말한다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "What Are the Odds? · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "What Are the Odds? · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "What Are the Odds? · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "What Are the Odds? · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "What Are the Odds? · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "What Are the Odds? · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "일치하면 수행/패스, 불일치는 종료다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "container-tower",
      "displayName": "Wizard Staff",
      "aliases": [],
      "searchAliases": [
        "Wizard Staff"
      ],
      "family": "만들기",
      "playersMin": 2,
      "props": [
        "빈 용기",
        "테이프"
      ],
      "playability": "adapted_safe",
      "rules": {
        "setup": "깨끗한 빈 용기만 준비한다",
        "action": "제한 시간 동안 자립 탑을 만든다",
        "end": "높이보다 안정성/창의 점수를 합친다."
      },
      "sourceObservationIds": [
        "bdg-072"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "hosted_round",
        "mode": "hosted",
        "goal": "화면의 안전 규칙대로 한 라운드를 완주한다.",
        "fun": "익숙하지 않은 규칙을 함께 익혀 성공",
        "firstAction": "규칙을 소리 내어 읽고 첫 차례를 정한다.",
        "reward": "완주 여부와 다음 추천",
        "durationSec": 60,
        "energy": "calm",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "adapted_safe_core",
        "publicTitle": "Wizard Staff",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Wizard Staff는 화면의 안전 규칙대로 한 라운드를 완주한다. 익숙하지 않은 규칙을 함께 익혀 성공을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "깨끗한 빈 용기만 준비한다",
          "앱이 현재 차례·실행 문장·타이머·완주 기록을 모두 보여 줍니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 깨끗한 빈 용기만 준비한다",
            "hostCue": "‘준비: 깨끗한 빈 용기만 준비한다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 화면의 안전 규칙대로 한 라운드를 완주한다. 라운드의 끝은 ‘높이보다 안정성/창의 점수를 합친다.’입니다.",
            "hostCue": "‘성공 조건: 높이보다 안정성/창의 점수를 합친다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
            "hostCue": "‘연습만 한 번: 규칙을 소리 내어 읽고 첫 차례를 정한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "제한 시간 동안 자립 탑을 만든다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 제한 시간 동안 자립 탑을 만든다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "높이보다 안정성/창의 점수를 합친다. 앱은 완주 여부와 다음 추천을 보여 줍니다.",
            "hostCue": "‘끝: 높이보다 안정성/창의 점수를 합친다.’"
          }
        ],
        "example": {
          "title": "Wizard Staff 한 차례 예시",
          "lines": [
            "실제 행동: 제한 시간 동안 자립 탑을 만든다",
            "화면이 1번 차례와 행동을 표시",
            "1번이 행동을 수행",
            "차례 완료를 눌러 2번에게 넘김"
          ]
        },
        "rounds": [
          {
            "title": "Wizard Staff · 1라운드",
            "prompt": "현재 차례 행동: 한 단어로 오늘 분위기 말하기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Wizard Staff · 2라운드",
            "prompt": "현재 차례 행동: 오른쪽 사람에게 주제 넘기기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Wizard Staff · 3라운드",
            "prompt": "현재 차례 행동: 5초 박수 리듬 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Wizard Staff · 4라운드",
            "prompt": "현재 차례 행동: 모두 같은 손 모양 만들기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Wizard Staff · 5라운드",
            "prompt": "현재 차례 행동: 다음 차례가 규칙 한 줄 읽기",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          },
          {
            "title": "Wizard Staff · 6라운드",
            "prompt": "현재 차례 행동: 전원 한 차례 완주 확인",
            "options": [
              "차례 완료",
              "패스"
            ],
            "reveal": "모두 한 차례씩 마치면 라운드가 끝납니다."
          }
        ],
        "practice": {
          "instruction": "첫 사람만 화면의 연습 행동을 수행하고 차례 완료를 눌러 보세요.",
          "actionLabel": "차례 연습",
          "success": "한 차례를 읽고 실행해 넘기는 방식을 익혔어요."
        },
        "winCondition": "높이보다 안정성/창의 점수를 합친다.",
        "tip": "설명이 헷갈리면 현재 화면 문장만 실행합니다. 합의되지 않은 추가 규칙은 넣지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "turn_loop",
          "labels": [
            "설명",
            "연습",
            "차례",
            "완주"
          ]
        }
      }
    },
    {
      "canonicalId": "would-you-rather",
      "displayName": "Would You Rather",
      "aliases": [],
      "searchAliases": [
        "Would You Rather"
      ],
      "family": "양자선택",
      "playersMin": 2,
      "props": [],
      "playability": "playable_safe",
      "rules": {
        "setup": "두 선택지를 읽는다",
        "action": "동시에 고른다",
        "end": "소수/다수 이유를 한 문장씩 듣고 다음으로 간다."
      },
      "sourceObservationIds": [
        "bdg-030"
      ],
      "safeOutcomes": [
        "team_point",
        "conversation",
        "rest",
        "pass"
      ],
      "replacementCanonicalId": null,
      "gameplay": {
        "mechanic": "social_vote",
        "mode": "digital",
        "goal": "각자 선택한 뒤 모두의 선택 분포를 공개한다.",
        "fun": "친구들의 예상 밖 선택을 동시에 확인",
        "firstAction": "질문을 읽고 자신의 선택에 한 표를 더한다.",
        "reward": "공개된 표와 대화 주제",
        "durationSec": 45,
        "energy": "lively",
        "novelty": "hidden_find",
        "sourceRegions": [
          "global_english"
        ]
      },
      "accessibility": {
        "participation": [
          "non_alcoholic",
          "pass_without_penalty",
          "no_required_contact"
        ],
        "format": "screen_guided"
      },
      "rights": {
        "treatment": "safe_core_paraphrase",
        "publicTitle": "Would You Rather",
        "sourceNameVisibility": "search_only",
        "runtimeMaterial": "own_or_permitted_only"
      },
      "beginnerGuide": {
        "summary": "Would You Rather는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 친구들의 예상 밖 선택을 동시에 확인을 즐기는 게임입니다.",
        "appOnly": true,
        "appOnlyMode": "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다.",
        "setupChecklist": [
          "2명 이상이 한 화면을 함께 볼 수 있게 모입니다.",
          "두 선택지를 읽는다",
          "앱이 질문 진행과 익명에 가까운 합산 표를 맡습니다. 별도 투표용지가 필요 없습니다."
        ],
        "steps": [
          {
            "id": "gather",
            "title": "화면을 같이 봐요",
            "instruction": "2명 이상이 모여 두 선택지를 읽는다",
            "hostCue": "‘준비: 두 선택지를 읽는다’"
          },
          {
            "id": "learn",
            "title": "이기는 방법을 알아요",
            "instruction": "목표는 각자 선택한 뒤 모두의 선택 분포를 공개한다. 라운드의 끝은 ‘소수/다수 이유를 한 문장씩 듣고 다음으로 간다.’입니다.",
            "hostCue": "‘성공 조건: 소수/다수 이유를 한 문장씩 듣고 다음으로 간다.’"
          },
          {
            "id": "practice",
            "title": "핵심 행동을 한 번 해요",
            "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
            "hostCue": "‘연습만 한 번: 질문을 읽고 자신의 선택에 한 표를 더한다.’"
          },
          {
            "id": "play",
            "title": "실전 차례를 진행해요",
            "instruction": "동시에 고른다 화면의 현재 차례를 확인하고 한 번씩 실행합니다.",
            "hostCue": "‘지금 할 일: 동시에 고른다’"
          },
          {
            "id": "finish",
            "title": "앱에 결과를 남겨요",
            "instruction": "소수/다수 이유를 한 문장씩 듣고 다음으로 간다. 앱은 공개된 표와 대화 주제를 보여 줍니다.",
            "hostCue": "‘끝: 소수/다수 이유를 한 문장씩 듣고 다음으로 간다.’"
          }
        ],
        "example": {
          "title": "Would You Rather 한 차례 예시",
          "lines": [
            "실제 행동: 동시에 고른다",
            "화면: ‘계획형 / 즉흥형’",
            "각자 자기 선택에 한 표씩 입력",
            "4명 입력 뒤 1:3으로 공개"
          ]
        },
        "rounds": [
          {
            "title": "Would You Rather · 1라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "산",
              "바다"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Would You Rather · 2라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "아침",
              "밤"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Would You Rather · 3라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "계획",
              "즉흥"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Would You Rather · 4라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "단맛",
              "짠맛"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Would You Rather · 5라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "실내",
              "야외"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          },
          {
            "title": "Would You Rather · 6라운드",
            "prompt": "둘 중 지금 더 끌리는 쪽은?",
            "options": [
              "빠르게",
              "천천히"
            ],
            "reveal": "모두 입력한 뒤 표 분포를 공개합니다. 이유 설명은 선택입니다."
          }
        ],
        "practice": {
          "instruction": "연습 질문을 읽고 왼쪽 또는 오른쪽에 각자 한 표씩 더한 뒤 공개하세요.",
          "actionLabel": "연습 투표",
          "success": "표 분포를 공개하는 순서를 익혔어요."
        },
        "winCondition": "소수/다수 이유를 한 문장씩 듣고 다음으로 간다.",
        "tip": "표가 적어 누가 골랐는지 보여도 설명은 선택입니다. 지목하거나 해명을 요구하지 않습니다.",
        "recovery": "순서가 헷갈리면 현재 차례와 ‘지금 할 일’ 문장으로 돌아갑니다. 누구도 벌주지 않고 그 차례만 다시 합니다.",
        "diagram": {
          "kind": "vote",
          "labels": [
            "질문",
            "왼쪽",
            "오른쪽",
            "분포"
          ]
        }
      }
    }
  ],
  "restCards": [
    {
      "id": "rest-001",
      "copy": "물이나 무알코올 음료를 한 번 권해볼까요? 마시지 않아도 완료예요.",
      "completion": "10초 후 완료/패스"
    },
    {
      "id": "rest-002",
      "copy": "안주가 필요한 사람 있는지 손으로 표시해요.",
      "completion": "전원 응답/패스"
    },
    {
      "id": "rest-003",
      "copy": "운전하는 사람은 지금도 끝까지 0잔이어야 해요.",
      "completion": "확인 탭"
    },
    {
      "id": "rest-004",
      "copy": "누구든 이유 없이 다음 라운드를 건너뛸 수 있어요.",
      "completion": "확인 탭"
    },
    {
      "id": "rest-005",
      "copy": "30초만 화면을 내려놓고 서로 상태를 봐요.",
      "completion": "30초/패스"
    },
    {
      "id": "rest-006",
      "copy": "속이 불편한 사람이 있으면 게임을 멈추고 쉬어요.",
      "completion": "확인 탭"
    },
    {
      "id": "rest-007",
      "copy": "물컵·빈 컵·게임 도구를 한 번 정리해요.",
      "completion": "호스트 완료"
    },
    {
      "id": "rest-008",
      "copy": "오늘의 최고 장면을 한 단어로 말해요.",
      "completion": "2명 응답/패스"
    },
    {
      "id": "rest-009",
      "copy": "조용한 게임으로 바꿀까요?",
      "completion": "유지/바꾸기"
    },
    {
      "id": "rest-010",
      "copy": "앉아서 할 수 있는 게임만 이어갈까요?",
      "completion": "유지/필터 적용"
    },
    {
      "id": "rest-011",
      "copy": "접촉 없는 게임만 이어갈까요?",
      "completion": "유지/필터 적용"
    },
    {
      "id": "rest-012",
      "copy": "준비물 없는 게임만 이어갈까요?",
      "completion": "유지/필터 적용"
    },
    {
      "id": "rest-013",
      "copy": "지금 끝내도 리캡은 그대로 남아요.",
      "completion": "종료/계속"
    },
    {
      "id": "rest-014",
      "copy": "한 명씩 패스 버튼 위치를 확인해요.",
      "completion": "전원 확인/패스"
    },
    {
      "id": "rest-015",
      "copy": "다음 게임은 지금까지 적게 고른 사람이 골라요.",
      "completion": "선택권 이전"
    },
    {
      "id": "rest-016",
      "copy": "팀을 한 번 섞어 새 조합으로 놀까요?",
      "completion": "유지/섞기"
    },
    {
      "id": "rest-017",
      "copy": "볼륨이 괜찮은지 확인해요.",
      "completion": "작게/그대로/끄기"
    },
    {
      "id": "rest-018",
      "copy": "움직일 공간에 깨질 물건이 없는지 봐요.",
      "completion": "확인/앉은 게임 필터"
    },
    {
      "id": "rest-019",
      "copy": "사진과 영상은 동의 없이 남기지 않아요.",
      "completion": "확인 탭"
    },
    {
      "id": "rest-020",
      "copy": "외부 사람에게 메시지를 보내는 미션은 없어요.",
      "completion": "확인 탭"
    },
    {
      "id": "rest-021",
      "copy": "지금까지 안 한 게임만 다시 추천할게요.",
      "completion": "추천 갱신"
    },
    {
      "id": "rest-022",
      "copy": "말하기가 부담되면 탭으로 답하는 게임을 골라요.",
      "completion": "필터 적용/유지"
    },
    {
      "id": "rest-023",
      "copy": "설명이 길었다면 10초 게임으로 바꿔요.",
      "completion": "초단기 필터/유지"
    },
    {
      "id": "rest-024",
      "copy": "모두 괜찮나요? 한 명이라도 쉬기를 누르면 같이 쉽니다.",
      "completion": "전원 익명 응답"
    }
  ],
  "promptPacks": [
    {
      "id": "prompt-food",
      "seeds": [
        "김밥",
        "라면",
        "여름 과일",
        "편의점 간식",
        "국물 요리",
        "빵",
        "길거리 음식",
        "배달 메뉴"
      ]
    },
    {
      "id": "prompt-place",
      "seeds": [
        "지하철역",
        "여행지",
        "공원",
        "바다",
        "산",
        "학교 근처",
        "동네 가게",
        "비 오는 날 갈 곳"
      ]
    },
    {
      "id": "prompt-object",
      "seeds": [
        "가방 속 물건",
        "둥근 물건",
        "파란 물건",
        "소리 나는 물건",
        "선물하기 좋은 것",
        "책상 위 물건",
        "주방 도구",
        "휴대 가능한 것"
      ]
    },
    {
      "id": "prompt-action",
      "seeds": [
        "아침에 하는 일",
        "주말에 하는 일",
        "기다릴 때 하는 일",
        "긴장 풀기",
        "팀으로 하는 일",
        "조용히 하는 일",
        "한 손으로 하는 일",
        "10초 안에 하는 일"
      ]
    },
    {
      "id": "prompt-media",
      "seeds": [
        "영화 장르",
        "드라마 직업",
        "예능 장면",
        "게임 장르",
        "노래 분위기",
        "책 장르",
        "주인공 특징",
        "반전 단서"
      ]
    },
    {
      "id": "prompt-memory",
      "seeds": [
        "첫 여행",
        "웃긴 실수",
        "고마웠던 일",
        "최근 배운 것",
        "다시 가고 싶은 곳",
        "좋아했던 놀이",
        "기억나는 냄새",
        "오래 쓴 물건"
      ]
    },
    {
      "id": "prompt-choice",
      "seeds": [
        "산/바다",
        "아침/밤",
        "계획/즉흥",
        "단맛/짠맛",
        "문자/통화",
        "실내/야외",
        "혼자/함께",
        "빠르게/천천히"
      ]
    },
    {
      "id": "prompt-sound",
      "seeds": [
        "종소리",
        "빗소리",
        "문 여는 소리",
        "박수",
        "동물 소리",
        "교통수단",
        "주방 소리",
        "전자기기 알림"
      ]
    },
    {
      "id": "prompt-drawing",
      "seeds": [
        "우산",
        "자전거",
        "고양이",
        "성",
        "로봇",
        "캠핑",
        "생일",
        "우주"
      ]
    },
    {
      "id": "prompt-charades",
      "seeds": [
        "양치하기",
        "버스 놓치기",
        "사진 찍기",
        "요리하기",
        "길 찾기",
        "운동하기",
        "선물 열기",
        "잠에서 깨기"
      ]
    },
    {
      "id": "prompt-safe-truth",
      "seeds": [
        "요즘 자주 듣는 노래",
        "좋아하는 간식",
        "다시 보고 싶은 작품",
        "편한 날씨",
        "잘하는 사소한 일",
        "가보고 싶은 곳",
        "최근 웃은 일",
        "쉬는 방법"
      ]
    },
    {
      "id": "prompt-safe-dare",
      "seeds": [
        "5초 박수 리듬",
        "동물 표정",
        "반대손으로 원 그리기",
        "영화 포스터 포즈",
        "팀 구호 만들기",
        "한 단어 칭찬",
        "3초 무음 연기",
        "다음 주제 고르기"
      ]
    }
  ]
}
